/* ============================================================
 * AI 3D Customizer — vanilla JS
 * 流程：风格锁定 → 上传 → 2D → 3D → 选配加购（单向）
 * ============================================================ */
(function () {
  'use strict';

  // 浏览器持久匿名身份：与网络无关，换 Wi-Fi / 切 VPN / 重启路由都不会丢失会话与积分。
  // 沿用旧 localStorage 键名，已存在的随机 ID 继续生效。
  var STORAGE_ANON_ID = 'ai3d_customer_hash';
  var STORAGE_STATE_PREFIX = 'ai3d_state_v1_';
  // 用户上传图的 R2 key 形态（Worker /f/ 公开只读路由只放行该前缀）
  var USER_UPLOAD_KEY_RE = /^[A-Z0-9]{2}\/user-upload\/.+\.(png|jpe?g|webp|gif)$/i;
  var POLL_2D_MS = 2500, POLL_3D_MS = 4000;
  // 2D 长尾实测可达 600s+（apimart 高峰期），客户端等待窗口留 15 分钟；
  // 超时后任务号持久化，重开定制器/重新点击都会自动续轮，不丢任务
  var TIMEOUT_2D_MS = 15 * 60 * 1000, TIMEOUT_3D_MS = 10 * 60 * 1000;
  // 2D 生成中「Check status」按钮的最早出现时间：正常 20–60 秒出图，超过 100 秒才给手动入口
  var GEN2D_STATUS_BTN_DELAY = 100 * 1000;

  /* ---------------- i18n ---------------- */
  // 内置英文兜底（与 Worker src/lib/ui-strings.ts 的 DEFAULT_UI 同名同值）。
  // 当前语种译文由 /api/config/public 的 ui 下发；缺失的 key 回退到这里，保证永不空白。
  // 含 {name}/{n} 占位符的文案由 t() 替换后再渲染（做 HTML 渲染的调用方自行传安全值）。
  var FALLBACK_UI = {
    'step.1.short': 'Photo',
    'step.2.short': 'AI Portrait',
    'step.3.short': '3D Model',
    'step.4.short': 'Options',
    'step.1.long': 'Upload Photo',
    'step.2.long': '2D Preview',
    'step.3.long': '3D Model',
    'step.4.long': 'Add to Cart',
    'progress.step': 'Step {n} of 4 · {name}',
    'progress.step_of3': 'Step {n} of 3 · {name}',
    'progress.saved': 'Your customization is saved — {step}. Continue anytime.',
    'btn.start': 'Start Customize',
    'btn.starting': 'Starting…',
    'btn.next': 'Next',
    'btn.generate': 'Generate',
    'btn.generate_2d': 'Generate 2D Portrait',
    'btn.use_portrait': 'Use this portrait',
    'btn.generate_3d': 'Generate 3D Model',
    'btn.choose_options': 'Choose options',
    'btn.add_to_cart': 'Add to Cart',
    'btn.preview_3d': 'Preview 3D',
    'btn.add_photo': 'Add photo',
    // 弹窗四步右下角统一的「NEXT: 去向」按钮文案（新 key，Worker 后台未配置时回退此处内置英文）
    'btn.next_ai_portrait': 'Next: AI Portrait',
    'btn.next_3d_model': 'Next: 3D Model',
    'btn.next_options': 'Next: Options',
    'credits.unit': 'Your credits',
    'credits.cost_both': '2D costs {2d} · 3D costs {3d}',
    'credits.cost_2d_only': '2D costs {2d}',
    'credits.cost_free_2d': '2D portraits are free · 3D costs {3d}',
    'credits.free': 'Free',
    'credits.cost_2d': 'Costs {n} credits · Balance {balance}',
    'credits.cost_3d': 'Costs {n} credits · Balance {balance}',
    // 保留 3D 积分提示（step 2：再刷一次 2D 就不够 3D 了／step 3：已经不够 3D）
    'credits.keep_3d': 'Keep {n} credits for the 3D model, or you won\'t be able to finish it. Generating another 2D portrait costs {c} credits.',
    'credits.need_3d': 'You need {n} credits to generate the 3D model.',
    'credits.how_prefix': 'Get more credits: ',
    'credits.how_register': 'sign in or create an account (+{n})',
    'credits.how_login': 'daily login bonus (+{n})',
    'credits.how_order': 'credits are topped up automatically after your order',
    'credits.get': 'Get credits',
    'credits.refresh': 'Refresh',
    'credits.out_title': 'You have run out of credits',
    'credits.out_text': 'Each AI portrait costs {n} credits and your balance is {balance}. Pick a way to get more credits and continue:',
    'credits.opt_register': 'Sign in / create an account (+{n})',
    'credits.opt_login': 'Sign in for today\'s bonus (+{n})',
    'credits.opt_whatsapp': 'Top up on WhatsApp',
    'credits.opt_email': 'Email us to top up',
    'gen.regen_locked': 'This button is greyed out because you don\'t have enough credits — balance {balance}, each attempt costs {cost}. Get more credits:',
    'step1.title': 'Upload your photo',
    'step1.upload_main': 'Drag & drop or <span>browse</span>',
    'step1.upload_sub': 'JPG / PNG / WebP · up to 20MB · {slot}',
    'step1.uploading': 'Uploading… {pct}%',
    'step1.slot_single': '1 photo',
    'step1.slot_multi': 'up to 2 photos',
    'step1.secure_note': 'Your photo is stored securely and used only for your custom model.',
    'styles.hint': 'Switching style restarts this customization.',
    'styles.locked_hint': 'Style is fixed by this scene.',
    'styles.preview_hint': 'Your selected style. Change it on the product page before you start.',
    'figures.hint': 'Solo: 1 photo · Duo & Pet combos: up to 2 photos. Switching restarts this customization.',
    'scene.color_label': 'Clothing colors',
    'scene.color_optional': '(optional)',
    'scene.color_placeholder': 'e.g. navy sweater, beige scarf',
    'scene.engraving_label': 'Base engraving',
    'scene.engraving_optional': '(optional)',
    'scene.engraving_placeholder': 'Up to 40 characters, e.g. Best Boss 2026',
    'scene.message_label': 'Gift message',
    'scene.message_optional': '(optional)',
    'scene.message_placeholder': 'A short message for the recipient (printed card / order note)',
    'step2.title': 'Generate your AI portrait',
    'step2.desc': 'The AI will redraw your photo in the locked <strong>{style}</strong> style.',
    'step3.title': 'Generate your 3D model',
    'step3.desc': 'Transform your AI portrait into a production-ready 3D model.',
    'gen.locknote': "🔒 This step can't be repeated once finished.",
    // Step 2 右下角「最后一步预告」：随 3D 步骤开关切换文案
    'gen.step2_teaser_on': 'Up next: 3D model, then options & add to cart',
    'gen.step2_teaser_off': 'Up next: choose your options and add to cart',
    'gen.regen_note': 'Each new attempt costs credits again. Your earlier portraits stay below.',
    'gen.history_title': 'Your earlier portraits',
    'btn.regenerate': 'Not satisfied? Generate again',
    'gen.status_submitting': 'Submitting task…',
    'gen.status_queued': 'Queued…',
    'gen.status_drawing': 'Drawing your AI portrait…',
    // 网络中断后按会话反查任务状态期间的状态文案（不承诺失败，也不让用户干等）
    'gen.status_reconnecting': 'Connection dropped — looking up your task…',
    'gen.status_3d_queued': 'Queued… this usually takes 30–60 seconds',
    'gen.status_sculpting': 'Sculpting your 3D model…',
    'step4.title': 'Choose your options',
    'step4.sold_out': 'This combination is currently sold out.',
    'step4.select_all': 'Please select all options.',
    'step4.locked': 'Locked — chosen before customization',
    'history.title': 'Recent History',
    'history.subtitle': 'Everything you have generated in this store. Tap a portrait to enlarge it.',
    'history.delete_selected': 'Remove selected ({n})',
    'history.clear_all': 'Clear all',
    'history.select_all': 'Select all',
    'history.deselect_all': 'Deselect all',
    'history.confirm_delete': 'Remove {n} item(s) from this list? Your orders and files stay safe with us.',
    'history.confirm_clear': 'Clear this list? Your orders and files stay safe with us.',
    'step1.confirm_remove': 'Remove this photo? You can upload another one afterwards.',
    'tour.recent_pick': 'Tap a result to select it, then add it to your cart',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'history.badge_2d': 'Portrait',
    'history.badge_3d': '3D model',
    'history.err_load': 'Could not load your creations right now.',
    'history.err_hide': 'Could not update the list. Please try again.',
    'history.continue': 'Continue customizing',
    'history.restart': 'New',
    'history.empty_title': 'No creations yet',
    'history.empty_text': 'Upload a photo and start customizing — your AI portraits will appear here.',
    'card.title': 'Customization',
    'card.history': 'Recent history',
    'card.contact': 'Need to refine your preview or use a specific photo? Contact our team via',
    'card.email': 'Email',
    'card.or': 'or',
    'card.whatsapp': 'WhatsApp',
    'msg.not_enough_credits': 'Not enough credits — please contact support on <a href="https://wa.me/8615851426970" target="_blank" rel="noopener">WhatsApp</a> or top up.',
    'msg.refunded': 'Your credits were automatically refunded. You can try again.',
    // 提交阶段网络中断（Failed to fetch）：请求可能已送达并真的在生成，不能说「失败/已退款」
    'msg.check_status': 'Your connection dropped, but your task may still be running. Check its status before generating again.',
    // 反查确认服务端确实没有该会话的任务：提交没送达，未扣费，可放心重试
    'msg.not_submitted': 'The request did not reach our server, so no credits were used. Please try again.',
    // 从历史记录继续定制：会话锁定的 Figure 与页面当前选中不同，已按作品当初的模式切换
    'msg.figure_switched': 'This record was made as {from} — switched to {to} to match it.',
    'btn.try_again': 'Try again',
    'btn.check_status': 'Check status',
    'err.upload_failed': 'Upload failed: {msg}',
    'err.file_type': 'Only JPG / PNG / WebP images are supported.',
    'err.file_too_large': 'File is larger than 20MB.',
    // 槽位已满（拖拽上传 / 已满额再选图）必须给可见提示；此前 handleFiles 静默 return，表现为「选了图毫无反应」
    'err.photo_limit': 'You already have {n} photo(s) for this figure. Remove one first, or click an existing photo to replace it.',
    'err.duplicate_photos': 'The two photos look identical. Please upload two different photos (e.g. two people).',
    'err.drop_no_file': "Couldn't read the dropped item. Please drag an image file from your computer (dragging an image out of a web page isn't supported).",
    'err.gen_failed': 'Generation failed',
    // design-box（辅助设计）：先上传/生成效果图才能带稿加购
    'err.need_photo': 'Please upload your photo first.',
    'err.gen_first': 'Please generate your AI design first, then add to cart.',
    'err.add_to_cart_failed': 'Could not add to cart',
    'err.start_failed': 'Could not start customization: {msg}',
    'err.switch_failed': 'Could not switch {kind}: {msg}',
    'err.worker_missing': 'AI service is not configured yet. Please set the Cloudflare Worker URL in the theme customizer.',
    'err.request_failed': 'Request failed ({status})',
    'page_upload.label': 'Upload Your Photo',
    'page_upload.cta': 'Upload Photo',
    'page_upload.uploading': 'Uploading…',
    'page_upload.compare': 'Before / After',
    // design-box：卡片 + 无步骤设计弹窗（提示词 / 预设标签 / 生成数量）
    'design.title': 'Create your AI design',
    'design.sub': 'Describe the look you want. Add a quick tag to guide the AI.',
    'design.open': 'Create AI design',
    'design.open_again': 'Generate more designs',
    'design.hint': 'Upload your photo, then describe the design you want.',
    'design.hint_ready': 'Tap to describe your idea and generate AI designs.',
    'design.results': 'Your AI designs',
    // 卡片下方的「最近生成」横条
    'design.recent_title': 'Your recent designs',
    'design.recent_all': 'View all',
    'design.act_refine': 'Keep editing',
    'design.act_addcart': 'Add to cart',
    'design.act_remove': 'Delete',
    'design.confirm_remove': 'Remove this design? It will no longer appear in your designs.',
    'design.refine_ok': 'This design is now the reference. Describe your changes and generate again.',
    'design.refine_uploading': 'Using this design as the reference…',
    'design.remove_done': 'Design removed.',
    'design.photo_hint': 'The AI keeps the face and likeness from this photo.',
    'design.prompt_label': 'Describe your idea',
    'design.optional': '(optional)',
    'design.prompt_placeholder': 'e.g. Keep my face and hairstyle, change the outfit to a navy sweater, soft studio background',
    'design.tags_label': 'Quick tags',
    'design.qty_label': 'Number of designs',
    'design.qty_hint': 'Each design is generated separately.',
    'design.cost': '{qty} × {n} credits · Total {total} · Balance {balance}',
    'design.cost_free': 'Free · {qty} design(s)',
    'design.generate': 'Generate',
    'design.generate_n': 'Generate {n} designs',
    'design.running': 'Creating design {i} of {n}…',
    'design.done': '{n} design(s) ready. Pick your favorite below.',
    'design.select_hint': 'Tap a design to use it for your order.',
    'design.wait': 'Please wait until the current designs are finished.',
    'design.not_enough': 'Not enough credits for {n} designs — you need {total} credits.',
    // 定制卡片打字机轮播句（内置默认，逐句打字 → 停留 → 删除 → 下一句）
    'design.typer_1': 'Turn your photo into a handcrafted figurine',
    'design.typer_2': 'Upload a photo, describe your idea, preview it in seconds',
    'design.typer_3': 'Keep the face you love, change the style',
    'design.typer_4': 'A one-of-a-kind gift, made just for them',
    'design.stage_reference': 'Reference product',
    'design.stage_result': 'Your AI design',
    'design.teaser_count': '{n} designs ready',
    'compare.title': 'Your AI preview',
    'size.unavailable': "This size isn't available for the selected style. Please choose another size.",
    // 定制卡片内的生成状态 / 前后对比
    'status.generating_2d': 'Generating your AI portrait… {p}%',
    'status.generating_3d': 'Building your 3D model… {p}%',
    'status.before': 'Original',
    'status.after': 'AI Portrait'
  };
  var UI_MAP = {};

  /** 取当前语种文案并替换 {占位符}；缺 key 回退英文兜底；仍缺则回原 key */
  function t(key, vars) {
    var s = (UI_MAP && UI_MAP[key]) || FALLBACK_UI[key] || key;
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        s = s.split('{' + k + '}').join(vars[k]);
      });
    }
    return s;
  }

  /* ---------------- utils ---------------- */

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  // 匿名身份必须在一个页面生命周期内保持稳定：Edge 跟踪防护/无痕模式下 localStorage
  // 可能「读不到也写不进」，逐次生成新 UUID 会让「建会话」与「上传」使用不同身份，
  // Worker 归属校验必然 403（且自动重建会话也救不回来）。因此读一次后缓存到内存，
  // 写入失败也不影响当前页面的一致性；localStorage 完全不可用时退化为本页内存身份。
  var _anonIdCache = null;
  function getAnonId() {
    if (_anonIdCache) return _anonIdCache;
    var h = '';

    try { h = localStorage.getItem(STORAGE_ANON_ID) || ''; } catch (e) { h = ''; }
    if (!h) {
      try { h = sessionStorage.getItem(STORAGE_ANON_ID) || ''; } catch (e) { h = ''; }
    }
    if (!h) h = uuid();
    _anonIdCache = h;

    try { localStorage.setItem(STORAGE_ANON_ID, h); } catch (e) {}
    try { sessionStorage.setItem(STORAGE_ANON_ID, h); } catch (e) {}
    return h;
  }

  function $(scope, selector) { return scope.querySelector(selector); }
  function $all(scope, selector) { return Array.prototype.slice.call(scope.querySelectorAll(selector)); }

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Shopify money format（支持 ${{amount}} 等常见格式）
  function formatMoney(cents, format) {
    function withDelimiters(num, precision, thou, dec) {
      precision = precision == null ? 2 : precision;
      if (isNaN(num) || num == null) return '0';
      var fixed = (num / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thou || ','));
      return dollars + (parts[1] ? (dec || '.') + parts[1] : '');
    }
    // 店铺的 money_format 常写成 ${{amount_no_decimals}} 这类「非裸 {{amount}}」变体。
    // 不能用 indexOf('{{amount}}') 判断格式是否有效——那会把已带货币符号的格式误判成无效，
    // 结果货币符号被丢掉、小数位还被强制成 2 位（实测本店得到 25.00 而不是 $25）。
    function formatString(str) {
      if (!str) return '${{amount}}';
      return String(str).indexOf('{{amount') >= 0 ? String(str) : '${{amount}}';
    }
    var f = formatString(format || '${{amount}}');
    var value = cents;
    if (f.indexOf('amount_no_decimals_with_comma_separator') >= 0) {
      return f.replace('{{amount_no_decimals_with_comma_separator}}', withDelimiters(value, 0, '.', ','));
    } else if (f.indexOf('amount_no_decimals') >= 0) {
      return f.replace('{{amount_no_decimals}}', withDelimiters(value, 0, ',', '.'));
    } else if (f.indexOf('amount_with_comma_separator') >= 0) {
      return f.replace('{{amount_with_comma_separator}}', withDelimiters(value, 2, '.', ','));
    }
    return f.replace('{{amount}}', withDelimiters(value, 2, ',', '.'));
  }

  function buildPrompt(styleName, presetMap, suffix) {
    var key = String(styleName || '').trim();
    if (presetMap && presetMap[key]) return presetMap[key] + (suffix ? ' ' + suffix : '');
    var k = key.toLowerCase();
    var base;
    if (k.indexOf('realistic') >= 0 || k.indexOf('real') >= 0 || k.indexOf('写实') >= 0) {
      base = 'Create a hyper-realistic custom collectible figurine portrait of the person in the reference photo, preserving exact facial features, skin tone, hairstyle and true likeness, realistic painterly render, premium resin figure quality.';
    } else if (k.indexOf('chibi') >= 0 || k.indexOf('q版') >= 0 || k.indexOf('q ') >= 0) {
      base = 'Create a cute chibi bobblehead version of the person in the reference photo, oversized round head with big expressive sparkling eyes, tiny chibi body proportions, playful and adorable, soft pastel shading.';
    } else if (k.indexOf('funko') >= 0) {
      base = 'Create a Funko Pop style vinyl figure of the person in the reference photo, signature oversized square head, big round solid black eyes, tiny simplified stylized body, glossy plastic toy look.';
    } else if (k.indexOf('anime') >= 0 || k.indexOf('manga') >= 0 || k.indexOf('动漫') >= 0) {
      base = 'Create a Japanese anime style character portrait of the person in the reference photo, refined anime facial features, stylized glossy hair, clean cel shading, cute and elegant.';
    } else if (k.indexOf('cartoon') >= 0 || k.indexOf('卡通') >= 0) {
      base = 'Create a stylized 3D cartoon character version of the person in the reference photo, rounded friendly features, vibrant clean colors, high-end animated movie character appeal.';
    } else if (k.indexOf('clay') >= 0 || k.indexOf('3d') >= 0) {
      base = 'Create a claymation style 3D figurine of the person in the reference photo, soft clay material textures, handcrafted sculpted look, gentle studio lighting.';
    } else {
      base = 'Create a custom collectible bobblehead figurine portrait of the person in the reference photo, preserving strong likeness, facial features, expression and hairstyle, premium hand-painted resin figure quality.';
    }
    return base + (suffix ? ' ' + suffix : '');
  }

  function parsePrompts(raw) {
    if (!raw || raw === '{}') return null;
    if (typeof raw === 'object') return raw;
    try { var o = JSON.parse(raw); return o && typeof o === 'object' ? o : null; } catch (e) { return null; }
  }

  /* 预设提示词标签：每行一个，支持「标签|提示词」或直接写一整句提示词。
     标签只负责显示，点击后把对应提示词追加进本次生成。 */
  function parseTags(raw) {
    if (!raw) return [];
    return String(raw).split(/\r?\n/).map(function (line) {
      var s = String(line || '').trim();
      if (!s) return null;
      var i = s.indexOf('|');
      if (i >= 0) {
        var label = s.slice(0, i).trim();
        var prompt = s.slice(i + 1).trim();
        if (!prompt) return null;
        return { label: label || prompt, prompt: prompt };
      }
      return { label: s, prompt: s };
    }).filter(Boolean);
  }

  /* 多主体（双人/人宠）生成约束：告知模型参考图数量与构图，避免只画一个人或把两人融在一起 */
  /* 多主体构图约束。offset = 风格草图占用的参考图数量（草图排在最前，用户照片顺延编号） */
  function figureClause(kind, photoCount, offset) {
    offset = offset || 0;
    var sameStyle = ' Render all subjects in one consistent art style within a single image.';
    var nA = 'reference image ' + (1 + offset);
    var nB = 'reference image ' + (2 + offset);
    if (kind === 'double') {
      return photoCount >= 2
        ? ('Two separate photos of the subjects are provided, in the exact left-to-right order shown in the upload step: '
           + nA + ' is person A (LEFT) and ' + nB + ' is person B (RIGHT). ' +
           'Combine BOTH people into ONE paired figurine composition on a single shared base, preserving each person\u2019s ' +
           'distinct face, hairstyle and outfit from their OWN photo. Place person A on the LEFT side and person B on the RIGHT side, ' +
           'standing close together side by side. Keep this left/right order exactly as provided; do not swap the two people. ' +
           'Do not merge them into one person and do not duplicate anyone.' + sameStyle)
        : ('The subject photo (' + nA + ') shows TWO people together. Depict BOTH of them in ONE paired figurine composition on ' +
           'a single shared base, preserving each person\u2019s own face, hairstyle, outfit and likeness exactly as seen in the ' +
           'photo, standing close together side by side in the same left/right order as the photo. ' +
           'Do not merge them into one person and do not duplicate anyone.' + sameStyle);
    }
    if (kind === 'pet') {
      return photoCount >= 2
        ? ('Two separate photos of the subjects are provided: ' + nA + ' is a person and ' + nB + ' is their pet ' +
           '(dog, cat or other animal). Depict the person AND the pet together in ONE figurine composition on a single ' +
           'shared base, preserving the person\u2019s likeness from ' + nA + ' and the pet\u2019s breed, colors and ' +
           'markings from ' + nB + '.' + sameStyle)
        : ('The subject photo (' + nA + ') shows a person together with their pet (dog, cat or other animal). Depict the person ' +
           'AND the pet together in ONE figurine composition on a single shared base, preserving the person\u2019s likeness ' +
           'and the pet\u2019s breed, colors and markings exactly as seen in the photo.' + sameStyle);
    }
    if (kind === 'pet_only') {
      return ('The subject photo (' + nA + ') shows a pet (dog, cat or other animal). Create a figurine of ONLY the pet with ' +
              'no person, preserving the pet\u2019s breed, colors, markings and pose exactly as seen in the photo.' + sameStyle);
    }
    return '';
  }

  /* 全身约束：默认/后台/场景提示词都统一确保生成全身像（提示词里已含全身描述时不再重复追加） */
  var FULL_BODY_CLAUSE = 'Show the full body from head to toe with the entire figure fully visible and centered in frame, no cropping of the head, legs or feet.';
  function withFullBody(prompt) {
    if (!prompt) return prompt;
    if (/full[\s-]?body/i.test(prompt) || /head to toe/i.test(prompt) || /entire figure/i.test(prompt)) return prompt;
    return prompt + ' ' + FULL_BODY_CLAUSE;
  }
  /* 背景约束：后台「系统设置 → 2D 模型计费 → 生图背景」下发
     white=纯白 / transparent=透明 / none=不追加。
     提示词里已写明同类背景时不重复追加。仅通用多风格产品生效，场景产品用场景自带背景。 */
  var BG_CLAUSE = {
    white: 'Pure white seamless background, no props, no scenery, no visible shadow cast by the figure.',
    transparent: 'Isolated on a fully transparent background with a real alpha channel: no backdrop, no props, no scenery, no floor or horizon line.',
  };
  var BG_GUARD = {
    white: /white\s+background/i,
    transparent: /transparent\s+background|alpha\s+channel/i,
  };
  function withBackground(prompt, bg) {
    if (!prompt) return prompt;
    var clause = BG_CLAUSE[bg];
    if (!clause) return prompt;                                  // none / 未知值 → 不追加
    if (BG_GUARD[bg] && BG_GUARD[bg].test(prompt)) return prompt; // 提示词已含同类描述
    return prompt + ' ' + clause;
  }
  /* 姿势/动作复刻约束：后台风格提示词与全局后缀偏向「正视/头肩/标准站姿」，
     会把用户原照里的姿势压平。这里在提示词末尾统一追加最强约束，
     确保生成图复刻用户原照的姿势、动作、手势与取景，而不是被模型标准化。
     提示词里已含同类描述时不重复追加。 */
  var POSE_CLAUSE = 'Faithfully replicate the exact pose, body posture, gestures, hand positions and action of the subject(s) shown in the reference photo(s), keeping the same framing and camera angle as the original photo; do not change, flatten or standardize the pose.';
  // ai-custom 单弹窗的基础指令：参考图 1 = 商品主图（作为底图原样复刻），只把用户照片的头换上去；
  // 背景约束不写在这里，由 withBackground 按全局默认背景统一追加
  var DESIGN_PRODUCT_PROMPT = 'Reference image 1 is the product listing photo of this product page: use it as the base and reproduce it exactly — same composition, body pose, outfit, materials, colors, proportions, sculpting style, base, framing and lighting. The remaining reference image(s) are customer photo(s). Replace ONLY the head: take the face, facial features, hairstyle, skin tone and head shape from the customer photo and swap them onto the figure in reference image 1. Keep the body, clothing, pose, hands and every other detail of reference image 1 unchanged; do not redesign, restyle, recompose or redraw the rest of the image. The result must look exactly like reference image 1 except for the customer\'s head.';
  function withPose(prompt) {
    if (!prompt) return prompt;
    if (/(exact|same|original)\s+pose/i.test(prompt)) return prompt;
    return prompt + ' ' + POSE_CLAUSE;
  }
  /* ---------------- API client ---------------- */

  function Api(workerUrl) {
    this.base = String(workerUrl || '').replace(/\/+$/, '');
  }
  Api.prototype._headers = function (extra) {
    // 店铺主域名统一不带 www：Shopify 会把主域名 301 到 www，若原样上报
    // Worker 会把数据记到 "www.xxx" 这个独立命名空间下，与后台（用 canonical_domain）对不上，
    // 表现为后台改的积分/订单/会话在前台看不到。
    // 草稿/后台预览页 hostname 是随机的 *.shopifypreview.com（不在 Worker 站点映射里，
    // 会被当成「幽灵店铺」导致积分与正式店隔离），因此优先用 Liquid 下发的 shop.domain。
    var siteDomain = (this.canonicalDomain || location.hostname).replace(/^www\./, '');
    var h = {
      'Accept': 'application/json',
      'X-Site-Domain': siteDomain,
      'X-Anon-Id': getAnonId()
    };
    // 已登录顾客：带上 Shopify customer ID，积分钱包/生成历史跟随账号（换设备也在）；
    // 同时仍带匿名 ID，登录后由服务端把匿名余额与历史一次性并入账号。
    if (this.customerId) {
      h['X-Customer-Id'] = String(this.customerId);
      // 姓名/邮箱：仅供 Worker 后台「用户管理」把长 ID 显示成可辨认的顾客。
      // HTTP 头只允许 Latin-1，非 ASCII 字符（如中文姓名）必须编码，否则 fetch 直接报错。
      if (this.customerName) h['X-Customer-Name'] = encodeURIComponent(this.customerName);
      if (this.customerEmail) h['X-Customer-Email'] = encodeURIComponent(this.customerEmail);
    }
    if (extra) Object.keys(extra).forEach(function (k) { h[k] = extra[k]; });
    return h;
  };
  Api.prototype._request = function (path, opts) {
    if (!this.base) return Promise.reject(new Error('Worker URL is not configured. Please set it in the theme section settings.'));
    return fetch(this.base + path, opts).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (body) {
        if (!res.ok) {
          var msg = (body && body.error && body.error.message) || t('err.request_failed', { status: res.status });
          var err = new Error(msg);
          err.status = res.status;
          err.body = body;
          throw err;
        }
        return body;
      });
    }).catch(function (e) {
      // 网络层失败（断网/切走页面/超时/CORS）时浏览器只给一个没有 status 的 TypeError，
      // 标记出来供调用方区分「请求根本没送达」与「服务端明确返回的错误」——
      // 前者不能定性为任务失败（服务端可能已经受理并真的在生成）
      if (e && e.status == null) e.network = true;
      throw e;
    });
  };
  Api.prototype.verify = function () {
    return this._request('/api/auth/verify', { method: 'POST', headers: this._headers({ 'Content-Type': 'application/json' }), body: '{}' });
  };
  Api.prototype.publicConfig = function (locale, product) {
    var q = [];
    if (locale) q.push('locale=' + encodeURIComponent(locale));
    // 商品 handle/ID：Worker 据此下发该商品单独的定制配置（标签/提示词/参考图/锁定内容）
    if (product) q.push('product=' + encodeURIComponent(product));
    return this._request('/api/config/public' + (q.length ? '?' + q.join('&') : ''), { method: 'GET', headers: this._headers() });
  };
  Api.prototype.createSession = function (styleVariantId) {
    return this._request('/api/session/create', {
      method: 'POST',
      headers: this._headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ style_variant_id: String(styleVariantId) })
    });
  };
  // 上传文件到 R2。用 XHR（而非 fetch）以便拿到上传进度：onProgress(loaded, total)
  Api.prototype.upload = function (file, sessionId, category, onProgress) {
    var self = this;
    if (!this.base) return Promise.reject(new Error('Worker URL is not configured. Please set it in the theme section settings.'));
    var fd = new FormData();
    fd.append('file', file);
    fd.append('session_id', sessionId);
    fd.append('category', category || 'user-upload');
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', self.base + '/api/r2/upload', true);
      var headers = self._headers();
      Object.keys(headers).forEach(function (k) { xhr.setRequestHeader(k, headers[k]); });
      if (onProgress && xhr.upload) {
        xhr.upload.onprogress = function (e) {
          onProgress(e.loaded, e.lengthComputable ? e.total : 0);
        };
      }
      xhr.onload = function () {
        var body = {};
        try { body = JSON.parse(xhr.responseText || '{}'); } catch (err) {}
        if (xhr.status >= 200 && xhr.status < 300) return resolve(body);
        var msg = (body && body.error && body.error.message) || t('err.request_failed', { status: xhr.status });
        var e2 = new Error(msg); e2.status = xhr.status; e2.body = body;
        reject(e2);
      };
      xhr.onerror = xhr.ontimeout = function () {
        reject(new Error(t('err.request_failed', { status: 0 })));
      };
      xhr.send(fd);
    });
  };
  Api.prototype.sign = function (key, sessionId) {
    return this._request('/api/r2/sign', {
      method: 'POST',
      headers: this._headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ key: key, session_id: sessionId })
    });
  };
  Api.prototype.gen2d = function (payload) {
    return this._request('/api/ai/generate-2d', {
      method: 'POST',
      headers: this._headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(payload)
    });
  };
  Api.prototype.gen3d = function (payload) {
    return this._request('/api/ai/generate-3d', {
      method: 'POST',
      headers: this._headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(payload)
    });
  };
  Api.prototype.task = function (taskId, provider) {
    return this._request('/api/ai/task/' + encodeURIComponent(taskId) + '?provider=' + provider, {
      method: 'GET', headers: this._headers()
    });
  };
  // 按会话反查最新任务：提交阶段网络中断（浏览器拿不到 task_id）时找回任务号，
  // 返回形态与 task() 一致，可复用同一条轮询处理链
  Api.prototype.taskLatest = function (sessionId, provider) {
    return this._request('/api/ai/task/latest?session_id=' + encodeURIComponent(sessionId)
      + '&provider=' + encodeURIComponent(provider || 'apimart'), {
      method: 'GET', headers: this._headers()
    });
  };
  Api.prototype.convert3d = function (payload) {
    return this._request('/api/ai/convert-3d', {
      method: 'POST',
      headers: this._headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(payload)
    });
  };
  // 我的生成历史（该身份在本店的全部已完成 2D/3D 生成）
  Api.prototype.history = function (limit) {
    return this._request('/api/history?limit=' + (limit || 48), {
      method: 'GET', headers: this._headers()
    });
  };
  // 历史记录「Continue customizing」：按会话 id 取回该次定制的风格/照片/2D/3D/步骤
  Api.prototype.sessionGet = function (sessionId) {
    return this._request('/api/session/get?session_id=' + encodeURIComponent(sessionId), {
      method: 'GET', headers: this._headers()
    });
  };
  // 软隐藏：删除所选或全部清空（仅影响前台展示，后台与订单图片保留）
  Api.prototype.hideHistory = function (payload) {
    return this._request('/api/history/hide', {
      method: 'POST',
      headers: this._headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(payload || {})
    });
  };
  // 领取积分：type='auto' 时服务端会并入匿名钱包余额，并补发注册一次性 + 当日首次登录奖励
  Api.prototype.claimPoints = function (type) {
    return this._request('/api/points/claim', {
      method: 'POST',
      headers: this._headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ type: type || 'auto' })
    });
  };

  /* ---------------- Customizer ---------------- */

  function Customizer(sectionId, root, preset, product) {
    this.sectionId = sectionId;
    this.root = root;
    this.preset = preset || {};
    this.product = product;
    this.api = new Api(this.preset.workerUrl);
    // 已登录顾客的 Shopify customer ID（主题 preset 下发）；为空即匿名访客
    this.customerId = this.preset.customerId ? String(this.preset.customerId) : '';
    // 顾客姓名/邮箱（主题 preset 下发），仅用于后台展示
    this.customerName = this.preset.customerName ? String(this.preset.customerName) : '';
    this.customerEmail = this.preset.customerEmail ? String(this.preset.customerEmail) : '';
    this.api.customerId = this.customerId;
    this.api.customerName = this.customerName;
    this.api.customerEmail = this.customerEmail;
    // 店铺规范主域名（Liquid 下发）：预览页/特殊域名下保证积分等数据归到正式店铺
    this.api.canonicalDomain = this.preset.canonicalDomain || '';

    this.cost2d = 3;
    this.cost3d = 8;
    this.balance = null;
    // 积分获取途径的奖励额度（后台「积分获取设置」配置，用于前台「如何获取积分」提示）
    this.earnBonus = { register: 0, login: 0, share: 0, checkin: 0 };
    this.apiReady = false;
    this.serverPrompts = null;      // 管理后台配置的风格 prompts（优先级最高）
    this.serverStyleRefs = {};      // 风格附加参考图 { Style变体值: R2 key }，仅作构图/位置参考
    // 姿态（后台「姿态库」+ 风格绑定）：{ Style变体值: 姿态提示词 / 姿态参考图 R2 key }
    this.serverPosePrompts = {};
    this.serverPoseRefs = {};
    this.defaultSize = '3:4';       // 后台配置的全局生图尺寸（画面比例）
    this.defaultBackground = 'white'; // 后台配置的全局生图背景：white | transparent | none
    this.locale = this.preset.locale || 'en';  // 当前店铺语种（Liquid request.locale.iso_code）
    this.styleDisplay = {};         // 风格展示名（按语种下发，键 = Style 变体值）
    // Worker 后台「Figure 变体设置」：{ "<Figure变体值>": { kind, photoCount } }，优先级高于主题关键词推断
    this.figureConfigs = {};
    // 第 3 步（3D 模型）开关：优先用主题编辑器的 Section 设置（Liquid 直接下发，首屏即生效，
    // 不依赖网络）；旧版 section 没有该设置时才回退 Worker /api/config/public 的 gen3d_enabled
    this.gen3dFromTheme = (typeof this.preset.gen3dStepEnabled === 'boolean') ? this.preset.gen3dStepEnabled : null;
    this.gen3dEnabled = this.gen3dFromTheme === null ? true : this.gen3dFromTheme;
    // 从页面最近记录选中的 2D 效果图（不进弹窗，直接加购）；selected3d 为旧的 3D 直购
    this.selected2d = null;
    // Step 4 加价展示：基准组合（current = 当前已选组合 | lowest = 最低价组合）
    this.priceDeltaBaseMode = 'current';
    // Step 4 加价覆盖：{ "选项名|值": 加价(店铺货币单位) }，后台可对个别值覆盖自动算出的差额
    this.priceDeltaOverrides = {};

    this.styleIdx = -1;
    this.figureIdx = -1;         // 单人/双人/人宠 组合选项
    this._photoCache = {};       // 按 Figure 模式缓存照片：Duo→Solo→Duo 切换时恢复被裁剪的照片
    this.sizeIdx = -1;           // Size 尺寸选项（Q4 场景产品）
    this.options = product.options || [];
    (this.options || []).forEach((function (name, i) {
      if (name === (this.preset.styleOptionName || 'Style')) this.styleIdx = i;
      if (name === (this.preset.figureOptionName || 'Figure')) this.figureIdx = i;
      if (name === 'Size') this.sizeIdx = i;
    }).bind(this));

    // Q4 场景模式：preset.sceneCode 来自产品元字段 custom.ai3d_scene；
    // scene 配置由 Worker /api/config/public 的 scene_presets 下发
    this.sceneCode = this.preset.sceneCode || '';
    this.sceneMode = !!this.sceneCode;
    // design-box：标准商品页 + AI 定制框（辅助设计）。变体由标准选择器（custom-options1
    // 的 radio/select）驱动，AI 框只负责上传照片/生成效果图，并随标准加购带稿（行属性）
    this.designBox = this.preset.mode === 'design-box';
    // AI 定制（辅助设计）没有 3D 步骤：积分文案只展示 2D 价格
    if (this.designBox) this.gen3dEnabled = false;
    this.scene = null;
    this.serverScenes = null;
    this.configPromise = null;

    this.sel = {};                 // optionIndex -> value
    this._cleanups = [];           // 挂在 window/document 上的监听器注销函数
    this._destroyed = false;
    this.pendingSlot = null;       // 点击空槽上传时的目标槽位（null = 追加到末尾）
    this._genRun = null;           // 进行中的生成 { kind:'2d'|'3d', pct:number }（关弹窗后卡片内显示进度）
    this._designBatch = null;      // design-box 多轮生图队列 { total, completed, prompt, running }
    this._designTagDefs = [];      // design-box 预设标签定义（来自 Section 配置）
    this.historyItems = [];        // 主图下方「我的生成历史」条目（服务端返回）
    this.historySelected = {};     // 已勾选待删除的 task_id 集合
    this.state = this.loadState() || {
      step: 1,
      style: null,
      figure: null,              // 单人/双人/人宠 变体值
      session: null,
      photos: [],                // [{ key, url }]，单人1张，双人/人宠最多2张
      photo: null,               // = photos[0]，兼容旧流程字段
      img2d: null,               // { taskId, key, url } 当前选中的 2D 效果图
      img2dPending: null,        // 已提交未终结的 2D 任务号（客户端超时/关页面后用于自动续轮）
      img2dHistory: [],          // 被重刷替换掉的旧 2D 图（仅历史预览，不可回选）
      model3d: null,             // { taskId, key, url }
      optionSel: null,
      // design-box：卡片右侧的多张效果图、弹窗提示词/标签/数量
      designResults: [],         // [{ taskId, key, url, sessionId }]
      designTags: [],            // 已选中的预设标签下标
      designQty: 1,
      designPrompt: '',
      designBatch: null,
      designSessionVariantId: null,
      // face 纵向照片列：历史上传照片（跨「重新上传清空 photos」保留）与当前参考照片 key
      designPhotos: [],
      designPhotoKey: null
    };
    // 旧版本 state 迁移：单张 photo → photos 数组
    if (this.state.photo && (!this.state.photos || !this.state.photos.length)) {
      this.state.photos = [this.state.photo];
    }
    if (!this.state.photos) this.state.photos = [];
    if (!this.state.img2dHistory) this.state.img2dHistory = [];
    if (!this.state.designResults) this.state.designResults = [];
    if (!this.state.designPhotos) this.state.designPhotos = [];
    // 旧存档升级：把当前照片组里的照片补进 face 历史照片列
    if (!this.state.designPhotos.length) {
      var seed = this.photos();
      for (var si = 0; si < seed.length; si++) {
        if (seed[si] && seed[si].key) this.rememberDesignPhoto(seed[si]);
      }
    }
    if (!this.state.designTags) this.state.designTags = [];
    if (!this.state.designQty) this.state.designQty = 1;

    this.cacheEls();
    this.bindUI();
    this.renderGuides();
    this.initGallery();
    this.initStyleRail();
    this.initVerify();
    this.initHistory();
    this.initViewerControls();
    if (this.sceneMode) {
      // Q4 场景产品：Style 固定、无 Figure 选项，改由场景包驱动（人数/照片数/尺寸/提示词）
      this.initScene();
    } else if (this.designBox) {
      // 标准商品页：变体已由标准选择器预选，同步进 sel/state 后渲染上传槽位（无 ai3d 风格/人物卡片）
      this.syncDesignBoxSelection();
      this.initDesignBoxUI();
      this.renderPageUpload();
    } else {
      this.restoreStyleSelection();
      // 无历史会话时，跟随页面上默认选中的风格 radio（主题按首个可用变体预选）
      if (!this.state.style) {
        var checkedStyle = this.root.querySelector('.ai3d-style-input:checked');
        if (checkedStyle) this.selectStyle(checkedStyle.getAttribute('data-style-value'), true, false, checkedStyle);
      }
      // 恢复已选人物模式（selectStyle 已按变体给默认值，持久化值优先）
      if (this.figureIdx >= 0) {
        // Figure 只有唯一值（前端隐藏选择器，仅一个隐藏 radio 承载）：兜底默认选中，否则 Start 会被拦
        if (!this.state.figure && this.els.figureBtns.length === 1) {
          this.selectFigure(this.els.figureBtns[0].getAttribute('data-figure-value'), true);
        }
        if (this.state.figure) this.selectFigure(this.state.figure, true);
        this.updateFigureAvailability();
        this.renderPhotos();
        this.renderPageUpload();
      }
      this.syncModalStyles();
    }
    this.updateResumeUI();
    this.watchRemoval();
  }

  /* 注册挂在 window/document 上的监听并登记注销函数（destroy 时成对移除，避免泄漏） */
  Customizer.prototype.bindGlobal = function (target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    this._cleanups.push(function () { target.removeEventListener(type, fn, opts); });
  };

  /* 主题编辑器中 section 被局部刷新/移除时，DOM 会脱离文档，自动销毁实例释放全局监听 */
  Customizer.prototype.watchRemoval = function () {
    var self = this;
    if (typeof MutationObserver === 'undefined' || !document.body) return;
    this._mo = new MutationObserver(function () {
      if (!document.body.contains(self.root)) self.destroy();
    });
    this._mo.observe(document.body, { childList: true, subtree: true });
  };

  Customizer.prototype.destroy = function () {
    if (this._destroyed) return;
    this._destroyed = true;
    this.stopGen2dCarousel();
    this.stopDesignTyper();
    if (this._mo) { this._mo.disconnect(); this._mo = null; }
    this._cleanups.splice(0).forEach(function (off) { try { off(); } catch (e) {} });
  };

  Customizer.prototype.cacheEls = function () {
    var r = this.root;
    this.els = {
      priceCurrent: $(r, '[data-price-current]'),
      priceCompare: $(r, '[data-price-compare]'),
      credits: $(r, '[data-ai3d-credits]'),
      creditsValue: $(r, '[data-credits-value]'),
      creditsCost: $(r, '[data-credits-cost]'),
      creditsGet: $(r, '[data-credits-get]'),
      creditsRefresh: $(r, '[data-credits-refresh]'),
      creditsPanel: $(r, '[data-credits-panel]'),
      styleBlock: $(r, '[data-style-block]'),
      styleBtns: $all(r, '[data-style-value]'),
      figureBlock: $(r, '[data-figure-block]'),
      figureBtns: $all(r, '[data-figure-value]'),
      sizeBlock: $(r, '[data-size-block]'),
      sizeBtns: $all(r, '[data-size-value]'),
      sizeHint: $(r, '[data-size-hint]'),
      sceneInfo: $(r, '[data-scene-info]'),
      sceneName: $(r, '[data-scene-name]'),
      sceneStyle: $(r, '[data-scene-style]'),
      scenePeople: $(r, '[data-scene-people]'),
      sceneRecipient: $(r, '[data-scene-recipient]'),
      sceneProp: $(r, '[data-scene-prop]'),
      sceneDeliveryWrap: $(r, '[data-scene-delivery-wrap]'),
      sceneDelivery: $(r, '[data-scene-delivery]'),
      sceneColorPalette: $(r, '[data-scene-color-palette]'),
      sceneColorName: $(r, '[data-scene-color-name]'),
      sceneEngraving: $(r, '[data-scene-engraving]'),
      sceneMessage: $(r, '[data-scene-message]'),
      lockHint: $(r, '[data-lock-hint]'),
      start: $(r, '[data-ai3d-start]'),
      progressHint: $(r, '[data-ai3d-progress]'),
      progressHintWrap: $(r, '[data-ai3d-progress-wrap]'),
      modal: $(r, '[data-ai3d-modal]'),
      overlay: $(r, '[data-ai3d-overlay]'),
      close: $(r, '[data-ai3d-close]'),
      history: $(r, '[data-ai3d-history]'),
      historyTitle: $(r, '[data-history-title]'),
      historyHint: $(r, '[data-history-hint]'),
      historyGrid: $(r, '[data-history-grid]'),
      historySelectAll: $(r, '[data-history-select-all]'),
      historyDeselectAll: $(r, '[data-history-deselect-all]'),
      historyDelete: $(r, '[data-history-delete]'),
      historyClear: $(r, '[data-history-clear]'),
      historyLightbox: $(r, '[data-history-lightbox]'),
      historyLightboxImg: $(r, '[data-history-lightbox-img]'),
      historyLightboxModel: $(r, '[data-history-lightbox-model]'),
      historyLightboxContinue: $(r, '[data-history-lightbox-continue]'),
      customCard: $(r, '[data-custom-card]'),
      historyCount: $(r, '[data-history-count]'),
      modalStyle: $(r, '[data-modal-style-label]'),
      indicators: $all(r, '[data-step-indicator]'),
      indicator4: $(r, '[data-step-indicator="4"]'),
      steps: $all(r, '[data-ai3d-step]'),

      uploadZone: $(r, '[data-upload-zone]'),
      uploadInput: $(r, '[data-upload-input]'),
      uploadPlaceholder: $(r, '[data-upload-placeholder]'),
      uploadThumbs: $(r, '[data-upload-thumbs]'),
      uploadHint: $(r, '[data-upload-hint]'),
      uploadSpinner: $(r, '[data-upload-spinner]'),
      uploadError: $(r, '[data-upload-error]'),
      goto2: $(r, '[data-goto-2]'),

      // 产品页上传区（弹窗外）
      pageUploadZone: $(r, '[data-page-upload-zone]'),
      pageUploadInput: $(r, '[data-page-upload-input]'),
      pageUploadBox: $(r, '.ai3d-page-upload__box'),
      pageUploadPlaceholder: $(r, '[data-page-upload-placeholder]'),
      pageUploadThumbs: $(r, '[data-page-upload-thumbs]'),
      pageUploadReplace: $(r, '[data-page-replace]'),
      pageUploadSpinner: $(r, '[data-page-upload-spinner]'),
      pageUploadError: $(r, '[data-page-upload-error]'),
      pageUploadRecent: $(r, '[data-page-upload-recent]'),
      pageUploadRecentList: $(r, '[data-page-upload-recent-list]'),
      recentTour: $(r, '[data-recent-tour]'),
      recentTourClose: $(r, '[data-recent-tour-close]'),
      compareOpen: $(r, '[data-compare-open]'),

      // design-box：设计弹窗 / 预设标签 / 生成数量 / 结果区
      designModal: $(r, '[data-design-modal]'),
      designOpenBtns: $all(r, '[data-design-open]'),
      designCloseBtns: $all(r, '[data-design-modal-close]'),
      designPhotos: $(r, '[data-design-photos]'),
      promptTags: $(r, '[data-prompt-tags]'),
      promptTagsWrap: $(r, '[data-prompt-tags-wrap]'),
      designQtyBtns: $all(r, '[data-design-qty-value]'),
      designQty: $(r, '[data-design-qty]'),
      designProgress: $(r, '[data-design-progress]'),
      designPct: $(r, '[data-design-pct]'),
      designResultActions: $(r, '[data-design-result-actions]'),
      designRounds: $(r, '[data-design-rounds]'),
      designGenerateLabel: $(r, '[data-design-generate-label]'),
      designCtaHint: $(r, '[data-design-cta-hint]'),
      designOpenLabel: $(r, '[data-design-open-label]'),
      designTeaser: $(r, '[data-design-teaser]'),
      designTyper: $(r, '[data-design-typer]'),
      designStage: $(r, '[data-design-stage]'),
      designStageImg: $(r, '[data-design-stage-img]'),
      designStageBadge: $(r, '[data-design-stage-badge]'),
      designFace: $(r, '[data-design-face]'),
      designFaceList: $(r, '[data-design-face-list]'),
      designComposer: $(r, '[data-design-composer]'),
      // 卡片下方的「最近生成」横条（弹窗之外，随时可见）
      designRecent: $(r, '[data-design-recent]'),
      designRecentList: $(r, '[data-design-recent-list]'),

      // 弹窗第一步左列：当前风格预览图
      modalStyleFigs: $all(r, '[data-style-preview-fig]'),

      // 生成前后对比弹窗
      compare: $(r, '[data-compare]'),

      // 定制卡片内的生成状态 / 前后对比（弹窗外）
      customStatus: $(r, '[data-custom-status]'),
      customStatusRunning: $(r, '[data-custom-status-running]'),
      customStatusDone: $(r, '[data-custom-status-done]'),
      customStatusText: $(r, '[data-custom-status-text]'),
      customStatusProgress: $(r, '[data-custom-status-progress]'),
      customStatusShotBack: $(r, '[data-custom-status-shot-back]'),
      customStatusShotFront: $(r, '[data-custom-status-shot-front]'),
      baBefore: $(r, '[data-ba-before]'),
      baAfter: $(r, '[data-ba-after]'),
      baClip: $(r, '[data-ba-clip]'),
      baDivider: $(r, '[data-ba-divider]'),
      baRange: $(r, '[data-ba-range]'),
      baBeforeThumb: $(r, '[data-ba-before-thumb]'),
      baAfterThumb: $(r, '[data-ba-after-thumb]'),
      custom3d: $(r, '[data-custom-3d]'),
      zoom: $(r, '[data-zoom]'),
      zoomImg: $(r, '[data-zoom-img]'),

      gen2dIdle: $(r, '[data-gen2d-idle]'),
      gen2dRunning: $(r, '[data-gen2d-running]'),
      gen2dCarousel: $(r, '[data-gen2d-carousel]'),
      gen2dDone: $(r, '[data-gen2d-done]'),
      gen2dThumb: $(r, '[data-gen2d-thumb]'),
      gen2dSource: $(r, '[data-gen2d-source]'),
      gen2dStyle: $(r, '[data-gen2d-style]'),
      gen2dCost: $(r, '[data-gen2d-cost]'),
      gen2dStart: $(r, '[data-gen2d-start]'),
      gen2dStatus: $(r, '[data-gen2d-status]'),
      gen2dProgress: $(r, '[data-gen2d-progress]'),
      gen2dRefresh: $(r, '[data-gen2d-refresh]'),
      gen2dResult: $(r, '[data-gen2d-result]'),
      gen2dZoom: $(r, '[data-gen2d-zoom]'),
      gen2dLightbox: $(r, '[data-gen2d-lightbox]'),
      gen2dLightboxImg: $(r, '[data-gen2d-lightbox-img]'),
      gen2dError: $(r, '[data-gen2d-error]'),
      gen2dRegen: $(r, '[data-gen2d-regen]'),
      gen2dRegenWrap: $(r, '[data-gen2d-regen-wrap]'),
      gen2dRegenWarn: $(r, '[data-gen2d-regen-warn]'),
      gen2dHistory: $(r, '[data-gen2d-history]'),
      gen2dHistoryList: $(r, '[data-gen2d-history-list]'),
      gen2dHistoryPrev: $(r, '[data-gen2d-history-prev]'),
      gen2dHistoryNext: $(r, '[data-gen2d-history-next]'),
      keepNote2d: $(r, '[data-keepnote-2d]'),
      step2Note: $(r, '[data-step2-note]'),
      goto3: $(r, '[data-goto-3]'),

      gen3dIdle: $(r, '[data-gen3d-idle]'),
      gen3dRunning: $(r, '[data-gen3d-running]'),
      gen3dDone: $(r, '[data-gen3d-done]'),
      gen3dSource: $(r, '[data-gen3d-source]'),
      gen3dCost: $(r, '[data-gen3d-cost]'),
      gen3dStart: $(r, '[data-gen3d-start]'),
      gen3dStatus: $(r, '[data-gen3d-status]'),
      gen3dPct: $(r, '[data-gen3d-pct]'),
      gen3dViewer: $(r, '[data-gen3d-viewer]'),
      gen3dError: $(r, '[data-gen3d-error]'),
      keepNote3d: $(r, '[data-keepnote-3d]'),
      goto4: $(r, '[data-goto-4]'),

      // 格式转换下载按钮（按需懒转换，不扣积分）
      convertBar: $(r, '[data-convert-bar]'),
      convertBtns: {
        STL: $(r, '[data-convert-stl]'),
        '3MF': $(r, '[data-convert-3mf]'),
        FBX: $(r, '[data-convert-fbx]'),
        OBJ: $(r, '[data-convert-obj]'),
        USDZ: $(r, '[data-convert-usdz]')
      },

      optionsArea: $(r, '[data-options-area]'),
      summary2d: $(r, '[data-summary-2d]'),
      summary3d: $(r, '[data-summary-3d]'),
      summaryStyle: $(r, '[data-summary-style]'),
      summaryVariant: $(r, '[data-summary-variant]'),
      summaryPrice: $(r, '[data-summary-price]'),
      optionsError: $(r, '[data-options-error]'),
      optionsHint: $(r, '[data-options-hint]'),
      addToCart: $(r, '[data-add-to-cart]')
    };
  };

  /* ---------- state persistence ---------- */
  Customizer.prototype.storageKey = function () { return STORAGE_STATE_PREFIX + this.product.id; };
  Customizer.prototype.loadState = function () {
    try { return JSON.parse(localStorage.getItem(this.storageKey())); } catch (e) { return null; }
  };
  Customizer.prototype.saveState = function () {
    // design-box：状态一变就同步表单隐藏属性（随标准加购提交的行属性）
    if (this.designBox) this.syncFormProperties();
    try {
      var s = this.state;
      // 上传中的占位只活在内存里（回填靠 _upId）：blob: URL 刷新后必然失效，
      // 落盘会变成永久转圈的死槽位，所以持久化时剔除 _pending
      var hasPending = s.photos && s.photos.some(function (p) { return p && p._pending; });
      if (!hasPending) {
        localStorage.setItem(this.storageKey(), JSON.stringify(s));
        return;
      }
      var copy = JSON.parse(JSON.stringify(s));
      // 剔除 _pending 占位时保留空槽（置 null 而非过滤）：刷新页面/section 重渲染后
      // loadState 恢复的仍是同样的槽位结构，已传照片不会整体前移
      copy.photos = (copy.photos || []).map(function (p) { return (p && !p._pending) ? p : null; });
      localStorage.setItem(this.storageKey(), JSON.stringify(copy));
    } catch (e) {}
  };
  Customizer.prototype.clearState = function () {
    try { localStorage.removeItem(this.storageKey()); } catch (e) {}
  };

  /* ---------- 会话自愈 ----------
   * 匿名身份已与网络解耦，但仍可能遇到历史遗留会话或后端数据清理导致的归属失配（403）。
   * 此时丢弃旧会话、静默重建后重试原请求一次，避免顾客在定制中途卡死。 */
  Customizer.prototype.recoverSession = function () {
    var self = this;
    // 并发请求同时 403 时只重建一次会话，避免重复建会话撞上限
    if (this._recovering) return this._recovering;
    this.state.session = null;
    this.saveState();
    var variant = this.findVariant(this.sel) || this.firstAvailableVariantForStyle(this.state.style);
    var vid = variant ? String(variant.id) : '';
    this._recovering = this.api.createSession(variant ? variant.id : this.state.style).then(function (d) {
      self.state.session = d.session_id;
      // design-box 会话校验依赖这两个字段：不同步的话，下次 ensureDesignBoxSession 会
      // 误判为「换了风格」再建一个会话，已上传照片的 key 留在旧会话下，取图/签名继续 403
      if (self.designBox) {
        self.state.designSessionVariantId = vid || null;
        self._designSessionStale = false;
        self._designSessionPromise = null;
      }
      self.saveState();
      self._recovering = null;
      return d.session_id;
    }, function (err) {
      self._recovering = null;
      throw err;
    });
    return this._recovering;
  };
  Customizer.prototype.withSessionRetry = function (run) {
    var self = this;
    return run().catch(function (err) {
      if (!err || err.status !== 403) throw err;
      return self.recoverSession().then(function () { return run(); });
    });
  };

  /* ---------- variants ---------- */
  Customizer.prototype.findVariant = function (sel) {
    var variants = this.product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var idx in sel) {
        if (sel[idx] && v.options[idx] !== sel[idx]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  };
  Customizer.prototype.firstAvailableVariantForStyle = function (styleValue) {
    var variants = this.product.variants || [];
    var first = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].options[this.styleIdx] !== styleValue) continue;
      if (!first) first = variants[i];
      if (variants[i].available) return variants[i];
    }
    return first;
  };
  /* 按会话 style_variant_id 在本页变体表反查（找不到返回 null） */
  Customizer.prototype.variantBySessionId = function (styleVariantId) {
    var out = null;
    var vid = String(styleVariantId || '');
    (this.product.variants || []).forEach(function (v) { if (String(v.id) === vid) out = v; });
    return out;
  };

  /* ---------- init UI ---------- */
  Customizer.prototype.bindUI = function () {
    var self = this;

    // 产品页卡片：用捕获阶段的单次 change 监听处理 Style / Figure 隐藏 radio。
    // 关键：点击 label 时浏览器会原生派发一次 change，主题 Slate 变体逻辑也听这个事件
    // （重算变体/价格、切换主图轮播）。捕获阶段先于 Slate 的冒泡处理执行，可先修正联动选项，
    // 且全程只触发一次，避免「原生 change + 手动 dispatch」重复执行导致的卡顿。
    this.root.addEventListener('change', function (e) {
      if (self._suppressNative) return;
      var t = e.target;
      if (!t || t.nodeType !== 1) return;
      if (self.designBox) {
        // 标准选择器（custom-options1 的 radio/select，data-index="optionN"）驱动变体与生成参数
        if (t.matches && t.matches('[data-index^="option"]')) self.syncDesignBoxSelection();
        return;
      }
      if (t.classList.contains('ai3d-style-input')) {
        // 会话进行中：与弹窗内风格按钮同语义，用新风格重开会话，避免状态与 UI 脱节
        if (self.state.session) self.switchSelection('style', t.getAttribute('data-style-value'), t);
        else self.selectStyle(t.getAttribute('data-style-value'), false, true, t);
      } else if (t.classList.contains('ai3d-figure-input')) {
        if (self.state.session) self.switchSelection('figure', t.getAttribute('data-figure-value'), t);
        else self.selectFigure(t.getAttribute('data-figure-value'), false, true, t);
      } else if (t.classList.contains('ai3d-size-input')) {
        // 尺寸不影响 AI 生成内容本身（6cm 仅追加简化约束），会话进行中也允许改价/改变体
        self.selectSize(t.getAttribute('data-size-value'), false, true, t);
      }
    }, true);

    if (this.els.start) this.els.start.addEventListener('click', function (e) {
      // 阻断冒泡：主题 theme.checkoutIndicator 对 .btn--add-to-cart 的委托点击会加上 btn--loading
      // （隐藏文案 + 无限旋转图标），而该类的清除只在主题加购成功回调里，本按钮永不触发 → 会一直转圈
      e.stopPropagation();
      self.els.start.classList.remove('btn--loading');
      // 选中了最近记录里的 2D 效果图 / 3D 模型：直接加购，不再进入定制弹窗
      if (self.selected3d || self.selected2d) self.submitCart();
      else self.onStart(false);
    });
    // 页面积分条右侧「Get credits」：展开/收起积分获取途径面板
    if (this.els.creditsGet) {
      this.els.creditsGet.addEventListener('click', function () {
        self.toggleCreditsPanel(self.els.creditsPanel && self.els.creditsPanel.hidden);
      });
    }
    // 「Refresh」：后台人工加积分后，用户无需刷新页面即可重新拉取余额
    if (this.els.creditsRefresh) {
      this.els.creditsRefresh.addEventListener('click', function () { self.refreshCredits(); });
    }
    // 气泡浮层定位：窗口尺寸变化 / 任意滚动容器滚动时跟随按钮（capture 才能收到内部滚动）
    this.bindGlobal(window, 'resize', function () { self.positionCreditsPanel(); });
    this.bindGlobal(window, 'resize', function () { self.fitPageRecent(); });
    this.bindGlobal(window, 'scroll', function () { self.positionCreditsPanel(); }, true);
    if (this.els.close) this.els.close.addEventListener('click', function () { self.closeModal(); });
    // 设计弹窗只能通过右上角叉关闭：点遮罩空白处、按 Esc 都不关闭（避免误触丢失进度）；
    // 对比 / 缩放等次级弹窗仍可用 Esc 关闭
    this.bindGlobal(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (self.els.compare && !self.els.compare.hidden) { self.closeCompare(); return; }
      if (self.els.zoom && !self.els.zoom.hidden) { self.closeZoom(); return; }
    });

    // 卡片内前后对比：拖动滑块裁切「原图」图层
    if (this.els.baRange) {
      this.els.baRange.addEventListener('input', function () { self.syncBeforeAfter(); });
    }
    // 3D 已生成：从卡片直接回弹窗 Step 3 看模型
    if (this.els.custom3d) {
      this.els.custom3d.addEventListener('click', function () {
        self.openModal();
        self.gotoStep(3);
      });
    }
    // 原图 / AI 效果图小图：点击放大预览
    var picks = this.root.querySelectorAll('[data-ba-zoom]');
    for (var pi = 0; pi < picks.length; pi++) {
      picks[pi].addEventListener('click', function () {
        var kind = this.getAttribute('data-ba-zoom');
        var src = kind === 'before'
          ? (self.els.baBefore && self.els.baBefore.getAttribute('src'))
          : (self.els.baAfter && self.els.baAfter.getAttribute('src'));
        self.openZoom(src);
      });
    }
    if (this.els.zoom) {
      this.els.zoom.addEventListener('click', function () { self.closeZoom(); });
    }

    if (this.els.goto2) this.els.goto2.addEventListener('click', function () {
      self.gotoStep(2);
      // 首次进入第二步：跳过 idle 态的「Generate 2D Portrait」二次点击，
      // 进入后直接提交生图，第二步立即展示生成中动画 + 进度条。
      // 已有 2D 结果（回来看）或有未终结任务（prepareStep2 会自动续轮）时不重复提交。
      if (!self.state.img2d && !self.state.img2dPending) self.runGen2D();
    });
    // 第 3 步（3D）被后台关闭时，Step 2 的同一个按钮直接进入 Options
    if (this.els.goto3) this.els.goto3.addEventListener('click', function () {
      if (self.gen3dEnabled === false) self.enterStep4();
      else self.gotoStep(3);
    });
    if (this.els.goto4) this.els.goto4.addEventListener('click', function () { self.enterStep4(); });

    // upload（支持多图：单人1张，双人/人宠最多2张；缩略图卡片上的删除走事件委托）
    if (this.els.uploadZone) this.els.uploadZone.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-photo-remove]');
      if (rm) {
        e.stopPropagation();
        // 点垃圾桶直接弹确认弹窗（不再在缩略图上展开勾/叉）
        var rmIndex = Number(rm.getAttribute('data-photo-index'));
        self.confirmDialog(t('step1.confirm_remove'), function () { self.removePhoto(rmIndex); });
        return;
      }
      var mv = e.target.closest('[data-photo-move]');
      if (mv) {
        e.stopPropagation();
        self.movePhoto(Number(mv.getAttribute('data-photo-index')), Number(mv.getAttribute('data-photo-move')));
        return;
      }
      if (self.has2d()) return;                     // 已生成 2D 后单向锁定
      // 槽位已满时不再直接 return（表现为「点上传框毫无反应，无法换图」）：
      // 改为整组替换，由 handleFiles 清空后重新上传
      var slotBtn = e.target.closest('[data-photo-slot]');
      self.pendingSlot = slotBtn ? Number(slotBtn.getAttribute('data-photo-slot')) : null;
      if (!slotBtn && self.photoCount() >= self.maxPhotos()) self.pendingReplace = true;
      self.els.uploadInput.click();
    });
    if (this.els.uploadInput) this.els.uploadInput.addEventListener('change', function () {
      if (this.files && this.files.length) self.handleFiles(this.files);
      this.value = '';
    });
    this.initDragDrop();

    // 产品页上传区（与弹窗内上传共用 handleFiles / 会话；上传后同步渲染到页面 + 弹窗 Step 1）
    if (this.els.pageUploadZone) {
      this.els.pageUploadPlaceholder.addEventListener('click', function () {
        self.pendingReplace = false;
        self.pendingSlot = null;
        self.els.pageUploadInput.click();
      });
      // 已有照片时点击上传区：点某张缩略图只替换该张，点框内空白处整组重新上传
      if (this.els.pageUploadBox) {
        this.els.pageUploadBox.addEventListener('click', function (e) {
          // 空槽 / 删除及其确认按钮由 pageUploadZone 事件委托处理，避免与「重新上传」冲突
          if (e.target.closest('[data-photo-remove]') || e.target.closest('[data-photo-slot]')
            || e.target.closest('[data-photo-confirm]') || e.target.closest('[data-photo-cancel]')) return;
          if (!self.photoCount()) return;   // 空态由占位符点击处理
          var thumb = e.target.closest('.ai3d-page-upload__thumb');
          self.pendingSlot = thumb ? Number(thumb.getAttribute('data-photo-index')) : null;
          self.pendingReplace = true;
          self.els.pageUploadInput.click();
        });
      }
      // 空槽上传 / 删除照片：与弹窗内一致走事件委托（点空槽 → 上传到该槽位）
      this.els.pageUploadZone.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-photo-remove]');
        if (rm) {
          e.stopPropagation();
          // 点垃圾桶不直接删：先展开「确认删除 / 取消」，避免误触
          var th = rm.closest('.ai3d-page-upload__thumb');
          if (th) th.classList.add('is-confirming');
          return;
        }
        var cf = e.target.closest('[data-photo-confirm]');
        if (cf) {
          e.stopPropagation();
          self.removePhoto(Number(cf.getAttribute('data-photo-index')));
          return;
        }
        var cc = e.target.closest('[data-photo-cancel]');
        if (cc) {
          e.stopPropagation();
          var cth = cc.closest('.ai3d-page-upload__thumb');
          if (cth) cth.classList.remove('is-confirming');
          return;
        }
        var slotBtn = e.target.closest('[data-photo-slot]');
        if (slotBtn) {
          e.stopPropagation();
          if (self.has2d() && self.photoCount()) return;   // 已生成 2D 后单向锁定（删光照片后可重新上传）
          self.pendingSlot = Number(slotBtn.getAttribute('data-photo-slot'));
          self.pendingReplace = false;
          self.els.pageUploadInput.click();
        }
      });
      this.els.pageUploadInput.addEventListener('change', function () {
        if (this.files && this.files.length) {
          if (self.pendingReplace) {
            self.pendingReplace = false;
            // 单槽替换：只移除该槽位的旧图，新图落到同一位置；未指定槽位则整组清空重传
            if (self.pendingSlot != null && self.photos()[self.pendingSlot]) {
              self.photos()[self.pendingSlot] = null;   // 保留槽位，新图落回同一位置
            } else {
              self.pendingSlot = null;
              self.state.photos = [];
            }
            self.syncPrimaryPhoto();
          }
          self.handleFiles(this.files);
        }
        this.value = '';
      });
      // 拖拽到产品页上传区
      this.els.pageUploadZone.addEventListener('dragover', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.els.pageUploadZone.classList.add('is-dragover');
      });
      this.els.pageUploadZone.addEventListener('dragleave', function (e) {
        if (e.target === self.els.pageUploadZone) self.els.pageUploadZone.classList.remove('is-dragover');
      });
      this.els.pageUploadZone.addEventListener('drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.els.pageUploadZone.classList.remove('is-dragover');
        self.pendingReplace = false;
        self.pendingSlot = null;
        var files = e.dataTransfer && e.dataTransfer.files;
        if (files && files.length) self.handleFiles(files);
        else if (self.els.pageUploadError) self.showError(self.els.pageUploadError, t('err.drop_no_file'));
      });
    }

    // 生成前后对比弹窗：入口（Upload Your Photo 右侧）/ 遮罩 / 关闭按钮
    if (this.els.compareOpen) {
      this.els.compareOpen.addEventListener('click', function () { self.openCompare(); });
    }
    // 「生成中」状态面板：点击回到定制弹窗（继续进行中的会话），而不是打开历史记录
    if (this.els.customStatusRunning) {
      this.els.customStatusRunning.addEventListener('click', function () {
        // design-box：打开设计弹窗继续查看进行中的生成（弹窗关闭后进度显示在卡片内）
        if (self.designBox) { self.openDesignModal(); return; }
        self.onStart(false);
      });
    }
    if (this.els.compare) {
      $all(this.els.compare, '[data-compare-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.closeCompare(); });
      });
    }

    // design-box：打开设计弹窗（提示词 / 标签 / 数量），生成过程也在弹窗内
    (this.els.designOpenBtns || []).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.openDesignModal();
      });
    });
    (this.els.designCloseBtns || []).forEach(function (b) {
      b.addEventListener('click', function () { self.closeDesignModal(); });
    });
    // 生成数量 1–4
    (this.els.designQtyBtns || []).forEach(function (b) {
      b.addEventListener('click', function () {
        if (self._designBatch && self._designBatch.running) return;
        self.setDesignQuantity(parseInt(b.getAttribute('data-design-qty-value'), 10) || 1);
      });
    });
    // 预设标签：点击把标签提示词插入输入框最前面（不清空用户已写内容）
    if (this.els.promptTags) {
      this.els.promptTags.addEventListener('click', function (e) {
        var b = e.target.closest('[data-design-tag]');
        if (!b) return;
        if (self._designBatch && self._designBatch.running) return;
        self.applyDesignTag(parseInt(b.getAttribute('data-design-tag'), 10));
      });
    }
    // 结果区底部操作组：继续修图（替换左下角上传图）/ 加入购物车 / 删除
    if (this.els.designResultActions) {
      this.els.designResultActions.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        if (b.hasAttribute('data-design-refine')) self.refineWithDesign(self.selectedDesign());
        else if (b.hasAttribute('data-design-addcart')) self.addDesignToCart();
        else if (b.hasAttribute('data-design-remove')) self.removeSelectedDesign();
      });
    }
    // 提示词输入：落盘，重新打开弹窗仍保留
    var designPromptEl = this.root.querySelector('[data-prompt-input]');
    if (designPromptEl) {
      designPromptEl.addEventListener('input', function () {
        self.state.designPrompt = designPromptEl.value || '';
        self.saveState();
      });
    }
    // 上传框右侧「当前上传图片生成的 2D 效果图」：点单条不进弹窗，
    // 直接选中该图 →「Start Customize」变「Add to Cart」（蓝紫渐变）立即加购
    if (this.els.pageUploadRecentList) {
      this.els.pageUploadRecentList.addEventListener('click', function (e) {
        // design-box：结果网格里的空态按钮 / 单张效果图
        if (self.designBox) {
          if (e.target.closest('[data-design-open]')) { self.openDesignModal(); return; }
          var rb = e.target.closest('[data-page-upload-recent-item]');
          if (!rb) return;
          var rid = rb.getAttribute('data-page-upload-recent-item');
          var foundDesign = null;
          (self.state.designResults || []).forEach(function (x) {
            if (x && String(x.taskId) === String(rid)) foundDesign = x;
          });
          if (foundDesign) self.selectDesignResult(foundDesign);
          return;
        }
        var b = e.target.closest('[data-page-upload-recent-item]');
        if (!b) return;
        var id = b.getAttribute('data-page-upload-recent-item');
        var found = null;
        (self.historyItems || []).forEach(function (x) { if (x.task_id === id) found = x; });
        if (!found) return;
        // 再次点击已选中的项 = 取消选中：按钮恢复「Start Customize」
        if (self.selected2d && self.selected2d.task_id === id) {
          self.selected2d = null;
          self.saveState();
          self.syncRecentSelection();
          self.updateResumeUI();
          return;
        }
        // 点击立刻给出选中高亮（无位移动画），最终选中态以会话恢复后的 syncRecentSelection 为准
        b.classList.add('is-selected');
        b.setAttribute('aria-pressed', 'true');
        self.select2dFromHistory(found);
      });
    }

    // 卡片下方的「最近生成」横条（design-box 专有）：点一张 → 选中为当前设计稿
    if (this.els.designRecentList) {
      this.els.designRecentList.addEventListener('click', function (e) {
        var b = e.target.closest('[data-design-recent-item]');
        if (!b) return;
        var id = b.getAttribute('data-design-recent-item');
        var found = null;
        (self.historyItems || []).forEach(function (x) { if (x && String(x.task_id) === String(id)) found = x; });
        if (!found) return;
        self.select2dFromHistory(found);
        self.renderDesignRecent();    // 重建后按新选中态刷高亮
        self.renderDesignStage();
      });
    }

    // face 纵向照片列：点选切换生图参考照片（不影响右侧结果选中态）
    if (this.els.designFaceList) {
      this.els.designFaceList.addEventListener('click', function (e) {
        var b = e.target.closest('[data-design-face-item]');
        if (!b) return;
        var key = b.getAttribute('data-design-face-item');
        if (!key || key === self.state.designPhotoKey) return;
        self.state.designPhotoKey = key;
        self.saveState();
        self.renderDesignStage();     // 只刷选中高亮；img2d（右侧结果选中）保持不变
      });
    }

    // 引导气泡关闭：记到 localStorage，之后不再打扰
    if (this.els.recentTourClose) {
      this.els.recentTourClose.addEventListener('click', function (e) {
        e.stopPropagation();
        try { window.localStorage.setItem('ai3d_recent_tour_dismissed', '1'); } catch (err) { /* 隐私模式忽略 */ }
        if (self.els.recentTour) self.els.recentTour.hidden = true;
      });
    }

    // gen buttons
    if (this.els.gen2dStart) this.els.gen2dStart.addEventListener('click', function () {
      // design-box：生成按钮即 AI 框主操作，先按标准表单当前变体建会话，再生成
      if (self.designBox) self.startDesignBoxGen();
      else self.runGen2D();
    });
    // 「生成中」面板的手动刷新：断网/切走页面导致拿不到结果时，
    // 任务其实多半已在服务端跑完，点一下立刻反查任务状态取回图片（不必重新生成、不重复扣费）
    if (this.els.gen2dRefresh) {
      this.els.gen2dRefresh.addEventListener('click', function () { self.recoverGen2dTask(); });
    }
    // 不满意可重刷 2D（再扣一次积分；3D 仍单向锁定）
    if (this.els.gen2dRegen) {
      this.els.gen2dRegen.addEventListener('click', function () { self.runGen2D(); });
    }
    // 「Your earlier portraits」缩略图：点选后与左侧当前大图互换，可来回切换
    if (this.els.gen2dHistoryList) {
      this.els.gen2dHistoryList.addEventListener('click', function (e) {
        var b = e.target.closest('[data-gen2d-history-item]');
        if (!b) return;
        self.selectGen2dHistory(parseInt(b.getAttribute('data-gen2d-history-item'), 10));
      });
      // 隐藏滚动条后靠右侧圆按钮翻页；滚动位置变化时同步按钮禁用态
      this.els.gen2dHistoryList.addEventListener('scroll', function () { self.syncGen2dHistoryNav(); });
    }
    if (this.els.gen2dHistoryPrev) {
      this.els.gen2dHistoryPrev.addEventListener('click', function () { self.scrollGen2dHistory(-1); });
    }
    if (this.els.gen2dHistoryNext) {
      this.els.gen2dHistoryNext.addEventListener('click', function () { self.scrollGen2dHistory(1); });
    }
    if (this.els.gen3dStart) this.els.gen3dStart.addEventListener('click', function () { self.runGen3D(); });
    // 格式转换下载按钮：按需调 Tripo convert 接口，轮询完成后触发浏览器下载
    Object.keys(this.els.convertBtns).forEach(function (fmt) {
      var btn = self.els.convertBtns[fmt];
      if (!btn) return;
      btn.addEventListener('click', function () { self.runConvert3D(fmt); });
    });
    if (this.els.addToCart) this.els.addToCart.addEventListener('click', function () { self.submitCart(); });
    // Step 4 摘要里的 3D 入口：点击才在共用预览 lightbox 里加载模型
    if (this.els.summary3d) {
      this.els.summary3d.addEventListener('click', function () {
        self.openModelPreview(self.els.summary3d.getAttribute('data-src'));
      });
    }
    if (this.designBox) this.initDesignBoxForm();
  };

  /* ---------- 3D 查看器控制条 ----------
   * Tripo 开放平台只返回模型文件（GLB），不提供可嵌入的查看器控件，
   * 因此在 <model-viewer> 上自建精简工具条：重置视角 / 左转 30° / 右转 30° / 逆时针自转 / 顺时针自转。
   * Step 4 摘要里的 86px 小模型不放控件（空间不足）。 */
  Customizer.prototype.initViewerControls = function () {
    // 光标：model-viewer 会在宿主元素上写行内 cursor:'grab'（拖拽时 'grabbing'），而且真正
    // 在鼠标下面的是它 shadow DOM 里的 <canvas>，canvas 上也有自己那份行内 grab —— 实测
    // canvas 的计算值就是 grab，它并不继承宿主的 pointer，所以只改宿主完全没有效果。
    // 只能靠「作者样式的 !important」压过行内普通声明（行内再设 !important 也会被 model-viewer
    // 之后的普通赋值连 priority 一起覆盖掉），并且从 JS 注入以摆脱「CSS 文件必须同步」的依赖。
    if (!document.getElementById('ai3d-mv-cursor')) {
      var st = document.createElement('style');
      st.id = 'ai3d-mv-cursor';
      st.textContent = 'model-viewer{cursor:pointer!important}';
      document.head.appendChild(st);
    }
    var self = this;
    var fixAll = function () {
      var list = self.root.querySelectorAll('model-viewer');
      for (var i = 0; i < list.length; i++) self.fixViewerCursor(list[i]);
    };
    fixAll();
    // 自定义元素升级完成后 shadow root 才存在，再补一次（Step 4 摘要里的 86px 小模型没有 load 兜底）
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('model-viewer').then(fixAll, function () {});
    }
    this.buildViewerControls(this.els.gen3dViewer);
    this.buildViewerControls(this.els.historyLightboxModel);
  };

  /* 往 model-viewer 的 shadow root 补一条 canvas 光标规则（未升级 / 已补过则跳过） */
  Customizer.prototype.fixViewerCursor = function (viewer) {
    var sr = viewer && viewer.shadowRoot;
    if (!sr || sr.getElementById('ai3d-cursor-style')) return;
    var s = document.createElement('style');
    s.id = 'ai3d-cursor-style';
    s.textContent = 'canvas{cursor:pointer!important}';
    sr.appendChild(s);
  };

  /* IBL 环境光预设：首项为空 = model-viewer 内建影棚光；其余 HDR 取自 google/model-viewer
     官方 shared-assets（modelviewer.dev 允许跨域引用），点击「环境」按钮循环切换 */
  Customizer.MV_ENV_PRESETS = [
    { name: 'Studio (default)', src: '' },
    { name: 'Park', src: 'https://modelviewer.dev/shared-assets/environments/whipple_creek_regional_park_04_1k.hdr' },
    { name: 'Workshop', src: 'https://modelviewer.dev/shared-assets/environments/aircraft_workshop_01_1k.hdr' },
    { name: 'Sunrise', src: 'https://modelviewer.dev/shared-assets/environments/spruit_sunrise_1k_HDR.hdr' },
    { name: 'Moonlight', src: 'https://modelviewer.dev/shared-assets/environments/moon_1k.hdr' }
  ];

  /* 背景预设色（前 12 色与 metool glbPreview 一致，外加「透明」） */
  Customizer.MV_BG_PRESETS = [
    '#dedede', '#ffffff', '#1a1a2e', '#0f3460', '#16213e', '#533483',
    '#e94560', '#f5f0e1', '#1b1b2f', '#2d4059', '#ea5455', '#7ec8e3'
  ];

  /* 仿 metool.online GLB Preview 的查看器浮层：
     顶部六向视图（正/背/顶/底/左/右）+ 底部暗色玻璃工具条
     （缩放 | 自转/线框/重置 | 截图/环境/光照/背景/全屏）。Step 4 摘要小模型不走这里。 */
  Customizer.prototype.buildViewerControls = function (viewer) {
    if (!viewer || viewer.getAttribute('data-mv-controls') === 'ready') return;
    viewer.setAttribute('data-mv-controls', 'ready');

    // 放开 model-viewer 默认的极角限制（22.5°~157.5°），否则「顶视/底视」只会停在斜角；
    // theta/radius 保持 auto（方位不限位、滚轮缩放维持默认可用区间）
    if (!viewer.getAttribute('min-camera-orbit')) viewer.setAttribute('min-camera-orbit', 'auto 0.001deg auto');
    if (!viewer.getAttribute('max-camera-orbit')) viewer.setAttribute('max-camera-orbit', 'auto 179.999deg auto');

    var self = this;

    var svg = function (inner) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"'
        + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + inner + '</svg>';
    };

    // 工具条按钮：顺序即展示顺序，sep = 分组竖分隔线；popup 表示点击弹面板而非立即动作
    var defs = [
      { act: 'zoomin', label: 'Zoom in',
        icon: svg('<circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/>') },
      { act: 'zoomout', label: 'Zoom out',
        icon: svg('<circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="8" y1="11" x2="14" y2="11"/>') },
      { sep: true },
      { act: 'rotate', label: 'Auto rotate', toggle: true,
        icon: svg('<polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>') },
      { act: 'wireframe', label: 'Wireframe', toggle: true,
        icon: svg('<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>') },
      { act: 'reset', label: 'Reset view',
        icon: svg('<polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>') },
      { sep: true },
      { act: 'shot', label: 'Save screenshot (PNG)',
        icon: svg('<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/>') },
      { act: 'env', label: 'Environment: Studio (default)',
        icon: svg('<circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>') },
      { act: 'light', label: 'Lighting', popup: 'light',
        icon: svg('<line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/>') },
      { act: 'color', label: 'Background color', popup: 'color',
        icon: svg('<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>') },
      { act: 'full', label: 'Fullscreen',
        icon: svg('<path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M21 8V5a2 2 0 0 0-2-2h-3"/><path d="M3 16v3a2 2 0 0 0 2 2h3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/>') }
    ];

    // 用相对定位容器包住查看器，所有浮层都挂在容器上
    var wrap = document.createElement('div');
    wrap.className = 'ai3d-mv-wrap';
    viewer.parentNode.insertBefore(wrap, viewer);
    wrap.appendChild(viewer);

    // 顶部六向视图胶囊
    var viewDefs = [['front', 'Front'], ['back', 'Back'], ['top', 'Top'], ['bottom', 'Bottom'], ['left', 'Left'], ['right', 'Right']];
    var views = document.createElement('div');
    views.className = 'ai3d-mv-views';
    views.setAttribute('role', 'group');
    views.setAttribute('aria-label', 'Quick views');
    var vh = '';
    for (var vi = 0; vi < viewDefs.length; vi++) {
      vh += '<button type="button" class="ai3d-mv-view" data-view="' + viewDefs[vi][0] + '">' + viewDefs[vi][1] + '</button>';
    }
    views.innerHTML = vh;
    wrap.appendChild(views);

    // 底部主工具条：外壳负责定位/弹层，内层在窄屏横向滚动（不出现滚动条）
    var bar = document.createElement('div');
    bar.className = 'ai3d-mv-controls';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', '3D model controls');
    var inner = document.createElement('div');
    inner.className = 'ai3d-mv-controls__inner';
    var html = '';
    for (var i = 0; i < defs.length; i++) {
      var d = defs[i];
      if (d.sep) { html += '<span class="ai3d-mv-divider" aria-hidden="true"></span>'; continue; }
      var popup = d.popup ? ' data-popup-open="' + d.popup + '" aria-haspopup="true"' : '';
      var pressed = d.toggle ? ' aria-pressed="false"' : '';
      html += '<button type="button" class="ai3d-mv-btn" data-mv-act="' + d.act + '"'
        + popup + pressed + ' aria-label="' + d.label + '" title="' + d.label + '">' + d.icon + '</button>';
    }
    inner.innerHTML = html;
    bar.appendChild(inner);

    // 背景色 / 光照 两个弹出面板（定位在工具条上方）
    var swatchHtml = '<button type="button" class="ai3d-mv-swatch is-transparent" data-bg="" title="Transparent"></button>';
    for (var bi = 0; bi < Customizer.MV_BG_PRESETS.length; bi++) {
      var hex = Customizer.MV_BG_PRESETS[bi];
      swatchHtml += '<button type="button" class="ai3d-mv-swatch" data-bg="' + hex + '" style="background:' + hex + '" title="' + hex + '"></button>';
    }
    var popColor = document.createElement('div');
    popColor.className = 'ai3d-mv-popup';
    popColor.setAttribute('data-popup-panel', 'color');
    popColor.innerHTML = '<div class="ai3d-mv-pop-title">Background</div>'
      + '<div class="ai3d-mv-swatches">' + swatchHtml + '</div>'
      + '<div class="ai3d-mv-pop-row"><label>Custom</label><input type="color" data-bg-custom value="#dedede"></div>';
    bar.appendChild(popColor);

    function sliderRow(key, label, min, max, step) {
      return '<div class="ai3d-mv-pop-row"><label>' + label + '</label>'
        + '<input type="range" data-light="' + key + '" min="' + min + '" max="' + max + '" step="' + step + '"></div>';
    }
    var popLight = document.createElement('div');
    popLight.className = 'ai3d-mv-popup';
    popLight.setAttribute('data-popup-panel', 'light');
    popLight.innerHTML = '<div class="ai3d-mv-pop-title">Lighting</div>'
      + sliderRow('exposure', 'Exposure', '0.2', '2', '0.05')
      + sliderRow('shadow', 'Shadow intensity', '0', '2', '0.05')
      + sliderRow('softness', 'Shadow softness', '0', '1', '0.05');
    bar.appendChild(popLight);
    wrap.appendChild(bar);

    // 加载进度浮层：浅色底上默认白色细进度条几乎看不见，改成居中圆环 + 圆心百分比
    var load = document.createElement('div');
    load.className = 'ai3d-mv-load';
    load.hidden = true;
    load.innerHTML = '<span class="ai3d-mv-load__ring">'
      + '<span class="ai3d-ring-spinner ai3d-ring-spinner--lg"></span>'
      + '<span class="ai3d-mv-load__pct">0%</span></span>';
    wrap.appendChild(load);

    var pctEl = load.querySelector('.ai3d-mv-load__pct');
    var setLoad = function (on, pct) {
      if (!on) { load.hidden = true; return; }
      load.hidden = false;
      var v = Math.round(pct || 0);
      if (pctEl) pctEl.textContent = (v < 1 ? 1 : (v > 100 ? 100 : v)) + '%';
    };
    // 用「已加载完的地址」收尾：model-viewer 到 100% 后还会补发一次 progress，必须忽略
    var doneSrc = '(none)';
    var srcNow = function () { return viewer.src || viewer.getAttribute('src') || ''; };

    viewer.addEventListener('progress', function (ev) {
      var dd = ev.detail || {};
      var p = typeof dd.totalProgress === 'number' ? dd.totalProgress : 0;
      var cur = srcNow();
      if (cur && cur === doneSrc) return;
      if (p >= 1) { doneSrc = cur; setLoad(false); return; }
      setLoad(true, p * 100);
    });

    function syncToggle(act, on) {
      var b = inner.querySelector('[data-mv-act="' + act + '"]');
      if (!b) return;
      b.classList.toggle('is-active', !!on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    function syncColorPanel() {
      var cur = viewer.__mvBg || '';
      popColor.querySelectorAll('[data-bg]').forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-bg') === cur);
      });
    }
    function syncLightPanel() {
      var vals = {
        exposure: viewer.exposure !== undefined ? viewer.exposure : 1,
        shadow: viewer.shadowIntensity !== undefined ? viewer.shadowIntensity : 1,
        softness: viewer.shadowSoftness !== undefined ? viewer.shadowSoftness : 1
      };
      popLight.querySelectorAll('[data-light]').forEach(function (r) {
        var k = r.getAttribute('data-light');
        if (vals[k] !== undefined && vals[k] !== null) r.value = vals[k];
      });
    }
    function closePopups() {
      popColor.classList.remove('is-open');
      popLight.classList.remove('is-open');
    }
    function openPopup(name) {
      closePopups();
      if (name === 'color') { syncColorPanel(); popColor.classList.add('is-open'); }
      if (name === 'light') { syncLightPanel(); popLight.classList.add('is-open'); }
    }
    function setBg(hex) {
      viewer.style.backgroundColor = hex || '';
      viewer.__mvBg = hex || '';
      syncColorPanel();
    }
    function applyLight(key, val) {
      var v = parseFloat(val);
      if (!isFinite(v)) return;
      if (key === 'exposure') viewer.exposure = v;
      else if (key === 'shadow') viewer.shadowIntensity = v;
      else if (key === 'softness') viewer.shadowSoftness = v;
    }

    viewer.addEventListener('load', function () {
      doneSrc = srcNow(); setLoad(false); self.fixViewerCursor(viewer);
      // 记录默认取景距离作为缩放基准；新模型材质是新的，线框开关要按当前状态重放
      var oo = self.readOrbit(viewer);
      viewer.__mvBaseRadius = oo ? oo.radius : 0;
      if (viewer.__wire) self.setWireframe(viewer, true);
    });
    viewer.addEventListener('error', function () { doneSrc = srcNow(); setLoad(false); });

    // 初始开关态：模型默认 auto-rotate（HTML 上带 auto-rotate 属性）
    syncToggle('rotate', !!viewer.autoRotate);
    syncToggle('wireframe', false);

    // 点击浮层控件：不冒泡到 3D 弹窗（否则会关弹窗）；点在模型本身则放行
    wrap.addEventListener('click', function (e) {
      if (viewer === e.target || (viewer.contains && viewer.contains(e.target))) return;
      e.stopPropagation();
      var t = e.target;
      if (!t || !t.closest) return;

      var popBtn = t.closest('[data-popup-open]');
      if (popBtn) {
        var name = popBtn.getAttribute('data-popup-open');
        var panel = name === 'color' ? popColor : popLight;
        if (panel.classList.contains('is-open')) closePopups(); else openPopup(name);
        return;
      }

      // 色块是普通按钮，直接在此处理（range/color 输入走下面的 input 事件委托）
      var sw = t.closest('[data-bg]');
      if (sw) { setBg(sw.getAttribute('data-bg') || ''); return; }

      var vb = t.closest('[data-view]');
      if (vb) { self.applyView(viewer, vb.getAttribute('data-view')); return; }

      var btn = t.closest('[data-mv-act]');
      if (btn) self.applyViewerAction(viewer, btn.getAttribute('data-mv-act'), btn);
    });

    // 自定义颜色 / 光照滑块（input 实时生效）
    bar.addEventListener('input', function (e) {
      var t = e.target;
      if (!t || !t.hasAttribute) return;
      if (t.hasAttribute('data-bg-custom')) setBg(t.value);
      if (t.hasAttribute('data-light')) applyLight(t.getAttribute('data-light'), t.value);
    });

    // 点到浮层外面自动收起面板。
    // 经 bindGlobal 登记：主题编辑器局部刷新 section 时 destroy() 会成对移除，
    // 否则监听器滞留 document 并一直持有已脱离文档的 wrap/查看器闭包
    function onDocPointerDown(e) {
      if (!wrap.contains(e.target)) closePopups();
    }
    this.bindGlobal(document, 'pointerdown', onDocPointerDown);

    // 全屏态切换按钮图标/高亮（同样登记到 bindGlobal，destroy 时移除）
    function onFsChange() {
      var fs = document.fullscreenElement === wrap || document.webkitFullscreenElement === wrap;
      syncToggle('full', fs);
      var b = inner.querySelector('[data-mv-act="full"]');
      if (b) b.title = fs ? 'Exit fullscreen' : 'Fullscreen';
    }
    this.bindGlobal(document, 'fullscreenchange', onFsChange);
    this.bindGlobal(document, 'webkitfullscreenchange', onFsChange);
  };

  /* 读取当前相机轨道：theta/phi 为弧度，radius 为相对取景距离的比例 */
  Customizer.prototype.readOrbit = function (viewer) {
    if (!viewer || typeof viewer.getCameraOrbit !== 'function') return null;
    try {
      var o = viewer.getCameraOrbit();
      if (!o) return null;
      return { theta: o.theta, phi: o.phi, radius: o.radius };
    } catch (e) { return null; }
  };

  Customizer.prototype.applyOrbit = function (viewer, o) {
    if (!viewer || !o) return;
    // 与 CameraOrbitValue.toString() 同格式；radius 必须带 m 单位，裸数字会被整条判为无效
    viewer.cameraOrbit = o.theta + 'rad ' + o.phi + 'rad ' + o.radius + 'm';
    if (typeof viewer.jumpCameraToGoal === 'function') viewer.jumpCameraToGoal();
  };

  /* 缓动到目标轨道，避免直接跳变；done 在动画结束（或退化为直跳）后回调。
     连续触发时以最新一次为准，旧动画自动作废。 */
  Customizer.prototype.animateOrbit = function (viewer, target, done) {
    var from = this.readOrbit(viewer);
    if (!from || !window.requestAnimationFrame) { this.applyOrbit(viewer, target); if (done) done(); return; }
    var self = this;
    var token = (viewer.__mvTween || 0) + 1;
    viewer.__mvTween = token;
    var t0 = null, dur = 320;
    var step = function (ts) {
      if (viewer.__mvTween !== token) return;
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);   // easeOutCubic
      self.applyOrbit(viewer, {
        theta: from.theta + (target.theta - from.theta) * e,
        phi: from.phi + (target.phi - from.phi) * e,
        radius: from.radius + (target.radius - from.radius) * e
      });
      if (p < 1) window.requestAnimationFrame(step);
      else if (done) done();
    };
    window.requestAnimationFrame(step);
  };

  /* 工具条动作分发（btn 为被点按钮，用于开关态高亮/标题更新） */
  Customizer.prototype.applyViewerAction = function (viewer, act, btn) {
    if (!viewer) return;

    // 放大 / 缩小：以默认取景距离为基准夹取，直接跳变（滚轮仍由 model-viewer 自身处理）
    if (act === 'zoomin' || act === 'zoomout') {
      var o = this.readOrbit(viewer);
      if (!o) return;
      var base = viewer.__mvBaseRadius || o.radius;
      var r = act === 'zoomin' ? o.radius * 0.8 : o.radius * 1.25;
      r = Math.max(base * 0.25, Math.min(base * 4, r));
      this.applyOrbit(viewer, { theta: o.theta, phi: o.phi, radius: r });
      return;
    }

    // 自动旋转开关：直接用 model-viewer 内建 autoRotate（拖拽时它会自动暂停/恢复）
    if (act === 'rotate') {
      viewer.autoRotate = !viewer.autoRotate;
      var on = !!viewer.autoRotate;
      if (btn) { btn.classList.toggle('is-active', on); btn.setAttribute('aria-pressed', on ? 'true' : 'false'); }
      return;
    }

    // 线框模式：遍历已加载模型的所有 three.js 材质切换 wireframe
    if (act === 'wireframe') {
      var wire = !viewer.__wire;
      this.setWireframe(viewer, wire);
      if (btn) { btn.classList.toggle('is-active', wire); btn.setAttribute('aria-pressed', wire ? 'true' : 'false'); }
      return;
    }

    // 重置视角：清掉手动相机轨道回到默认取景（自转开关状态保持用户选择不变）
    if (act === 'reset') {
      viewer.removeAttribute('camera-orbit');
      if (typeof viewer.resetTurntableRotation === 'function') viewer.resetTurntableRotation();
      if (typeof viewer.jumpCameraToGoal === 'function') viewer.jumpCameraToGoal();
      return;
    }

    if (act === 'shot') { this.snapshotViewer(viewer); return; }
    if (act === 'env') { this.cycleEnvironment(viewer, btn); return; }
    if (act === 'full') { this.toggleFullscreen(viewer); return; }
  };

  /* 六向正交视角：theta=方位角（0=正），phi=极角（0=顶，90°=水平，180°=底） */
  Customizer.prototype.applyView = function (viewer, view) {
    var o = this.readOrbit(viewer);
    if (!o) return;
    var D = Math.PI / 180;
    var map = {
      front: { theta: 0, phi: 90 * D },
      back: { theta: 180 * D, phi: 90 * D },
      right: { theta: 90 * D, phi: 90 * D },
      left: { theta: 270 * D, phi: 90 * D },
      top: { theta: 0, phi: 0.5 * D },
      bottom: { theta: 0, phi: 179.5 * D }
    };
    var t = map[view];
    if (!t) return;
    // 缓动期间自转若开着会和动画抢相机，先关掉、结束后恢复
    var wasAuto = viewer.autoRotate;
    viewer.autoRotate = false;
    this.animateOrbit(viewer, { theta: t.theta, phi: t.phi, radius: o.radius }, function () {
      viewer.autoRotate = wasAuto;
    });
  };

  /* 切换线框：model-viewer 3.5 的 model 是场景门面而非 three Object3D（没有 traverse），
     model.materials 是材质门面数组，原生 three 材质藏在 symbol 键 $backingThreeMaterial 上。
     模型未加载时先记住状态，load 事件里会按状态重放。 */
  Customizer.prototype.setWireframe = function (viewer, on) {
    viewer.__wire = !!on;
    var model = viewer && viewer.model;
    if (!model || !model.materials) return;
    for (var i = 0; i < model.materials.length; i++) {
      var threeMat = this.getBackingThreeMaterial(model.materials[i]);
      if (threeMat) { threeMat.wireframe = on; threeMat.needsUpdate = true; }
    }
  };

  /* 从 model-viewer 材质门面上取原生 three 材质：
     $backingThreeMaterial 是原型上的 symbol getter，按 three 材质独有的 isMaterial 特征找，
     不写死 symbol 描述，版本小升级也不易碎。 */
  Customizer.prototype.getBackingThreeMaterial = function (mvMaterial) {
    var target = mvMaterial;
    for (var depth = 0; target && depth < 4; depth++, target = Object.getPrototypeOf(target)) {
      var syms = Object.getOwnPropertySymbols(target);
      for (var i = 0; i < syms.length; i++) {
        try {
          var val = mvMaterial[syms[i]];
          if (val && val.isMaterial === true) return val;
        } catch (e) { /* 个别 getter 可能在未加载时抛错，继续找下一个 */ }
      }
    }
    return null;
  };

  /* 截图：优先用 model-viewer 的 toDataURL（保留透明背景），失败再从 shadow canvas 抓 */
  Customizer.prototype.snapshotViewer = function (viewer) {
    var url = '';
    try {
      if (viewer && typeof viewer.toDataURL === 'function') url = viewer.toDataURL('image/png');
    } catch (e) { url = ''; }
    if (!url && viewer && viewer.shadowRoot) {
      var canvas = viewer.shadowRoot.querySelector('canvas');
      if (canvas) { try { url = canvas.toDataURL('image/png'); } catch (e2) { url = ''; } }
    }
    if (!url) return;
    var a = document.createElement('a');
    a.href = url;
    a.download = 'bobblegifts-3d-' + Date.now() + '.png';
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  /* 循环切换 IBL 环境光预设，按钮 title 同步当前预设名 */
  Customizer.prototype.cycleEnvironment = function (viewer, btn) {
    var presets = Customizer.MV_ENV_PRESETS;
    var idx = (((viewer.__envIdx || 0) + 1) % presets.length + presets.length) % presets.length;
    viewer.__envIdx = idx;
    var p = presets[idx];
    if (p.src) viewer.setAttribute('environment-image', p.src);
    else viewer.removeAttribute('environment-image');
    if (btn) btn.title = 'Environment: ' + p.name;
  };

  /* 查看器容器全屏（含 webkit 前缀兜底） */
  Customizer.prototype.toggleFullscreen = function (viewer) {
    var wrap = viewer && viewer.parentNode;
    if (!wrap || !wrap.classList || !wrap.classList.contains('ai3d-mv-wrap')) return;
    var active = document.fullscreenElement === wrap || document.webkitFullscreenElement === wrap;
    if (active) {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
    } else if (wrap.requestFullscreen) {
      wrap.requestFullscreen();
    } else if (wrap.webkitRequestFullscreen) {
      wrap.webkitRequestFullscreen();
    }
  };

  Customizer.prototype.initGallery = function () {
    var root = this.root;
    var mainImg = $(root, '.ai3d-gallery__main img');
    $all(root, '.ai3d-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        $all(root, '.ai3d-thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (mainImg) mainImg.src = t.getAttribute('data-full');
      });
    });
  };

  /* 风格卡片单行横滚：左右箭头点击移动，到两端自动禁用；不溢出时两端都隐藏 */
  Customizer.prototype.initStyleRail = function () {
    var owner = this;
    this._rails = [];
    $all(this.root, '[data-style-rail]').forEach(function (rail) {
      var view = rail.querySelector('.ai3d-style-grid');
      var prev = rail.querySelector('[data-style-prev]');
      var next = rail.querySelector('[data-style-next]');
      if (!view || !prev || !next) return;

      function update() {
        var overflow = view.scrollWidth > view.clientWidth + 2;
        rail.classList.toggle('has-overflow', overflow);
        prev.disabled = !overflow || view.scrollLeft <= 2;
        next.disabled = !overflow || view.scrollLeft >= view.scrollWidth - view.clientWidth - 2;
      }
      function scrollByDir(dir) {
        view.scrollBy({ left: dir * Math.max(view.clientWidth * 0.8, 240), behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { scrollByDir(-1); });
      next.addEventListener('click', function () { scrollByDir(1); });
      view.addEventListener('scroll', update, { passive: true });
      owner.bindGlobal(window, 'resize', update);
      // 图片懒加载可能改变 scrollWidth，加载完后重算一次
      view.addEventListener('load', update, true);
      owner._rails.push(update);
      setTimeout(update, 0);
      setTimeout(update, 600);
    });
  };
  /* 弹窗内的风格条初始处于 hidden 容器中，量到的宽度为 0，会被判成「不溢出」而不出箭头；
     弹窗打开后再量一次（并等一帧让布局完成）。 */
  Customizer.prototype.refreshStyleRails = function () {
    var rails = this._rails || [];
    function run() {
      rails.forEach(function (fn) { try { fn(); } catch (e) {} });
    }
    run();
    setTimeout(run, 0);
    setTimeout(run, 320);
  };

  /* 拖拽上传：弹窗打开时整个弹窗都是投放区（Step 1 才接收文件），
     window 级阻止默认行为，杜绝拖入文件导致浏览器跳转/打开图片 */
  Customizer.prototype.initDragDrop = function () {
    var self = this;
    // design-box 没有四步弹窗：拖拽作用域回退到设计弹窗 + 页面（弹窗内）上传区
    var modal = this.els.modal || this.els.designModal;
    var zone = this.els.uploadZone || this.els.pageUploadZone;
    if (!modal || !zone) return;
    var depth = 0;

    function isFileDrag(e) {
      if (!e.dataTransfer) return false;
      var types = e.dataTransfer.types;
      if (types && Array.prototype.indexOf.call(types, 'Files') >= 0) return true;
      // Safari 在 dragover 阶段可能拿不到 types，退一步看 items
      var items = e.dataTransfer.items;
      if (items && items.length) {
        for (var i = 0; i < items.length; i++) {
          if (items[i] && items[i].kind === 'file') return true;
        }
      }
      return false;
    }
    // 当前是否允许接收照片（Step 1、未生成 2D、名额未满）
    function canAccept() {
      return (self.state.step || 1) === 1 && !self.has2d() && self.photoCount() < self.maxPhotos();
    }
    // 从 dataTransfer 取文件：优先 files，部分浏览器回退 items
    function filesFrom(dt) {
      if (!dt) return [];
      if (dt.files && dt.files.length) return dt.files;
      var out = [];
      if (dt.items) {
        for (var i = 0; i < dt.items.length; i++) {
          var it = dt.items[i];
          if (it && it.kind === 'file') { var f = it.getAsFile(); if (f) out.push(f); }
        }
      }
      return out;
    }
    function clearHighlight() {
      depth = 0;
      zone.classList.remove('is-drag');
    }

    // 弹窗打开期间：拦截 window 默认行为（防止浏览器直接打开/下载拖入的文件）。
    // 不依赖 types 判断（部分浏览器 dragover 阶段拿不到 types），只在弹窗打开时统一拦截。
    // 用具名引用注册，destroy() 时可成对移除，避免监听器滞留 window
    function blockWindowDefault(e) {
      if (modal.hidden) return;
      e.preventDefault();
    }
    this.bindGlobal(window, 'dragover', blockWindowDefault);
    this.bindGlobal(window, 'drop', blockWindowDefault);

    // 关键：dragenter / dragover 必须 preventDefault，浏览器才允许 drop。
    // 不能拿 isFileDrag 当前置条件（Safari 的 dragover 阶段 types 可能为空，会导致 drop 永远不触发）。
    function onDragEnter(e) {
      if (modal.hidden) return;
      e.preventDefault();
      if (!isFileDrag(e)) return;      // 只影响是否高亮，不影响能否 drop
      depth++;
      if (canAccept()) zone.classList.add('is-drag');
    }
    function onDragOver(e) {
      if (modal.hidden) return;
      e.preventDefault();
      if (e.dataTransfer) e.dataTransfer.dropEffect = canAccept() ? 'copy' : 'none';
    }
    function onDragLeave(e) {
      if (!isFileDrag(e)) return;
      depth--;
      if (depth <= 0) clearHighlight();
    }
    function onDrop(e) {
      if (modal.hidden) return;
      e.preventDefault();
      e.stopPropagation();             // 本处已处理，阻止冒泡到上层再处理一次（避免重复上传）
      clearHighlight();
      var files = filesFrom(e.dataTransfer);
      // 只有 Step 1、未生成 2D、名额未满时接收文件（可一次拖入多张）；其它步骤仅消费事件（不跳转）
      if (!canAccept()) return;
      if (files && files.length) self.handleFiles(files);
      else if (self.els.uploadError) self.showError(self.els.uploadError, t('err.drop_no_file'));
    }
    // 弹窗级：整个弹窗可投放；投放区级：直投上传框时再绑一份，确保悬停/投放落在上传框时一定被处理
    modal.addEventListener('dragenter', onDragEnter);
    modal.addEventListener('dragover', onDragOver);
    modal.addEventListener('dragleave', onDragLeave);
    modal.addEventListener('drop', onDrop);
    zone.addEventListener('dragover', onDragOver);
    zone.addEventListener('drop', onDrop);
  };

  Customizer.prototype.renderGuides = function () {
    var g = this.preset;
    var titleEl = $(this.root, '[data-guide-title]');
    if (titleEl && g.uploadGuideTitle) titleEl.textContent = g.uploadGuideTitle;
    // design-box 不展示拍摄要求（页面只保留定制卡片），没有该节点时直接跳过
    var ul = $(this.root, '[data-guide-list]');
    if (!ul) return;
    (g.uploadGuideItems || []).forEach(function (t) {
      if (!t) return;
      var li = document.createElement('li'); li.textContent = t; ul.appendChild(li);
    });
  };

  /* 商品维度配置的键：优先商品 handle，其次数字 ID；都取不到就不传（Worker 也不会下发） */
  Customizer.prototype.productDesignKey = function () {
    var p = this.preset || {};
    return String(p.productHandle || p.productId || '').trim();
  };

  Customizer.prototype.initVerify = function () {
    var self = this;
    // 后台配置的 prompts/场景包/价格优先（失败不影响主流程，回退主题设置）
    this.configPromise = this.api.publicConfig(this.locale, this.productDesignKey()).then(function (d) {
      // 第 3 步开关先定：主题设置优先（构造时已赋值）；只有旧主题缺该设置时才看 Worker 配置。
      // 放在最前面 + 单独同步，保证后面任何渲染出错都不会让流程退回 4 步
      if (self.gen3dFromTheme === null) {
        self.gen3dEnabled = self.designBox ? false : !(d && d.gen3d_enabled === false);
      }
      self.syncGen3dStep();
      if (d && d.style_prompts && Object.keys(d.style_prompts).length) self.serverPrompts = d.style_prompts;
      if (d && d.style_refs && typeof d.style_refs === 'object') self.serverStyleRefs = d.style_refs;
      // 姿态：后台按风格绑定的姿态提示词 / 姿态参考图（键 = Style 变体值）
      if (d && d.style_pose_prompts && typeof d.style_pose_prompts === 'object') self.serverPosePrompts = d.style_pose_prompts;
      if (d && d.style_pose_refs && typeof d.style_pose_refs === 'object') self.serverPoseRefs = d.style_pose_refs;
      if (d && d.default_size) self.defaultSize = String(d.default_size);
      if (d && d.default_background) self.defaultBackground = String(d.default_background);
      // 本商品的定制配置（快捷标签 / 默认提示词 / 参考图 / 锁定内容）：命中才下发，缺省沿用主题 Section
      if (self.designBox && d && d.product_design && typeof d.product_design === 'object') {
        self.productDesign = d.product_design;
        self.applyProductDesign();
      }
      if (d && d.scene_presets && typeof d.scene_presets === 'object') self.serverScenes = d.scene_presets;
      // Figure 变体设置（变体值 → 类型 + 照片张数 + 多语言显示名）：到达后覆盖 Liquid 关键词推断的 data-* 属性并重算照片槽位
      if (d && d.figure_configs && typeof d.figure_configs === 'object') {
        self.figureConfigs = d.figure_configs;
        self.applyFigureConfigs();
        self.applyFigureLabels();
      }
      if (d && d.points_earn && typeof d.points_earn === 'object') self.earnBonus = d.points_earn;
      // Step 4 加价展示：基准组合与个别值覆盖（后台配置，缺省自动算差额）
      if (d && d.price_delta && typeof d.price_delta === 'object') {
        if (d.price_delta.base === 'lowest') self.priceDeltaBaseMode = 'lowest';
        if (d.price_delta.overrides && typeof d.price_delta.overrides === 'object') self.priceDeltaOverrides = d.price_delta.overrides;
      }
      // 当前语种界面文案（全量下发）；风格展示名（键 = Style 变体值，缺则回退变体值）
      UI_MAP = (d && d.ui && typeof d.ui === 'object') ? d.ui : {};
      self.styleDisplay = (d && d.style_display && typeof d.style_display === 'object') ? d.style_display : {};
      self.applyI18n();
      // 3D 开关会影响积分文案（是否出现 3D 价格 / 保留积分提示），配置到达后重渲染一次
      self.renderCredits();
      self.updateResumeUI();
      return d;
    }).catch(function (e) { self.configPromise = null; throw e; });
    this.configPromise.catch(function () {});

    this.api.verify().then(function (d) {
      self.apiReady = true;
      self.balance = d.points_balance;
      if (d.config && d.config.costs) {
        self.cost2d = d.config.costs.generate_2d;
        self.cost3d = d.config.costs.generate_3d;
      }
      self.renderCredits();
      self.refreshResumeButton();
      // 已登录顾客：领取注册/每日登录奖励，并把匿名钱包余额与生成历史并入账号
      if (self.customerId) self.claimEarnedPoints();
    }).catch(function (err) {
      console.warn('[AI3D] verify failed:', err.message);
    });
  };

  /* 领取积分（注册一次性 + 每日首次登录 + 匿名钱包合并）；失败静默，不影响主流程 */
  Customizer.prototype.claimEarnedPoints = function () {
    var self = this;
    return this.api.claimPoints('auto').then(function (p) {
      if (p && typeof p.balance === 'number') {
        self.balance = p.balance;
        self.renderCredits();
      }
    }).catch(function () {});
  };

  /* ---------- 主图下方「我的生成历史」（该身份在本店的全部 2D/3D 生成） ---------- */
  Customizer.prototype.initHistory = function () {
    var self = this;
    if (!this.els.history) return;

    // 历史弹窗与放大层原本在 .product-photos 内，而该列在桌面是 position:sticky，
    // sticky 会创建层叠上下文，把浮层的 z-index 困在内部 → 被「定制」弹窗（z-index:9990）盖住。
    // 移到 .ai3d-product 下（与 .ai3d-modal 同级，且仍继承 --ai3d-* 变量）即彻底脱离该上下文。
    var stage = this.root.querySelector('[data-ai3d-product]');
    if (stage) {
      if (this.els.history.parentNode !== stage) stage.appendChild(this.els.history);
      if (this.els.historyLightbox && this.els.historyLightbox.parentNode !== stage) {
        stage.appendChild(this.els.historyLightbox);
      }
    }

    // 产品页「Recent history」入口：把同一块历史列表切成弹窗展示（数据/勾选/删除逻辑共用）
    // 入口可能有多个（卡片头 + 卡片下方最近横条的「View all」），逐个绑定
    $all(this.root, '[data-history-open]').forEach(function (el) {
      el.addEventListener('click', function () { self.openHistoryPopup(); });
    });
    // 弹窗态：点遮罩或按 Esc 关闭
    this.els.history.addEventListener('click', function (e) {
      if (e.target === self.els.history) self.closeHistoryPopup();
    });
    this.bindGlobal(document, 'keydown', function (e) {
      if (e.key === 'Escape' && self.els.history.classList.contains('is-modal')) self.closeHistoryPopup();
    });
    // 弹窗态的关闭按钮
    var historyClose = this.els.history.querySelector('[data-history-close]');
    if (historyClose) {
      historyClose.addEventListener('click', function () { self.closeHistoryPopup(); });
    }

    if (this.els.historyGrid) {
      // 勾选（change 委托）：label 内任意位置点击都能可靠触发
      this.els.historyGrid.addEventListener('change', function (e) {
        var chk = e.target.closest('[data-history-check]');
        if (!chk) return;
        var id = chk.getAttribute('data-history-check');
        if (chk.checked) self.historySelected[id] = true;
        else delete self.historySelected[id];
        var card = chk.closest('.ai3d-history__card');
        if (card) {
          if (chk.checked) card.classList.add('is-selected');
          else card.classList.remove('is-selected');
        }
        self.updateHistoryActions();
      });
      // 点击卡片：2D 放大预览 / 3D 新标签打开模型页（勾选框区域除外）
      this.els.historyGrid.addEventListener('click', function (e) {
        if (e.target.closest('.ai3d-history__check')) return;
        var card = e.target.closest('[data-history-item]');
        if (card) self.openHistoryItem(card.getAttribute('data-history-item'));
      });
    }

    // 「删除所选」：仅软隐藏，后台与订单图片不受影响
    if (this.els.historyDelete) {
      this.els.historyDelete.addEventListener('click', function () {
        var ids = Object.keys(self.historySelected);
        if (!ids.length) return;
        self.confirmDialog(t('history.confirm_delete', { n: ids.length }), function () {
          self.hideHistoryItems(ids);
        });
      });
    }

    // 「全选」：勾选全部历史条目（与 renderHistory 同样过滤掉 kind=3D），同步卡片勾选态与高亮
    if (this.els.historySelectAll) {
      this.els.historySelectAll.addEventListener('click', function () {
        var items = (self.historyItems || []).filter(function (it) { return it && it.kind !== '3d'; });
        if (!items.length) return;
        items.forEach(function (it) { self.historySelected[it.task_id] = true; });
        Array.prototype.forEach.call(self.els.historyGrid.querySelectorAll('[data-history-check]'), function (chk) {
          chk.checked = true;
          var card = chk.closest('.ai3d-history__card');
          if (card) card.classList.add('is-selected');
        });
        self.updateHistoryActions();
      });
    }

    // 「取消全选」：清空所有勾选与高亮
    if (this.els.historyDeselectAll) {
      this.els.historyDeselectAll.addEventListener('click', function () {
        self.historySelected = {};
        Array.prototype.forEach.call(self.els.historyGrid.querySelectorAll('[data-history-check]'), function (chk) {
          chk.checked = false;
          var card = chk.closest('.ai3d-history__card');
          if (card) card.classList.remove('is-selected');
        });
        self.updateHistoryActions();
      });
    }

    // 「全部清空」：仅软隐藏
    if (this.els.historyClear) {
      this.els.historyClear.addEventListener('click', function () {
        if (!self.historyItems || !self.historyItems.length) return;
        self.confirmDialog(t('history.confirm_clear'), function () {
          self.hideHistoryItems(null);
        });
      });
    }

    if (this.els.historyLightbox) {
      this.els.historyLightbox.addEventListener('click', function (e) {
        // 点在 3D 模型上（拖动旋转/缩放）不关闭弹窗
        if (e.target && e.target.closest && e.target.closest('[data-history-lightbox-model]')) return;
        self.closeHistoryLightbox();
      });
      this.bindGlobal(document, 'keydown', function (e) {
        if (e.key === 'Escape') self.closeHistoryLightbox();
      });
    }

    // Step 2 结果缩略图：点击全屏预览；预览层点击任意处（含图片）关闭
    if (this.els.gen2dZoom) {
      this.els.gen2dZoom.addEventListener('click', function (e) {
        e.preventDefault();
        self.openGen2dPreview();
      });
    }
    if (this.els.gen2dLightbox) {
      this.els.gen2dLightbox.addEventListener('click', function () { self.closeGen2dPreview(); });
      this.bindGlobal(document, 'keydown', function (e) {
        if (e.key === 'Escape') self.closeGen2dPreview();
      });
    }
    // 放大预览底部的「继续定制」：按该条历史记录所在的会话精准恢复，而不是回到最近一次定制
    if (this.els.historyLightboxContinue) {
      this.els.historyLightboxContinue.addEventListener('click', function (e) {
        e.stopPropagation();
        self.continueFromHistory(self._historyOpenItem);
      });
    }

    this.applyHistoryTexts();
    this.loadHistory();
  };

  Customizer.prototype.applyHistoryTexts = function () {
    if (!this.els.history) return;
    if (this.els.historyTitle) this.els.historyTitle.textContent = t('history.title');
    if (this.els.historyHint) this.els.historyHint.textContent = t('history.subtitle');
    if (this.els.historyClear) this.els.historyClear.textContent = t('history.clear_all');
    if (this.els.historySelectAll) this.els.historySelectAll.textContent = t('history.select_all');
    if (this.els.historyDeselectAll) this.els.historyDeselectAll.textContent = t('history.deselect_all');
    if (this.els.historyLightboxContinue) this.els.historyLightboxContinue.textContent = t('history.continue');
    this.updateHistoryActions();
  };

  Customizer.prototype.updateHistoryActions = function () {
    var ids = this.historySelected ? Object.keys(this.historySelected) : [];
    // 历史条目与 renderHistory 同样过滤掉 kind=3d（网格只显示 2D）
    var items = (this.historyItems || []).filter(function (it) { return it && it.kind !== '3d'; });
    if (this.els.historyDelete) {
      this.els.historyDelete.hidden = ids.length === 0;
      this.els.historyDelete.textContent = t('history.delete_selected', { n: ids.length });
    }
    // 全选：无条目或全部已选时隐藏（与删除按钮互补）
    if (this.els.historySelectAll) {
      this.els.historySelectAll.hidden = !items.length || ids.length >= items.length;
    }
    // 取消全选：有任意勾选时显示
    if (this.els.historyDeselectAll) {
      this.els.historyDeselectAll.hidden = ids.length === 0;
    }
    if (this.els.historyClear) {
      this.els.historyClear.hidden = !(this.historyItems && this.historyItems.length);
    }
  };

  /* 「Recent History」按钮右上角的条数气泡：数字变化时弹一下，0 条时隐藏 */
  Customizer.prototype.renderHistoryCount = function (n) {
    var el = this.els.historyCount;
    if (!el) return;
    var count = Number(n) || 0;
    if (!count) {
      el.hidden = true;
      el.textContent = '';
      this._historyCount = 0;
      return;
    }
    var changed = this._historyCount !== count;
    el.hidden = false;
    el.textContent = count > 99 ? '99+' : String(count);
    this._historyCount = count;
    if (!changed) return;
    // 重放动画：先摘掉 class 并强制一次重排，再加回来
    el.classList.remove('is-pop');
    void el.offsetWidth;
    el.classList.add('is-pop');
  };

  Customizer.prototype.loadHistory = function () {
    var self = this;
    if (!this.els.history) return;
    this.api.history(48).then(function (d) {
      self.historyItems = (d && d.items) || [];
      self.historyLoaded = true;   // 成功拉到一次后即可复用，避免反复请求
      self.renderHistory();
      self.renderPageRecent();     // 同步上传框右侧的「最近生成记录」一行
    }).catch(function (e) {
      console.warn('[AI3D] history load failed:', e && e.message);
    });
  };

  /* 历史条目的风格名称：Worker 只回 style_variant_id，用本页变体表反查 Style 选项值。
     取不到（老数据没有会话 / 变体已下架）返回空串，角标回退 2D/3D 文案。 */
  Customizer.prototype.historyStyleLabel = function (item) {
    var vid = item && item.style_variant_id;
    if (!vid || this.styleIdx < 0) return '';
    var variant = null;
    (this.product.variants || []).forEach(function (v) {
      if (String(v.id) === String(vid)) variant = v;
    });
    var label = variant && variant.options ? variant.options[this.styleIdx] : '';
    return label || '';
  };

  Customizer.prototype.renderHistory = function () {
    var self = this;
    var box = this.els.history;
    var grid = this.els.historyGrid;
    if (!box || !grid) return;

    this.historySelected = {};
    // 历史记录只保留 2D 效果图（3D 模型不再在前台历史里露出入口）
    var items = (this.historyItems || []).filter(function (it) { return it && it.kind !== '3d'; });
    this.renderHistoryCount(items.length);
    if (!items.length) {
      // 弹窗态不能直接隐藏，否则点开是一片空白；改为整块居中的「去定制」提示
      grid.classList.remove('is-empty');
      if (box.classList.contains('is-modal')) {
        grid.classList.add('is-empty');
        grid.innerHTML = '<p class="ai3d-history__empty-title">' + escapeHtml(t('history.empty_title')) + '</p>'
          + '<p class="ai3d-history__empty-text">' + escapeHtml(t('history.empty_text')) + '</p>';
        box.hidden = false;
      } else {
        box.hidden = true;
        grid.innerHTML = '';
      }
      this.updateHistoryActions();
      return;
    }

    grid.innerHTML = items.map(function (it) {
      var is3d = it.kind === '3d';
      var id = escapeHtml(it.task_id || '');
      // 角标优先显示风格名称，取不到（老数据/变体下架）回退 2D/3D 类型文案
      var styleName = self.historyStyleLabel(it);
      var badge = escapeHtml(styleName || (is3d ? t('history.badge_3d') : t('history.badge_2d')));
      var media = is3d
        ? '<span class="ai3d-history__ph" aria-hidden="true"></span>'
        // 网格只加载缩略图（2D 原图是 2K PNG，一张 1–5MB，十几张一起下会明显卡住弹窗）；
        // 老图还没有缩略图时退回原图，点开预览一律看原图 view_url
        : '<img src="' + escapeHtml(it.thumb_url || it.view_url || '') + '" alt="" loading="lazy">';
      return '<figure class="ai3d-history__card" data-history-item="' + id + '">'
        + '<label class="ai3d-history__check">'
        + '<input type="checkbox" data-history-check="' + id + '">'
        + '<span class="ai3d-history__checkmark"></span>'
        + '</label>'
        + '<div class="ai3d-history__thumb' + (is3d ? ' is-3d' : '') + '">' + media
        + '<span class="ai3d-history__badge">' + badge + '</span></div>'
        + '</figure>';
    }).join('');

    grid.classList.remove('is-empty');
    // 历史记录只在弹窗里显示：非弹窗态（主图下方的内联块）一律隐藏
    box.hidden = !box.classList.contains('is-modal');
    this.updateHistoryActions();
    this.syncHistoryGridHeight();
    // 2D 缩略图高度随图片比例、且多数是懒加载：图片加载完成后行高才定型，需重算网格高度
    Array.prototype.forEach.call(grid.querySelectorAll('.ai3d-history__thumb img'), function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () { self.syncHistoryGridHeight(); });
      img.addEventListener('error', function () { self.syncHistoryGridHeight(); });
    });
  };

  /* 桌面端：列表区固定为「3 行卡片」的高度，条目更多则在内部滚动。
     2D 卡高度随图片比例、3D 卡是正方形，同一行可能不等高，故取所有卡片的「最大高度」作行高。
     移动端头部是两行，交给 CSS 自适应高度 + 内部滚动。 */
  Customizer.prototype.syncHistoryGridHeight = function () {
    var grid = this.els.historyGrid;
    if (!grid) return;
    // 移动端：头部两行，弹层高度交给 CSS（max-height + 内部滚动），
    // 不再按「3 行」写死内联高度，避免行高被算小导致卡片互相压住
    if (window.matchMedia && window.matchMedia('(max-width: 600px)').matches) {
      grid.style.height = '';
      return;
    }
    var rowH = 0;
    Array.prototype.forEach.call(grid.querySelectorAll('.ai3d-history__card'), function (c) {
      rowH = Math.max(rowH, c.getBoundingClientRect().height);
    });
    if (!rowH) return;   // 弹窗未显示时量不到高度，保留兜底样式
    var cs = window.getComputedStyle(grid);
    var gap = parseFloat(cs.rowGap) || 12;
    var padV = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
    grid.style.height = Math.round(rowH * 3 + gap * 2 + padV) + 'px';
  };

  /* 历史记录弹窗：复用同一块 .ai3d-history 节点（加 is-modal 变浮层）；关闭后整块隐藏，不再回内联列表 */
  Customizer.prototype.openHistoryPopup = function () {
    var box = this.els.history;
    if (!box) return;
    box.hidden = false;
    box.classList.add('is-modal');
    this.renderHistory();            // 直接用已有数据渲染，不阻塞、不请求
    // 初始化时已拉过一次（出图后也会刷新），这里不再重复请求；仅首次未成功时才补拉
    if (!this.historyLoaded) this.loadHistory();
  };

  Customizer.prototype.closeHistoryPopup = function () {
    var box = this.els.history;
    if (!box) return;
    box.classList.remove('is-modal');
    if (this.els.historyGrid) this.els.historyGrid.style.height = '';   // 清掉弹窗态的内联高度
    this.renderHistory();   // 重置选中态（非弹窗态固定隐藏）
    box.hidden = true;
  };

  Customizer.prototype.openHistoryItem = function (taskId) {
    var found = null;
    (this.historyItems || []).forEach(function (x) { if (x.task_id === taskId) found = x; });
    if (!found) return;
    // 记下当前正在查看的历史条目：放大层里的「Continue customizing」要按它精准恢复
    this._historyOpenItem = found;

    if (found.kind === '3d') {
      // 3D 模型：仍在当前页面用 lightbox 内的 model-viewer 展示，不再跳新标签页
      this.openModelPreview(found.view_url);
      return;
    }

    var lb = this.els.historyLightbox;
    if (!lb) return;
    if (this.els.historyLightboxImg) {
      lb.classList.remove('is-3d');
      this.els.historyLightboxImg.src = found.view_url || '';
      lb.hidden = false;
    }
  };

  /* 3D 模型预览：Step 4 摘要的入口按钮与历史记录共用同一个 lightbox，
     页面里不再内嵌第二份 model-viewer（GLB 只在点击时才加载） */
  Customizer.prototype.openModelPreview = function (url) {
    var lb = this.els.historyLightbox;
    var model = this.els.historyLightboxModel;
    if (!lb || !model || !url) return;
    lb.classList.add('is-3d');
    lb.hidden = false;
    model.src = url;
  };

  Customizer.prototype.closeHistoryLightbox = function () {
    if (!this.els.historyLightbox) return;
    this.els.historyLightbox.hidden = true;
    this.els.historyLightbox.classList.remove('is-3d');
    if (this.els.historyLightboxImg) this.els.historyLightboxImg.src = '';
    // 释放 GLB：清空 src 让 model-viewer 停止加载/卸载模型
    var model = this.els.historyLightboxModel;
    if (model) model.removeAttribute('src');
  };

  /* 历史记录「Continue customizing」：按该条记录所在的会话精准恢复
     （锁定的风格/人物/尺寸、原图、2D/3D 结果、以及这张图所在的步骤）。
     取不到会话时（跨设备/旧数据）退回旧行为：继续最近一次定制。 */
  Customizer.prototype.continueFromHistory = function (item) {
    var self = this;
    this.closeHistoryLightbox();
    // 继续定制会打开定制弹窗，历史记录浮层必须先收起，避免两层叠在一起
    this.closeHistoryPopup();
    // design-box 没有 3D 步骤弹窗：历史里的 2D 图直接作为当前设计稿回填到卡片
    if (this.designBox) {
      if (item && item.kind === '2d' && item.key) {
        var res = {
          taskId: item.task_id,
          key: item.key,
          url: item.view_url || item.thumb_url,
          sessionId: item.session_id
        };
        var exists = (this.state.designResults || []).some(function (x) {
          return x && String(x.taskId) === String(res.taskId);
        });
        if (!exists) {
          this.state.designResults.push(res);
          if (this.state.designResults.length > 12) {
            this.state.designResults = this.state.designResults.slice(-12);
          }
        }
        this.selectDesignResult(res);
        this.renderPageUpload();
      } else {
        this.showNotice(t('design.select_hint'));
      }
      return;
    }
    if (!item || !item.session_id) { this.onStart(); return; }
    this.api.sessionGet(item.session_id).then(function (d) {
      if (!d || !d.session_id) throw new Error('empty');
      self.applyRestoredSession(d, item);
    }).catch(function () {
      self.onStart();
    });
  };

  /* 从最近记录选中 3D 模型：恢复会话与变体但不打开弹窗，
     按钮变为「Add to Cart」，点击直接加购该模型 */
  Customizer.prototype.select3dFromHistory = function (item) {
    var self = this;
    if (!item || !item.session_id) return;
    // 恢复前记住页面当前 Figure：会话锁定的 Figure 可能不同，事后据此提示
    var beforeFigure = this.state.figure;
    this.api.sessionGet(item.session_id).then(function (d) {
      if (!d || !d.session_id) throw new Error('empty');
      var s = self.state;
      s.session = d.session_id;
      s.photos = self.historyPhotos(d);
      s.photo = s.photos[0] || null;
      s.img2d = d.img2d ? { taskId: d.img2d.task_id, key: d.img2d.key, url: d.img2d.url } : null;
      s.model3d = { taskId: item.task_id, key: item.key, url: item.view_url };

      // 会话锁定的变体反查本页变体，保证加购的尺寸/人物与当初生成一致
      var variant = null;
      var vid = String(d.style_variant_id || '');
      (self.product.variants || []).forEach(function (v) { if (String(v.id) === vid) variant = v; });
      if (!variant) {
        // 会话变体在本页已不存在（下架/跨产品）：无法直接加购，撤销高亮并回退到弹窗继续
        self.syncRecentSelection();
        self.continueFromHistory(item);
        return;
      }

      // 先把 sel 整体锁定为会话变体，再静默同步风格/人物 radio（联动过程会临时改动 sel，之后再次锁定）
      self.sel = variant.options.slice();
      if (self.styleIdx >= 0 && variant.options[self.styleIdx] != null) {
        self.selectStyle(variant.options[self.styleIdx], true);
      }
      self.sel = variant.options.slice();
      if (self.figureIdx >= 0 && variant.options[self.figureIdx] != null) {
        s.figure = variant.options[self.figureIdx];
        self.selectFigure(s.figure, true);
      }
      self.sel = variant.options.slice();
      s.optionSel = self.optionSelSnapshot();
      self.currentVariant = variant;
      self.updatePagePrice(variant);
      // 加购按钮的可购性以会话锁定变体为准（selectStyle/selectFigure 联动时可能短暂把按钮置灰）
      self.els.start.disabled = !variant.available;

      self.selected3d = item;
      self.saveState();
      self.syncRecentSelection();
      self.updateResumeUI();
      self.noticeFigureSwitch(beforeFigure);
    }).catch(function () {
      // 会话取不到（跨设备/旧数据）时回退到进入弹窗继续定制，并撤销点击时的乐观高亮
      self.syncRecentSelection();
      self.continueFromHistory(item);
    });
  };

  /* 从上传框右侧选中一张当前会话的 2D 效果图：恢复会话与变体但不打开弹窗，
     按钮变「Add to Cart」（蓝紫渐变），点击直接加购该效果图（不要求 3D 模型）。
     流程与 select3dFromHistory 同构，仅产物落在 img2d、model3d 留空 */
  Customizer.prototype.select2dFromHistory = function (item) {
    var self = this;
    if (this.designBox) {
      // 标准商品页：变体由表单选择器决定，历史选图只取 2D 结果、随标准加购带稿，
      // 不做会话变体锁定（无 Step 4 / currentVariant）
      if (!item) return;
      var ds = this.state;
      ds.img2d = { taskId: item.task_id, key: item.key, url: item.view_url };
      ds.model3d = null;
      if (item.session_id) ds.session = item.session_id;
      this.selected3d = null;
      this.selected2d = item;
      this.saveState();
      this.syncRecentSelection();
      this.updateResumeUI();
      return;
    }
    if (!item || !item.session_id) { this.continueFromHistory(item); return; }
    var s = this.state;
    var sameSession = item.session_id === s.session;
    // 快速路径：最近记录只铺当前会话的图，会话就在本地时直接同步应用，
    // 不等 sessionGet 网络请求（选中高亮与「Add to Cart」文案即刻生效）
    if (sameSession) {
      s.img2d = { taskId: item.task_id, key: item.key, url: item.view_url };
      s.model3d = null;   // 2D 直购：购物车属性不带 3D
      this.selected3d = null;
      this.selected2d = item;
      this.saveState();
      this.syncRecentSelection();
      this.updateResumeUI();
      // 变体已锁过（进过 Step 4 / 页面选过完整选项）才能直接加购；否则不能直接 return，
      // 必须继续走 sessionGet 反查会话锁定变体 —— 否则 currentVariant 为空，
      // 点「Add to Cart」只会在上传区报「Please select all options.」
      if (this.currentVariant) return;
    }
    this.api.sessionGet(item.session_id).then(function (d) {
      if (!d || !d.session_id) throw new Error('empty');
      var s = self.state;
      // 当前会话：照片/产物刚在快速路径里同步过，不覆盖本地状态，这里只补锁变体
      if (!sameSession) {
        s.session = d.session_id;
        s.photos = self.historyPhotos(d);
        s.photo = s.photos[0] || null;
        s.img2d = { taskId: item.task_id, key: item.key, url: item.view_url };
        s.model3d = null;   // 2D 直购：购物车属性不带 3D
      }

      // 恢复前记住页面当前 Figure：会话锁定的 Figure 可能不同，事后据此提示
      var beforeFigure = self.state.figure;

      // 会话锁定的变体反查本页变体，保证加购的尺寸/人物与当初生成一致
      var variant = null;
      var vid = String(d.style_variant_id || '');
      (self.product.variants || []).forEach(function (v) { if (String(v.id) === vid) variant = v; });
      if (!variant) {
        // 会话变体在本页已不存在（下架/跨产品）：无法直接加购，撤销高亮并回退到弹窗继续
        self.syncRecentSelection();
        self.continueFromHistory(item);
        return;
      }

      // 先把 sel 整体锁定为会话变体，再静默同步风格/人物 radio（联动过程会临时改动 sel，之后再次锁定）
      self.sel = variant.options.slice();
      if (self.styleIdx >= 0 && variant.options[self.styleIdx] != null) {
        self.selectStyle(variant.options[self.styleIdx], true);
      }
      self.sel = variant.options.slice();
      if (self.figureIdx >= 0 && variant.options[self.figureIdx] != null) {
        s.figure = variant.options[self.figureIdx];
        self.selectFigure(s.figure, true);
      }
      self.sel = variant.options.slice();
      s.optionSel = self.optionSelSnapshot();
      self.currentVariant = variant;
      self.updatePagePrice(variant);
      // 加购按钮的可购性以会话锁定变体为准（selectStyle/selectFigure 联动时可能短暂把按钮置灰）
      self.els.start.disabled = !variant.available;

      self.selected3d = null;
      self.selected2d = item;
      self.saveState();
      self.syncRecentSelection();
      self.updateResumeUI();
      self.noticeFigureSwitch(beforeFigure);
    }).catch(function () {
      // 会话取不到（跨设备/旧数据）时回退到进入弹窗继续定制，并撤销点击时的乐观高亮
      self.syncRecentSelection();
      self.continueFromHistory(item);
    });
  };

  /* 同步最近记录列表的选中态：选中 2D 效果图 / 3D 模型时高亮对应项 */
  Customizer.prototype.syncRecentSelection = function () {
    var list = this.els.pageUploadRecentList;
    if (!list) return;
    var selected = this.selected2d || this.selected3d;
    var selId = selected ? selected.task_id : null;
    Array.prototype.forEach.call(list.querySelectorAll('[data-page-upload-recent-item]'), function (b) {
      var on = b.getAttribute('data-page-upload-recent-item') === selId;
      b.classList.toggle('is-selected', on);
      if (on) b.setAttribute('aria-pressed', 'true');
      else b.removeAttribute('aria-pressed');
    });
  };

  /* 历史会话原图归一：优先用 Worker 下发的全部 photos（Duo 为 2 张），
     旧接口只有单张 photo 时回退。保证 Duo 会话恢复后上传框/缩略图都是 2 个，
     而不是只显示 1 个（custom_sessions.user_photo_r2 只存第一张）。 */
  Customizer.prototype.historyPhotos = function (d) {
    var list = Array.isArray(d && d.photos) ? d.photos
      : (d && d.photo && d.photo.key ? [d.photo] : []);
    return list.filter(function (p) { return p && p.key; }).map(function (p) {
      return {
        key: p.key,
        url: p.url || '',
        thumbKey: p.thumb_key || '',
        thumbUrl: p.thumb_url || ''
      };
    });
  };

  /* 把服务端取回的会话状态落到本地 state 与界面，并打开弹窗到该图所在的步骤 */
  Customizer.prototype.applyRestoredSession = function (d, item) {
    var s = this.state;

    // 恢复前记住页面当前 Figure：会话锁定的 Figure 可能不同，事后据此提示
    var beforeFigure = s.figure;

    // 1) 还原 Style / Figure / Size：会话锁定的是 Shopify 变体，按变体 id 反查本页变体
    var variant = null;
    var vid = String(d.style_variant_id || '');
    (this.product.variants || []).forEach(function (v) { if (String(v.id) === vid) variant = v; });
    if (variant) {
      if (this.styleIdx >= 0 && variant.options[this.styleIdx] != null) {
        this.selectStyle(variant.options[this.styleIdx], true);
      }
      // 用会话变体覆盖：保证 Size / Figure 与当初一致（selectStyle 会按新风格重算其它选项）
      this.sel = variant.options.slice();
      if (this.figureIdx >= 0 && variant.options[this.figureIdx] != null) {
        this.state.figure = variant.options[this.figureIdx];
        this.selectFigure(this.state.figure, true);
      }
      this.state.optionSel = this.optionSelSnapshot();
      this.updatePagePrice(variant);
      this.syncModalStyles();
      // Figure 与页面当前选中不同：会话会把它锁回作品当初的模式，明确告知避免误解
      this.noticeFigureSwitch(beforeFigure);
    }

    // 2) 还原会话与产物；2D 记录优先显示被点的那张图本身
    s.session = d.session_id;
    s.photos = this.historyPhotos(d);
    s.photo = s.photos[0] || null;
    if (item.kind === '2d' && item.key) {
      s.img2d = { taskId: item.task_id, key: item.key, url: item.view_url };
    } else {
      s.img2d = d.img2d ? { taskId: d.img2d.task_id, key: d.img2d.key, url: d.img2d.url } : null;
    }
    // 同一张原图（同一会话）生成过的其它 2D 图 → Step 2 操作区下方「Your earlier portraits」
    var cur2dId = s.img2d ? s.img2d.taskId : null;
    s.img2dHistory = (this.historyItems || []).filter(function (x) {
      return x.kind === '2d' && x.session_id === s.session && x.task_id !== cur2dId;
    }).map(function (x) {
      return { taskId: x.task_id, key: x.key, url: x.view_url };
    });
    if (item.kind === '3d' && item.key) {
      s.model3d = { taskId: item.task_id, key: item.key, url: item.view_url };
    } else {
      s.model3d = d.model3d ? { taskId: d.model3d.task_id, key: d.model3d.key, url: d.model3d.url } : null;
    }

    // 3) 定位步骤：2D 图回到 Step 2，3D 图回到 Step 3
    s.step = item.kind === '3d' ? 3 : 2;
    this.saveState();

    // 4) 打开弹窗并还原界面（rehydrate 会用 task_id 刷新过期的签名链接）
    this.lockStyles();
    this.syncModalStyles();
    this.renderPhotos();
    this.renderPageUpload();
    this.openModal();
    this.gotoStep(s.step);
    this.rehydrate();
  };

  /* Step 2 生成结果全屏预览：点缩略图打开，点任意处关闭 */
  Customizer.prototype.openGen2dPreview = function () {
    if (!this.els.gen2dLightbox || !this.els.gen2dLightboxImg) return;
    var src = this.els.gen2dResult && this.els.gen2dResult.src;
    if (!src) return;
    this.els.gen2dLightboxImg.src = src;
    this.els.gen2dLightbox.hidden = false;
  };

  Customizer.prototype.closeGen2dPreview = function () {
    if (!this.els.gen2dLightbox || this.els.gen2dLightbox.hidden) return;
    this.els.gen2dLightbox.hidden = true;
    if (this.els.gen2dLightboxImg) this.els.gen2dLightboxImg.src = '';
  };

  /* 软隐藏：ids 为 null 表示全部清空。请求成功后本地移除对应卡片，不重新拉取 */
  Customizer.prototype.hideHistoryItems = function (ids) {
    var self = this;
    this.api.hideHistory(ids ? { task_ids: ids } : { all: true }).then(function () {
      if (ids) {
        var pick = {};
        ids.forEach(function (id) { pick[id] = true; });
        self.historyItems = (self.historyItems || []).filter(function (it) { return !pick[it.task_id]; });
      } else {
        self.historyItems = [];
      }
      // 历史里删掉的，生成弹窗里的结果同步移除（否则删了还会出现在弹窗里）
      self.dropDesignResults(ids);
      self.renderHistory();
    }).catch(function () {
      window.alert(t('history.err_hide'));
    });
  };

  /* 从「生成弹窗」的结果列表里移除指定任务（ids 为空 = 清空全部）；
     若当前选中的设计稿被删除，自动回退到剩余最新一张，并同步订单属性 */
  Customizer.prototype.dropDesignResults = function (ids) {
    if (!this.designBox) return;
    var pick = null;
    if (ids) {
      pick = {};
      ids.forEach(function (id) { pick[String(id)] = true; });
    }
    var list = (this.state.designResults || []).filter(function (r) {
      return r && (!pick || !pick[String(r.taskId)]);
    });
    this.state.designResults = list;
    // 历史回填的结果也要一起剔除，否则重渲染会从 historyItems 再捞回来
    if (pick) {
      this.historyItems = (this.historyItems || []).filter(function (it) {
        return !it || !pick[String(it.task_id)];
      });
    } else {
      this.historyItems = [];
    }
    var img2d = this.state.img2d;
    if (img2d && (!pick || pick[String(img2d.taskId)])) {
      var next = list.length ? list[0] : null;   // 与「默认选中第一个」保持一致
      if (next) {
        this.state.img2d = { taskId: next.taskId, key: next.key, url: next.url };
        this.selected2d = {
          task_id: next.taskId, key: next.key, view_url: next.url,
          session_id: next.sessionId || this.state.session
        };
      } else {
        delete this.state.img2d;
        this.selected2d = null;
      }
    }
    this.saveState();
    this.renderDesignStage();
    this.renderPageRecent();
    this.syncFormProperties();
    this.syncDesignCta();
    this.renderCustomStatus();
  };

  Customizer.prototype.renderCredits = function () {
    if (this.balance == null) return;
    var free2d = !(this.cost2d > 0);
    var free3d = !(this.cost3d > 0);
    var off3d = this.gen3dEnabled === false;
    // 免费模式（2D 限免 + 3D 关闭或同样限免）：隐藏积分条、获取积分入口与各步骤积分文案；
    // 但 2D 限免仍要在第 2 步说明「Free」，避免用户误以为还要扣积分
    if (free2d && (off3d || free3d)) {
      if (this.els.credits) this.els.credits.hidden = true;
      if (this.els.creditsPanel) this.els.creditsPanel.hidden = true;
      if (this.els.gen3dCost) this.els.gen3dCost.hidden = true;
      if (this.els.gen2dCost) {
        this.els.gen2dCost.hidden = !free2d;
        this.els.gen2dCost.textContent = t('credits.free');
        this.els.gen2dCost.dataset.base = this.els.gen2dCost.textContent;
      }
      this.renderKeepNote();
      if (this.designBox) this.renderDesignCost();
      return;
    }
    if (this.els.credits) this.els.credits.hidden = false;
    if (this.els.creditsValue) this.els.creditsValue.textContent = this.balance;
    // 3D 已关闭：不再显示 3D 价格；2D 限免：显示免费说明（有 3D 时附带 3D 价格）
    if (this.els.creditsCost) {
      if (free2d) {
        this.els.creditsCost.textContent = t('credits.cost_free_2d', { '3d': this.cost3d });
      } else if (off3d) {
        this.els.creditsCost.textContent = t('credits.cost_2d_only', { '2d': this.cost2d });
      } else {
        this.els.creditsCost.textContent = t('credits.cost_both', { '2d': this.cost2d, '3d': this.cost3d });
      }
      this.els.creditsCost.hidden = false;
    }
    if (this.els.gen2dCost) {
      this.els.gen2dCost.hidden = false;
      this.els.gen2dCost.textContent = free2d
        ? t('credits.free')
        : t('credits.cost_2d', { n: this.cost2d, balance: this.balance });
      this.els.gen2dCost.dataset.base = this.els.gen2dCost.textContent;
    }
    if (this.els.gen3dCost) {
      this.els.gen3dCost.textContent = t('credits.cost_3d', { n: this.cost3d, balance: this.balance });
      this.els.gen3dCost.dataset.base = this.els.gen3dCost.textContent;
    }
    this.renderKeepNote();
    this.syncCreditsCta();
    // design-box：弹窗里的价格按「生成数量 × 单张」展示
    if (this.designBox) this.renderDesignCost();
  };

  /* 余额见底（连一次 2D 都生不成）时：积分条转警示色，右侧露出「Get credits」入口；
     恢复余额后收起面板并隐藏入口 */
  Customizer.prototype.syncCreditsCta = function () {
    var b = this.balance;
    if (b == null || !this.els.credits) return;
    var low = b < this.cost2d;
    this.els.credits.classList.toggle('is-low', low);
    if (this.els.creditsGet) this.els.creditsGet.hidden = !low;
    // 余额不足（含为 0）时同时露出「Refresh」：客服/后台人工加积分后点它立即到账
    if (this.els.creditsRefresh) this.els.creditsRefresh.hidden = !low;
    if (!low) this.toggleCreditsPanel(false);
  };

  /* 重新拉取积分余额（后台人工加积分后，用户点「Refresh」立即看到新余额） */
  Customizer.prototype.refreshCredits = function () {
    var self = this;
    var btn = this.els.creditsRefresh;
    if (btn) btn.disabled = true;
    this.api.verify().then(function (d) {
      self.updateBalance(d.points_balance);
    }).catch(function () {}).then(function () {
      if (btn) btn.disabled = false;
    });
  };

  Customizer.prototype.toggleCreditsPanel = function (show) {
    var panel = this.els.creditsPanel;
    if (!panel) return;
    if (show === false || !panel.hidden) {
      panel.hidden = true;
      return;
    }
    panel.innerHTML = '<button type="button" class="ai3d-credits__panel-close" data-credits-panel-close aria-label="Close">&times;</button>'
      + '<p class="ai3d-credits__panel-title">' + t('credits.out_title') + '</p>'
      + '<p class="ai3d-credits__panel-text">' + t('credits.out_text', { n: this.cost2d, balance: this.balance }) + '</p>'
      + '<div class="ai3d-earn">' + this.earnOptionsHtml() + '</div>';
    var closeBtn = panel.querySelector('[data-credits-panel-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { panel.hidden = true; });
    // 移出弹窗挂到 root：弹窗 overflow:hidden 会裁掉上浮气泡，移出后才能用更高层级浮在弹窗之上
    if (panel.parentNode !== this.root) this.root.appendChild(panel);
    panel.hidden = false;
    this.positionCreditsPanel();
  };

  /* 气泡定位：右边缘对齐「Get credits」按钮，底边贴在其上方 8px（按钮不可见时自动收起）；
     同时把按钮中心相对气泡右缘的距离下发给 CSS，驱动底部箭头正好指向按钮 */
  Customizer.prototype.positionCreditsPanel = function () {
    var panel = this.els.creditsPanel;
    var btn = this.els.creditsGet;
    if (!panel || !btn || panel.hidden) return;
    var r = btn.getBoundingClientRect();
    if (!r.width || !r.height) { panel.hidden = true; return; }
    var rightOffset = Math.max(16, window.innerWidth - r.right);
    panel.style.left = 'auto';
    panel.style.top = 'auto';
    panel.style.right = rightOffset + 'px';
    panel.style.bottom = (window.innerHeight - r.top + 8) + 'px';
    // 箭头中心 = 按钮中心；夹在气泡内边距之间，窄屏下也不会超出气泡
    var arrowFromRight = (window.innerWidth - rightOffset) - (r.left + r.width / 2);
    var maxArrow = Math.min(160, panel.offsetWidth - 20);
    arrowFromRight = Math.max(16, Math.min(maxArrow, arrowFromRight));
    panel.style.setProperty('--ai3d-credits-arrow-x', arrowFromRight + 'px');
  };

  /* 「获取积分」可点击途径：未登录优先给注册/登录奖励链接（带 return_url 回跳），
     所有用户都能走 WhatsApp/Email 充值；下单自动补发以说明文字呈现 */
  Customizer.prototype.earnOptionsHtml = function (compact) {
    var e = this.earnBonus || {};
    var isGuest = !(this.preset && this.preset.customerId);
    var ret = encodeURIComponent(window.location.pathname + window.location.search);
    var links = [];
    if (isGuest && Number(e.register) > 0) {
      links.push('<a class="ai3d-earn__opt ai3d-earn__opt--primary" href="/account/register?return_url=' + ret + '">'
        + t('credits.opt_register', { n: e.register }) + '</a>');
    } else if (isGuest && Number(e.login) > 0) {
      links.push('<a class="ai3d-earn__opt ai3d-earn__opt--primary" href="/account/login?return_url=' + ret + '">'
        + t('credits.opt_login', { n: e.login }) + '</a>');
    }
    links.push('<a class="ai3d-earn__opt" href="https://wa.me/8615851426970" target="_blank" rel="noopener">' + t('credits.opt_whatsapp') + '</a>');
    links.push('<a class="ai3d-earn__opt" href="mailto:service@bobblegifts.com">' + t('credits.opt_email') + '</a>');
    if (compact) return links.join('');
    return links.join('') + '<p class="ai3d-earn__note">' + t('credits.how_order') + '.</p>';
  };

  /* 「Generate again」因积分不足置灰时，在按钮下方说明原因并给出获取入口，避免用户误以为是故障 */
  Customizer.prototype.renderRegenWarn = function () {
    var el = this.els.gen2dRegenWarn;
    if (!el) return;
    var low = this.balance != null && this.balance < this.cost2d;
    if (!low) {
      el.hidden = true;
      el.innerHTML = '';
      return;
    }
    el.hidden = false;
    el.innerHTML = escapeHtml(t('gen.regen_locked', { balance: this.balance, cost: this.cost2d }))
      + '<span class="ai3d-earn ai3d-earn--inline">' + this.earnOptionsHtml(true) + '</span>';
  };

  /* 保留 3D 积分提示：不打断流程，只在余额可能不够跑完 3D 时温和说明，并给出获取途径 */
  Customizer.prototype.renderKeepNote = function () {
    var b = this.balance;
    if (b == null) return;
    // 3D 已隐藏：所有「保留积分给 3D」的说明（含 Get more credits 获取途径）都不再展示
    if (this.gen3dEnabled === false) {
      this.renderKeepNoteEl(this.els.keepNote2d, false);
      this.renderKeepNoteEl(this.els.keepNote3d, false);
      return;
    }
    // step 2：够生一次 2D，但再刷一次就不够接着生 3D 了
    // （例如 2D=3、3D=8、余额 12：能跑完一轮，但重刷后只剩 6，不够 3D 的 8）
    this.renderKeepNoteEl(this.els.keepNote2d, b >= this.cost2d && b < this.cost2d * 2 + this.cost3d,
      t('credits.keep_3d', { n: this.cost3d, c: this.cost2d }));
    // step 3：当前已不够生成 3D
    this.renderKeepNoteEl(this.els.keepNote3d, b < this.cost3d,
      t('credits.need_3d', { n: this.cost3d }));
  };

  Customizer.prototype.renderKeepNoteEl = function (el, show, text) {
    if (!el) return;
    if (!show) { el.hidden = true; el.innerHTML = ''; return; }
    el.hidden = false;
    el.innerHTML = '<span class="ai3d-keepnote__text">' + escapeHtml(text) + '</span>'
      + '<span class="ai3d-keepnote__how">' + escapeHtml(this.earnHowText()) + '</span>';
  };

  /* 「如何获取积分」按后台配置动态拼装：未启用的途径不显示，下单补发始终提示 */
  Customizer.prototype.earnHowText = function () {
    var e = this.earnBonus || {};
    var parts = [];
    if (Number(e.register) > 0) parts.push(t('credits.how_register', { n: e.register }));
    if (Number(e.login) > 0) parts.push(t('credits.how_login', { n: e.login }));
    parts.push(t('credits.how_order'));
    return t('credits.how_prefix') + parts.join(' · ');
  };

  /* 风格展示名：按语种取展示名，缺则回退变体值本身 */
  Customizer.prototype.styleName = function (v) {
    if (v == null || v === '') return '';
    return (this.styleDisplay && this.styleDisplay[v]) || v;
  };

  /* 一次性把带 data-i18n* 标记的写死文案替换为当前语种（配置加载后调用） */
  Customizer.prototype.applyI18n = function () {
    var root = this.root;
    $all(root, '[data-i18n]').forEach(function (el) { el.textContent = t(el.getAttribute('data-i18n')); });
    $all(root, '[data-i18n-html]').forEach(function (el) { el.innerHTML = t(el.getAttribute('data-i18n-html')); });
    $all(root, '[data-i18n-ph]').forEach(function (el) { el.setAttribute('placeholder', t(el.getAttribute('data-i18n-ph'))); });

    // 上传副标题含 {slot} 占位符（内嵌 data-upload-hint），整体重建后再取回引用
    var sub = $(root, '[data-upload-sub]');
    if (sub) {
      sub.innerHTML = t('step1.upload_sub', { slot: '<span data-upload-hint></span>' });
      this.els.uploadHint = $(sub, '[data-upload-hint]');
    }
    // 风格展示名替换（页面风格卡片 / 弹窗风格条），键为 Style 变体值
    var self = this;
    $all(root, '.ai3d-style-card').forEach(function (card) {
      var input = $(card, '[data-style-value]');
      var name = $(card, '.ai3d-style-card__name');
      if (input && name) name.textContent = self.styleName(input.getAttribute('data-style-value'));
    });
    $all(root, '[data-style-preview-fig]').forEach(function (fig) {
      var name = $(fig, '.ai3d-modal-style-preview__name');
      if (name) name.textContent = self.styleName(fig.getAttribute('data-style-preview-fig'));
    });

    this.updateUploadHint();
    this.renderGen2dDesc();
    this.renderCredits();
    // Step 1 主按钮文案随是否已生成切换（data-i18n 默认值会把它刷回 Generate，这里再校正）
    if (this.els && this.els.goto2) {
      var g2lab = $(this.els.goto2, '.ai3d-btn__label');
      if (g2lab) g2lab.textContent = this.has2d() ? t('btn.next') : t('btn.generate');
    }
    this.updateResumeUI();
    this.applyHistoryTexts();
  };

  /* Step 2 描述里的风格名是动态的：整体重建并重新取回 <strong> 引用 */
  Customizer.prototype.renderGen2dDesc = function () {
    var p = $(this.root, '[data-gen2d-desc]');
    if (!p) return;
    p.innerHTML = t('step2.desc', { style: escapeHtml(this.gen2dStyleLabel || '') });
    this.els.gen2dStyle = $(p, '[data-gen2d-style]');
  };

  Customizer.prototype.updateBalance = function (b) {
    if (typeof b === 'number') { this.balance = b; this.renderCredits(); }
  };

  /* ---------- style selection ---------- */
  Customizer.prototype.restoreStyleSelection = function () {
    if (this.state.style) this.selectStyle(this.state.style, true);
  };

  /* 弹窗内「当前风格」预览与 state.style 对齐（初始化 / 恢复会话 / 打开弹窗时刷新） */
  Customizer.prototype.syncModalStyles = function () {
    this.syncModalStylePreview();
  };

  /* 勾选指定 radio 并把同组其它 radio 置为未选（不触发事件），同步卡片 label 选中态 */
  Customizer.prototype.markRadio = function (selector) {
    var radio = this.root.querySelector(selector);
    if (!radio) return null;
    var cls = radio.classList.contains('ai3d-figure-input') ? 'ai3d-figure-input'
            : radio.classList.contains('ai3d-size-input') ? 'ai3d-size-input'
            : 'ai3d-style-input';
    var labelCls = cls === 'ai3d-figure-input' ? 'ai3d-figure-card__label'
                 : cls === 'ai3d-size-input' ? 'ai3d-size-card__label'
                 : 'ai3d-style-card__label';
    $all(this.root, 'input.' + cls).forEach(function (r) {
      var on = (r === radio);
      r.checked = on;
      var lbl = r.nextElementSibling;
      if (lbl && lbl.classList.contains(labelCls)) lbl.classList.toggle('is-selected', on);
    });
    return radio;
  };

  /* 程序化选择后通知主题 Slate 变体逻辑一次；期间抑制自家捕获处理器，避免重入重复执行 */
  Customizer.prototype.emitNative = function (radio) {
    if (!radio) return;
    this._suppressNative = true;
    try { radio.dispatchEvent(new Event('change', { bubbles: true })); }
    finally { this._suppressNative = false; }
  };

  Customizer.prototype.selectStyle = function (value, silent, nativeEvent, sourceRadio) {
    this.sel[this.styleIdx] = value;
    var variant = this.firstAvailableVariantForStyle(value);
    if (variant) {
      for (var i = 0; i < this.options.length; i++) {
        if (i === this.styleIdx) continue;
        // 保留用户已选的 Size：若该尺寸对新风格不可用，由 size 提示 + Start 禁用兜住，
        // 不静默改成别的尺寸（否则用户看到的尺寸与实际下单的组合不一致）
        if (i === this.sizeIdx && this.sel[i]) continue;
        this.sel[i] = variant.options[i];
      }
    }
    // 已选人物模式优先：尝试「该风格 × 该 Figure」组合变体，售罄则回退该风格首个可用变体
    if (this.figureIdx >= 0) {
      if (this.state.figure) {
        this.sel[this.figureIdx] = this.state.figure;
        var pv = this.findVariant(this.sel);
        if (pv) {
          variant = pv;
        } else if (variant) {
          this.sel[this.figureIdx] = variant.options[this.figureIdx];
        }
      }
      if (variant) this.state.figure = variant.options[this.figureIdx];
    }
    // 保留的尺寸在新风格下没有可售组合时，自动落到该风格首个可售尺寸：
    // Slate 在 change 冒泡时按所有已选 radio 精确匹配变体——组合不存在时
    // variantChange 拿不到变体，主图就不会跟随切换。
    // 用户主动切风格视为接受该风格的尺寸矩阵；价格/Start 按钮仍按真实组合判定。
    if (this.sizeIdx >= 0 && variant && !this.findVariant(this.sel)) {
      this.sel[this.sizeIdx] = variant.options[this.sizeIdx];
    }
    if (variant) this.updatePagePrice(variant);
    // 价格/可购性以「Style × Figure × Size」实际组合为准（保留尺寸后可能不可购）
    var combo = this.findVariant(this.sel);
    if (combo) this.updatePagePrice(combo);

    // 先解析目标 radio：原生事件带来源（用户点的就是它），程序化取第一个匹配；
    // 产品选项值可能重复（CSV/API 导入），同值会有多个 radio，必须锁定唯一目标
    var styleRadio = null;
    var styleChanged = false;
    try {
      if (sourceRadio && sourceRadio.classList && sourceRadio.classList.contains('ai3d-style-input')) {
        styleRadio = sourceRadio;
      } else {
        var safeVal0 = String(value).replace(/"/g, '\\"');
        styleRadio = this.root.querySelector('.ai3d-style-input[data-style-value="' + safeVal0 + '"]');
      }
      styleChanged = !!styleRadio && !styleRadio.checked;
    } catch (e) {}

    this.els.styleBtns.forEach(function (b) {
      var on;
      if (b.tagName === 'INPUT') {
        // 同组 radio 只允许目标那一个选中，其余全部显式取消
        // （重复选项值时若按值匹配会同时勾多个，互相顶掉、卡片状态错乱）
        on = (b === styleRadio);
        b.checked = on;
      } else {
        on = b.getAttribute('data-style-value') === value;
      }
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      var cardLbl = b.nextElementSibling;
      if (cardLbl && cardLbl.classList.contains('ai3d-style-card__label')) {
        cardLbl.classList.toggle('is-selected', on);
        cardLbl.setAttribute('aria-checked', on ? 'true' : 'false');
      }
    });
    // 同步联动的 Figure radio 选中态；把当前风格卡片滚动到可视区域
    try {
      if (styleRadio) {
        if (this.figureIdx >= 0 && this.state.figure) {
          var safeFig0 = String(this.state.figure).replace(/"/g, '\\"');
          this.markRadio('.ai3d-figure-input[data-figure-value="' + safeFig0 + '"]');
        }
        // 同步尺寸 radio：可能因新风格不含原尺寸而自动落到了首个可售尺寸，
        // 必须在 Slate 冒泡处理前改好 DOM，它才能解析到变体并切换主图
        if (this.sizeIdx >= 0 && this.sel[this.sizeIdx]) {
          var safeSize0 = String(this.sel[this.sizeIdx]).replace(/"/g, '\\"');
          this.markRadio('.ai3d-size-input[data-size-value="' + safeSize0 + '"]');
        }
        var card = styleRadio.closest('.ai3d-style-card');
        var rail = card && card.parentElement;
        if (card && rail && rail.classList.contains('ai3d-style-grid')) {
          var target = Math.max(0, card.offsetLeft - (rail.clientWidth - card.offsetWidth) / 2);
          rail.scrollTo({ left: target, behavior: 'smooth' });
        }
      }
    } catch (e) {}
    this.state.style = value;
    this.syncSceneStyle();
    this.updateFigureAvailability();
    this.updateStyleAvailability();
    this.updateSizeAvailability();
    this.syncModalStylePreview();
    this.els.start.disabled = !(combo && combo.available);
    if (this.els.modalStyle) {
      this.els.modalStyle.textContent = (this.preset.styleOptionName || 'Style') + ': ' + value;
    }
    // 原生点击时 change 已在派发流程中（Slate 随后处理）；程序化选择且确有变化才补发一次
    if (!nativeEvent && styleChanged) this.emitNative(styleRadio);
    if (!silent) this.saveState();
  };

  /* 人物模式（单人/双人/人宠组合）选择：联动 Style×Figure 组合变体与价格 */
  Customizer.prototype.selectFigure = function (value, silent, nativeEvent, sourceRadio) {
    if (this.figureIdx < 0) return;
    // 切换前：记录旧模式与照片（用于切换后按模式缓存/恢复）
    var oldKind = this.figureKind();
    var oldPhotos = this.photos().slice();
    this.sel[this.figureIdx] = value;
    this.state.figure = value;

    // Figure 切换后联动 Style：当前 Style 在新 Figure 下无可售组合时，自动落到该 Figure 下
    // 第一个可售 Style。selectStyle 会同步重写 Style radio / 卡片选中态，
    // 让 Slate 在本次 change 冒泡时能按「新 Style × 新 Figure」解析到变体并切换主图与价格。
    if (this.styleIdx >= 0 && this.state.style && !this.styleAvailableForFigure(this.state.style, value)) {
      var firstStyle = this.firstStyleAvailableForFigure(value);
      if (firstStyle && firstStyle !== this.state.style) this.selectStyle(firstStyle, true);
    }
    // selectStyle 的兜底逻辑可能把 Figure 改回旧值：这里恢复用户刚点的 Figure
    this.sel[this.figureIdx] = value;
    this.state.figure = value;

    var variant = this.findVariant(this.sel);
    if (!variant) {
      // 当前尺寸等选项在该「Style × Figure」下不存在：按组合的首个可用变体修正其它选项，
      // 但锁定用户刚点的 Figure，避免被 selectStyle 的兜底逻辑改回旧 Figure
      var comboVariant = this.variantForStyleFigure(this.state.style, value);
      if (comboVariant) {
        for (var i = 0; i < this.options.length; i++) {
          if (i !== this.styleIdx && i !== this.figureIdx) this.sel[i] = comboVariant.options[i];
        }
        this.sel[this.figureIdx] = value;
        this.state.figure = value;
        variant = this.findVariant(this.sel);
      }
    }
    if (variant) this.updatePagePrice(variant);

    // 切换后：按 Figure 模式缓存/恢复照片，避免 Duo→Solo→Duo 切换后第二张图被永久删除
    var newKind = this.figureKind();
    if (oldKind && newKind && oldKind !== newKind) {
      // 缓存旧模式的照片
      if (oldPhotos.length > 0) this._photoCache[oldKind] = oldPhotos;
      // 恢复新模式缓存：仅当用户没换图（第一张相同）时恢复，否则保留当前照片
      var cached = this._photoCache[newKind];
      if (cached && cached.length > 0 && oldPhotos.length > 0 && oldPhotos[0] === cached[0]) {
        var max = this.maxPhotos();
        var restored = cached.slice(0, max);
        var current = this.photos();
        current.length = 0;
        restored.forEach(function (p) { current.push(p); });
      }
    }

    // 解析目标 radio（原生事件带来源），并记录变化；重复选项值时只锁定被点击的那一个
    var figRadio = null;
    var figChanged = false;
    try {
      if (sourceRadio && sourceRadio.classList && sourceRadio.classList.contains('ai3d-figure-input')) {
        figRadio = sourceRadio;
      } else {
        var safeFig = String(value).replace(/"/g, '\\"');
        figRadio = this.root.querySelector('.ai3d-figure-input[data-figure-value="' + safeFig + '"]');
      }
      figChanged = !!figRadio && !figRadio.checked;
    } catch (e) {}

    this.els.figureBtns.forEach(function (b) {
      var on;
      if (b.tagName === 'INPUT') {
        on = (b === figRadio);
        b.checked = on;
      } else {
        on = b.getAttribute('data-figure-value') === value;
      }
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      var cardLbl = b.nextElementSibling;
      if (cardLbl && cardLbl.classList.contains('ai3d-figure-card__label')) {
        cardLbl.classList.toggle('is-selected', on);
        cardLbl.setAttribute('aria-checked', on ? 'true' : 'false');
      }
    });

    this.enforcePhotoLimit();
    // 尺寸可能因新组合不存在而落到该组合的首个尺寸：同步 radio，Slate 才能解析到变体
    if (this.sizeIdx >= 0 && this.sel[this.sizeIdx]) {
      var safeSize = String(this.sel[this.sizeIdx]).replace(/"/g, '\\"');
      this.markRadio('.ai3d-size-input[data-size-value="' + safeSize + '"]');
    }
    this.updateStyleImages();
    this.updateStyleAvailability();
    this.updateFigureAvailability();
    this.updateSizeAvailability();
    this.els.start.disabled = !variant || !variant.available;
    // 原生点击时 change 已在派发流程中（Slate 随后处理）；程序化选择且确有变化才补发一次
    if (!nativeEvent && figChanged) this.emitNative(figRadio);
    if (!silent) this.saveState();
  };

  /* ---------- Q4 场景模式（场景包由 Worker 后台下发，产品经元字段绑定） ---------- */
  Customizer.prototype.peopleTypeToKind = function (pt) {
    if (pt === 'couple') return 'double';
    if (pt === 'pet_owner') return 'pet';
    if (pt === 'pet_only') return 'pet_only';
    return 'single';
  };

  Customizer.prototype.scenePeopleLabel = function (kind) {
    if (kind === 'double') return 'Duo · 2 people';
    if (kind === 'pet') return 'Person + pet';
    if (kind === 'pet_only') return 'Pet · 1 pet';
    return 'Solo · 1 person';
  };

  Customizer.prototype.initScene = function () {
    var self = this;
    // 风格初始值取当前选中的 Style radio（Shopify 变体默认值）；场景不再锁定风格，用户可自由切换
    var styleRadio = this.root.querySelector('.ai3d-style-input:checked') || this.root.querySelector('.ai3d-style-input');
    if (styleRadio) {
      var styleVal = styleRadio.getAttribute('data-style-value');
      if (styleVal) { this.state.style = styleVal; this.sel[this.styleIdx] = styleVal; }
    }
    // 场景模式不渲染 Figure 卡片，但变体里仍有 Figure 选项（如 Solo）：
    // 不补这一项，state.figure 会一直是空 → onStart 的 figure 守卫直接静默 return，Start 点了没反应
    this.syncSceneFigure();
    this.restoreSceneInputs();
    this.bindSceneInputs();

    var ready = this.configPromise || Promise.resolve(null);
    ready.then(function () {
      var sc = self.serverScenes ? self.serverScenes[self.sceneCode] : null;
      if (sc && sc.name) {
        self.scene = sc;
        self.applyScene(sc);
      } else {
        // 后台尚未保存该场景或接口失败：不阻塞定制，按变体默认尺寸 + 单人兜底
        self.scene = null;
        self.fallbackScene();
      }
    }).catch(function () { self.fallbackScene(); });
  };

  /* 场景模式：Figure 由场景决定、前端无选择器，从变体反查唯一值补进 state/sel */
  Customizer.prototype.syncSceneFigure = function () {
    if (this.figureIdx < 0 || this.state.figure) return;
    var v = this.findVariant(this.sel) || this.firstAvailableVariantForStyle(this.state.style);
    if (!v || v.options[this.figureIdx] == null) return;
    this.state.figure = v.options[this.figureIdx];
    this.sel[this.figureIdx] = this.state.figure;
  };

  Customizer.prototype.applyScene = function (sc) {
    this.sceneKind = this.peopleTypeToKind(sc.peopleType);

    // 新模型：风格不再由场景锁定，沿用顾客在产品页通过 Shopify Style 变体选中的风格
    // （initScene 已按当前选中 radio 初始化 state.style；这里不覆盖）

    // 场景信息条（产品页 + 弹窗 Step1 两处同构节点统一填充）
    this.fillSceneInfo(sc);

    if (this.els.sceneDeliveryWrap) {
      var d = (sc.deliveryText || '').trim();
      this.els.sceneDeliveryWrap.hidden = !d;
      if (this.els.sceneDelivery) this.els.sceneDelivery.textContent = d ? ' ' + d : '';
    }

    // 照片槽位（单/双/人宠；人数由场景锁定 → 决定上传照片张数）
    this.enforcePhotoLimit();
    this.renderPhotos();

    // 尺寸：场景默认尺寸 ＞ URL 已选 ＞ 首个可用变体
    var desired = this.matchOptionValue(this.sizeIdx, sc.defaultSize)
      || this.currentSizeValue()
      || this.firstAvailableSize();
    if (desired) this.selectSize(desired, true);
    else this.refreshSceneStartState();

    if (this.els.modalStyle) {
      this.els.modalStyle.textContent = (sc.name || '') + (this.state.style ? ' · ' + this.styleName(this.state.style) : '');
    }
  };

  /* 场景信息条：产品页与弹窗 Step1 各有一份同构节点，按 data-scene-* 统一填充全部副本 */
  Customizer.prototype.fillSceneInfo = function (sc) {
    var self = this;
    var values = {
      name: sc.name || '',
      style: this.state.style || sc.style || '',
      people: this.scenePeopleLabel(this.sceneKind),
      recipient: sc.recipient || '',
      prop: sc.prop || ''
    };
    Object.keys(values).forEach(function (key) {
      var val = String(values[key] || '');
      $all(self.root, '[data-scene-' + key + ']').forEach(function (el) {
        el.textContent = val;
        el.hidden = !val.trim();
      });
    });
    // 每个信息条独立控制整体显隐与「对象 · 道具」中点
    $all(this.root, '[data-scene-info]').forEach(function (box) {
      box.hidden = !sc.name;
      var dot = box.querySelector('[data-scene-dot]');
      if (dot) dot.style.display = (values.recipient && values.prop) ? '' : 'none';
    });
  };

  /* 用户在产品页切换风格时，实时刷新两处场景信息条里的风格胶囊 */
  Customizer.prototype.syncSceneStyle = function () {
    if (!this.sceneMode) return;
    var val = this.state.style || '';
    $all(this.root, '[data-scene-style]').forEach(function (el) {
      el.textContent = val;
      el.hidden = !val;
    });
    if (this.els.modalStyle && this.scene) {
      this.els.modalStyle.textContent = (this.scene.name || '') + (val ? ' · ' + this.styleName(val) : '');
    }
  };

  Customizer.prototype.fallbackScene = function () {
    this.sceneKind = 'single';
    if (this.styleIdx >= 0 && this.state.style) this.sel[this.styleIdx] = this.state.style;
    var cur = this.currentSizeValue() || this.firstAvailableSize();
    if (cur) this.selectSize(cur, true);
    else this.refreshSceneStartState();
    this.renderPhotos();
  };

  Customizer.prototype.setSceneChip = function (el, text) {
    if (!el) return;
    text = (text || '').trim();
    el.textContent = text;
    el.hidden = !text;
  };

  /* 在指定 option 位上找与期望值相等（忽略大小写/首尾空格）的真实变体值 */
  Customizer.prototype.matchOptionValue = function (idx, wanted) {
    if (idx < 0 || !wanted) return '';
    var w = String(wanted).trim().toLowerCase();
    var found = '';
    (this.product.variants || []).forEach(function (v) {
      if (!found && String(v.options[idx] || '').trim().toLowerCase() === w) found = v.options[idx];
    });
    return found;
  };

  Customizer.prototype.currentSizeValue = function () {
    var checked = this.root.querySelector('.ai3d-size-input:checked');
    return checked ? checked.getAttribute('data-size-value') : '';
  };

  Customizer.prototype.firstAvailableSize = function () {
    if (this.sizeIdx < 0) return '';
    var self = this;
    var out = '';
    (this.product.variants || []).forEach(function (v) {
      if (!out && v.available) out = v.options[self.sizeIdx];
    });
    return out;
  };

  /* 指定尺寸对「当前 Style/Figure」是否可购（该尺寸有没有可用变体） */
  Customizer.prototype.sizeAvailableFor = function (sizeValue) {
    if (this.sizeIdx < 0) return true;
    var probe = {};
    for (var k in this.sel) probe[k] = this.sel[k];
    if (this.styleIdx >= 0 && this.state.style) probe[this.styleIdx] = this.state.style;
    if (this.figureIdx >= 0 && this.state.figure) probe[this.figureIdx] = this.state.figure;
    probe[this.sizeIdx] = sizeValue;
    var v = this.findVariant(probe);
    return !!(v && v.available);
  };

  /* 指定 Style × Figure 组合下的首个可售尺寸（用于切换后自动落位） */
  Customizer.prototype.firstSizeAvailableFor = function (styleValue, figureValue) {
    if (this.sizeIdx < 0) return '';
    for (var i = 0; i < (this.product.variants || []).length; i++) {
      var v = this.product.variants[i];
      if (!v.available) continue;
      var hit = true;
      for (var k = 0; k < this.options.length; k++) {
        if (k === this.sizeIdx) continue;
        var want = k === this.styleIdx ? styleValue : (k === this.figureIdx ? figureValue : null);
        if (want != null && v.options[k] !== want) { hit = false; break; }
      }
      if (hit) return v.options[this.sizeIdx];
    }
    return '';
  };

  /* 尺寸可用性：按「当前 Style/Figure × 该尺寸」判断有没有可购变体，没有的尺寸置灰。
     Liquid 里的 disabled/is-disabled 只按整个商品算，切换风格后不会跟着更新 */
  Customizer.prototype.updateSizeAvailability = function () {
    if (this.sizeIdx < 0) return;
    var self = this;
    this.els.sizeBtns.forEach(function (b) {
      var ok = self.sizeAvailableFor(b.getAttribute('data-size-value'));
      if (b.tagName === 'INPUT') b.disabled = !ok;
      var cardLbl = b.nextElementSibling;
      if (cardLbl && cardLbl.classList.contains('ai3d-size-card__label')) {
        cardLbl.classList.toggle('is-disabled', !ok);
        cardLbl.setAttribute('aria-disabled', ok ? 'false' : 'true');
      }
    });
    // 当前选中的尺寸对新组合不可用：自动切到该组合首个可售尺寸。
    // 不能只把选中项置灰——置灰的 radio 会让主题 Slate 解析不到变体，
    // 表现为「切了 Figure/Style 但主图/价格不跟着变」。
    var selected = this.currentSizeValue();
    if (selected && !this.sizeAvailableFor(selected)) {
      var fallback = this.firstSizeAvailableFor(this.state.style, this.state.figure);
      if (fallback && fallback !== selected && !this._sizeFallbackBusy) {
        this._sizeFallbackBusy = true;
        try {
          // nativeEvent=true：不额外派发 change，由外层 Style/Figure 的那次 change 统一通知 Slate
          this.selectSize(fallback, false, true, null);
        } finally {
          this._sizeFallbackBusy = false;
        }
        return;
      }
    }
    // 组合整体售罄（没有任何可选尺寸）时才回退成提示
    if (this.els.sizeHint) {
      var sel2 = this.currentSizeValue();
      this.els.sizeHint.hidden = !sel2 || this.sizeAvailableFor(sel2);
    }
  };

  Customizer.prototype.refreshSceneStartState = function () {
    var variant = this.findVariant(this.sel);
    if (variant) this.updatePagePrice(variant);
    this.els.start.disabled = !(variant && variant.available);
  };

  /* 尺寸选择：联动 Style×Size 变体、价格（Slate 同时监听原生 change 切换主图/变体） */
  Customizer.prototype.selectSize = function (value, silent, nativeEvent, sourceRadio) {
    if (this.sizeIdx < 0) return;
    this.sel[this.sizeIdx] = value;
    var variant = this.findVariant(this.sel);
    if (!variant && this.state.style) variant = this.firstAvailableVariantForStyle(this.state.style);
    if (variant) {
      for (var i = 0; i < this.options.length; i++) {
        if (i !== this.styleIdx && i !== this.figureIdx && i !== this.sizeIdx) this.sel[i] = variant.options[i];
      }
      this.updatePagePrice(variant);
    }

    var sizeRadio = null;
    var sizeChanged = false;
    try {
      if (sourceRadio && sourceRadio.classList && sourceRadio.classList.contains('ai3d-size-input')) {
        sizeRadio = sourceRadio;
      } else {
        var safe = String(value).replace(/"/g, '\\"');
        sizeRadio = this.root.querySelector('.ai3d-size-input[data-size-value="' + safe + '"]');
      }
      sizeChanged = !!sizeRadio && !sizeRadio.checked;
    } catch (e) {}

    this.els.sizeBtns.forEach(function (b) {
      var on = (b === sizeRadio);
      if (b.tagName === 'INPUT') b.checked = on;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      var cardLbl = b.nextElementSibling;
      if (cardLbl && cardLbl.classList.contains('ai3d-size-card__label')) {
        cardLbl.classList.toggle('is-selected', on);
        cardLbl.setAttribute('aria-checked', on ? 'true' : 'false');
      }
    });

    this.els.start.disabled = !(variant && variant.available);
    this.updateSizeAvailability();   // 同步「当前尺寸不可用」提示
    this.state.optionSel = this.optionSelSnapshot();
    if (!nativeEvent && sizeChanged && sizeRadio) this.emitNative(sizeRadio);
    if (!silent) this.saveState();
  };

  /* 场景附加输入（配色/刻字/留言）：本地草稿持久化，加购时读取 */
  Customizer.prototype.restoreSceneInputs = function () {
    var s = this.state.sceneInputs || {};
    this.syncColorSelection(s.colorHex || '');
    if (this.els.sceneEngraving) this.els.sceneEngraving.value = s.engraving || '';
    if (this.els.sceneMessage) this.els.sceneMessage.value = s.message || '';
  };

  /* 色板选中态：空 hex = 「不指定」那个斜线色块 */
  Customizer.prototype.syncColorSelection = function (hex) {
    var palette = this.els.sceneColorPalette;
    if (!palette) return;
    var target = String(hex || '');
    var name = '';
    Array.prototype.forEach.call(palette.querySelectorAll('[data-color-hex]'), function (dot) {
      var on = String(dot.getAttribute('data-color-hex') || '') === target;
      dot.classList.toggle('is-selected', on);
      if (on) name = dot.getAttribute('data-color-name') || '';
    });
    if (this.els.sceneColorName) {
      this.els.sceneColorName.textContent = name ? (name + (target ? ' · ' + target : '')) : '';
      this.els.sceneColorName.hidden = !name;
    }
  };

  Customizer.prototype.bindSceneInputs = function () {
    var self = this;
    function save() {
      var s = self.state.sceneInputs || {};
      self.state.sceneInputs = {
        color: s.color || '',
        colorHex: s.colorHex || '',
        engraving: self.els.sceneEngraving ? self.els.sceneEngraving.value : '',
        message: self.els.sceneMessage ? self.els.sceneMessage.value : ''
      };
      self.saveState();
    }
    if (this.els.sceneColorPalette) {
      this.els.sceneColorPalette.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-color-hex]');
        if (!dot) return;
        self.state.sceneInputs = self.state.sceneInputs || {};
        self.state.sceneInputs.color = dot.getAttribute('data-color-name') || '';
        self.state.sceneInputs.colorHex = dot.getAttribute('data-color-hex') || '';
        self.syncColorSelection(self.state.sceneInputs.colorHex);
        save();
      });
    }
    [this.els.sceneEngraving, this.els.sceneMessage].forEach(function (el) {
      if (el) el.addEventListener('input', save);
    });
  };

  Customizer.prototype.sceneInputValues = function () {
    var s = this.state.sceneInputs || {};
    return {
      color: (s.color || '').trim(),
      colorHex: (s.colorHex || '').trim(),
      engraving: (s.engraving || '').trim(),
      message: (s.message || '').trim()
    };
  };

  /* 弹窗第一步左列只展示「当前已在页面选中的风格」预览图：按 data-style-preview-fig 高亮当前项 */
  Customizer.prototype.syncModalStylePreview = function () {
    var cur = this.state && this.state.style;
    this.els.modalStyleFigs.forEach(function (fig) {
      fig.classList.toggle('is-current', fig.getAttribute('data-style-preview-fig') === cur);
    });
  };

  /* 指定「Style × Figure」组合变体：优先返回可售的那个，找不到可售则返回第一个存在的 */
  Customizer.prototype.variantForStyleFigure = function (styleValue, figureValue) {
    var variants = this.product.variants || [];
    var first = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (this.styleIdx >= 0 && v.options[this.styleIdx] !== styleValue) continue;
      if (this.figureIdx >= 0 && v.options[this.figureIdx] !== figureValue) continue;
      if (!first) first = v;
      if (v.available) return v;
    }
    return first;
  };

  /* 该 Style 在当前 Figure 下是否有可售组合 */
  Customizer.prototype.styleAvailableForFigure = function (styleValue, figureValue) {
    if (this.styleIdx < 0 || this.figureIdx < 0) return true;
    var fig = figureValue != null ? figureValue : this.state.figure;
    if (!fig) return true;
    var v = this.variantForStyleFigure(styleValue, fig);
    return !!(v && v.available);
  };

  /* 取该 Figure 下第一个可售 Style（优先按页面卡片顺序；design-box 无卡片时按变体表顺序） */
  Customizer.prototype.firstStyleAvailableForFigure = function (figureValue) {
    var self = this;
    var out = null;
    this.els.styleBtns.forEach(function (btn) {
      if (out) return;
      var val = btn.getAttribute('data-style-value');
      if (val == null) return;
      if (self.styleAvailableForFigure(val, figureValue)) out = val;
    });
    if (out) return out;
    var variants = this.product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v.available) continue;
      if (this.figureIdx >= 0 && v.options[this.figureIdx] !== figureValue) continue;
      var styleVal = v.options[this.styleIdx];
      if (styleVal) return styleVal;
    }
    return null;
  };

  /* 变体图 URL 追加 CDN 尺寸/居中裁剪参数（原图 URL 不带尺寸，直接用于卡片会过大） */
  Customizer.prototype.variantImageSrc = function (url, size) {
    if (!url) return '';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + size + '&height=' + size + '&crop=center';
  };

  /* Figure 切换后，Style 卡片与弹窗风格预览的配图跟随「当前 Figure × 各 Style」变体图；
     该组合没有变体时回退到 Liquid 渲染时的默认图，保证切回原 Figure 能还原 */
  Customizer.prototype.updateStyleImages = function () {
    if (this.styleIdx < 0 || this.figureIdx < 0) return;
    var figure = this.state.figure;
    if (!figure) return;
    var self = this;

    var apply = function (img, styleValue, size) {
      if (!img) return;
      if (!img.getAttribute('data-default-src')) {
        img.setAttribute('data-default-src', img.getAttribute('src') || '');
      }
      var v = self.variantForStyleFigure(styleValue, figure);
      var src = v && v.featured_image && v.featured_image.src;
      img.src = src ? self.variantImageSrc(src, size) : img.getAttribute('data-default-src');
    };

    this.els.styleBtns.forEach(function (btn) {
      var val = btn.getAttribute('data-style-value');
      if (val == null) return;
      var label = btn.nextElementSibling;
      if (!label || !label.classList.contains('ai3d-style-card__label')) return;
      apply(label.querySelector('.ai3d-style-card__img img'), val, 160);
    });
    this.els.modalStyleFigs.forEach(function (figEl) {
      apply(figEl.querySelector('img'), figEl.getAttribute('data-style-preview-fig'), 480);
    });
  };

  /* 按当前 Figure 刷新各 Style 卡片的可售状态（组合售罄时仅置灰，仍可点击：
     点选后会按新 Style 自动切到有货的 Figure，避免两边互相锁死） */
  Customizer.prototype.updateStyleAvailability = function () {
    if (this.styleIdx < 0 || this.figureIdx < 0) return;
    if (!this.state.figure) return;
    var self = this;
    this.els.styleBtns.forEach(function (btn) {
      var val = btn.getAttribute('data-style-value');
      if (val == null) return;
      var ok = self.styleAvailableForFigure(val, self.state.figure);
      btn.setAttribute('data-available', ok ? 'true' : 'false');
      var lbl = btn.nextElementSibling;
      if (lbl && lbl.classList.contains('ai3d-style-card__label')) {
        lbl.classList.toggle('is-dimmed', !ok);
      }
    });
  };

  /* 按当前风格刷新各 Figure 值的可售状态（组合售罄时禁用对应卡片）。
     注意：只按「该 Style × 该 Figure」判断是否存在可售组合，**不能把当前 Size 算进去**——
     否则当前尺寸在新 Figure 下不存在时（如 Pet+6cm 切到 3D Realistic 时的 Solo/Duo），
     Figure 卡片会被直接禁用，用户就切不过去了。Size 不匹配由 updateSizeAvailability
     自动切到该组合首个可选尺寸。 */
  Customizer.prototype.updateFigureAvailability = function () {
    if (this.figureIdx < 0) return;
    var self = this;
    var styleVal = (this.styleIdx >= 0 && this.state.style) ? this.state.style : '';
    this.els.figureBtns.forEach(function (btn) {
      var val = btn.getAttribute('data-figure-value');
      var available;
      if (styleVal) {
        var combo = self.variantForStyleFigure(styleVal, val);
        available = !!(combo && combo.available);
      } else {
        // 尚未选风格：按当前所有已选选项（含 Size）判断
        var probe = {};
        for (var k in self.sel) probe[k] = self.sel[k];
        probe[self.figureIdx] = val;
        var v = self.findVariant(probe);
        available = !!(v && v.available);
      }
      btn.classList.toggle('is-unavailable', !available);
      btn.setAttribute('data-available', available ? 'true' : 'false');
      if (btn.tagName === 'BUTTON') {
        btn.disabled = !available;
      } else {
        btn.disabled = !available;
        if (btn.id) {
          var lbl = document.querySelector('label[for="' + btn.id + '"]');
          if (lbl) lbl.classList.toggle('is-disabled', !available);
        }
      }
    });
  };

  /* 弹窗内切换风格或人物模式：静默放弃当前进度，用新组合重开会话，回到 Step 1（无确认弹窗）。
     仅被点击的按钮短暂弱化；失败时回滚到切换前的会话。 */
  Customizer.prototype.switchSelection = function (kind, value, clickedBtn) {
    var self = this;
    var current = kind === 'style' ? this.state.style : this.state.figure;
    if (value === current) return;

    var snapshot = JSON.parse(JSON.stringify(this.state));
    // 人物模式切换前：按模式缓存当前照片，供切回该模式时恢复被裁剪的照片
    // （本路径先 resetState() 清空 photos，selectFigure 内的缓存逻辑拿不到旧照片，必须在此补写）
    if (kind === 'figure') {
      var prevKind = this.figureKind();
      var prevPhotos = (snapshot.photos || []).filter(function (p) { return !!p; });
      if (prevPhotos.length > 0) this._photoCache[prevKind] = prevPhotos;
    }
    // 后台请求序号：快速连点风格时只有最后一次的结果生效，避免旧响应回写覆盖新选择
    var seq = (this._switchSeq = (this._switchSeq || 0) + 1);

    // 乐观更新：立即切换选中态并回到第一步。不给按钮加 disabled/is-busy（不置灰、不转圈），
    // 会话重建放后台进行，用户点击即刻看到切换结果，无需等待网络往返
    // 会话重建要走网络：期间置 _switching 让进度提示条保持可见，否则它会先消失、等接口回来再出现（闪一下）
    this._switching = true;
    this.resetState();
    if (kind === 'style') this.selectStyle(value, true);
    else this.selectFigure(value, true);
    this.gotoStep(1);

    // 照片与风格/人物模式无关：已传完和「上传中」的照片都原样保留。
    // 上传请求不会因切换而中断，结果靠占位上的 _upId 回写到迁移后的槽位；
    // 生成结果 img2d/model3d 仍作废（属于旧风格/旧会话的作品）。
    // 保留空槽（与删除照片的槽位模型一致）：切换风格/人物只迁移照片，不紧凑数组
    this.state.photos = (snapshot.photos || []).slice();
    // 切回曾用过的模式：若该模式缓存过照片、且用户没换第一张（按 R2 key 比对，
    // 因 snapshot 是深拷贝、对象引用已变），恢复缓存，找回被切换时裁掉的第二张图
    if (kind === 'figure') {
      var nextKind = this.figureKind();
      var cached = this._photoCache[nextKind];
      var cur = this.validPhotos();
      var pid = function (p) { return p ? (p.key || p._upId || p.url || '') : ''; };
      if (cached && cached.length > 0 && cur.length > 0 && pid(cur[0]) === pid(cached[0])) {
        this.state.photos = cached.slice(0, this.maxPhotos());
      }
    }
    this.syncPrimaryPhoto();
    this.enforcePhotoLimit();   // 切人物模式（如双人→单人）后裁剪超额照片
    this.renderPhotos();
    // 同步刷新产品页上传区：resetState() 刚把 photos 清空过，这里必须立刻重建，
    // 否则页面上的上传框会先退化成「+ Upload Photo」占位，等接口回来才恢复缩略图（视觉上闪一下）
    this.renderPageUpload();
    this.saveState();

    // 防抖：快速连点时只发最后一次请求，避免旧响应覆盖新选择、减少 alert 弹窗
    if (this._switchTimer) clearTimeout(this._switchTimer);
    this._switchTimer = setTimeout(function () {
      var variant = self.findVariant(self.sel) || self.firstAvailableVariantForStyle(self.state.style);
      self.api.verify()
        .then(function () { return self.api.createSession(variant ? variant.id : value); })
        .then(function (d) {
          if (seq !== self._switchSeq) return;   // 已被更新的切换取代，丢弃本次结果
          self._switching = false;
          // 期间若已由会话自愈（403 重试）建好会话，就沿用那条，避免把它覆盖成
          // 「另一条会话」——否则刚上传成功的照片仍挂在旧会话目录，取图/生图继续 403
          if (!self.state.session) self.state.session = d.session_id;
          self.state.step = 1;
          self.saveState();
          self.updateResumeUI();
        })
        .catch(function (err) {
          if (seq !== self._switchSeq) return;
          self._switching = false;
          alert(t('err.switch_failed', { kind: kind, msg: err.message }));
          // 回滚：恢复切换前的会话与步骤
          self.state = snapshot;
          self.saveState();
          self.selectStyle(snapshot.style, true);
          if (self.figureIdx >= 0 && snapshot.figure) self.selectFigure(snapshot.figure, true);
          var step = snapshot.step || 1;
          self.gotoStep(step);
          self.renderPhotos();
          if (step >= 2) self.rehydrate();
        });
    }, 300);
  };

  Customizer.prototype.updatePagePrice = function (variant) {
    if (!variant || !this.els.priceCurrent) return;
    this.els.priceCurrent.textContent = formatMoney(variant.price, this.preset.moneyFormat);
    if (this.els.priceCompare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        this.els.priceCompare.textContent = formatMoney(variant.compare_at_price, this.preset.moneyFormat);
        this.els.priceCompare.hidden = false;
      } else {
        this.els.priceCompare.hidden = true;
      }
    }
  };

  Customizer.prototype.stepName = function (n) {
    return t('step.' + n + '.long');
  };

  /* 页面进行中状态：进度提示条显示当前步骤；主按钮始终保持「Start Customize」，点击即继续 */
  Customizer.prototype.updateResumeUI = function () {
    // _switching 期间旧会话已置空、新会话还在后台重建，仍按「进行中」显示，避免提示条闪一下
    var active = !!(this.state && this.state.style && (this.state.session || this._switching));
    var step = Math.max(1, Math.min(4, (this.state && this.state.step) || 1));

    if (this.els.progressHintWrap) {
      this.els.progressHintWrap.hidden = !active;
      if (active) {
        // 关掉第 3 步后流程只有 3 步：Options 在提示里显示为 Step 3 of 3
        var off3 = this.gen3dEnabled === false;
        var dispNo = off3 && step >= 3 ? step - 1 : step;
        var stepFmt = off3
          ? t('progress.step_of3', { n: dispNo, name: this.stepName(step) })
          : t('progress.step', { n: step, name: this.stepName(step) });
        this.els.progressHint.innerHTML = t('progress.saved', { step: '<b>' + stepFmt + '</b>' });
      }
    }
    var label = this.els.start && $(this.els.start, '.ai3d-btn__label');
    // 选中最近记录里的 2D 效果图 / 3D 模型时，按钮变「Add to Cart」并呈蓝紫渐变，点击直接加购
    var directCart = !!(this.selected3d || this.selected2d);
    if (this.els.start) this.els.start.classList.toggle('is-direct-cart', directCart);
    if (label && !this._starting) {
      label.textContent = directCart ? t('btn.add_to_cart') : t('btn.start');
    }
    // 同步产品页上传区
    this.renderPageUpload();
    // 同步产品页卡片内的生成状态 / 前后对比
    this.renderCustomStatus();
  };

  /* 兼容旧调用点 */
  Customizer.prototype.refreshResumeButton = function () { this.updateResumeUI(); };

  /* ---------- 卡片内生成状态 / 前后对比（弹窗外始终可见） ---------- */

  /** 记录进行中的生成（kind: '2d' | '3d'），pct 为 0-100 */
  Customizer.prototype.setGenRun = function (kind, pct) {
    this._genRun = { kind: kind, pct: Math.max(0, Math.min(100, Math.round(pct || 0))) };
    this.renderCustomStatus();
  };
  Customizer.prototype.clearGenRun = function () {
    this.stopGen2dPulse();
    if (!this._genRun) return;
    this._genRun = null;
    this.renderCustomStatus();
  };

  /* 进度统一绘制：进度条宽度 + 圆环圆心百分比（design 进度卡同 3D 生成动画）一起更新。
     同一轮内只升不降：轮询回传的原始进度可能低于脉冲已推进的位置，直接绘制会导致
     进度条反复后退又跳回；新一轮由 startGen2dPulse 重置基准 */
  Customizer.prototype.setGen2dBar = function (p) {
    var v = Math.max(0, Math.min(100, Math.round(p || 0)));
    if (v < (this._gen2dBarP || 0)) v = this._gen2dBarP;
    this._gen2dBarP = v;
    if (this.els.gen2dProgress) this.els.gen2dProgress.style.width = v + '%';
    if (this.els.designPct) this.els.designPct.textContent = v + '%';
  };

  /* 生图进度平滑脉冲：每 250ms 推进一次，取「真实轮询进度」与「模拟增速」的较大者，
     提交阶段（Submitting task…）和轮询间隙进度条也会持续走动 */
  Customizer.prototype.startGen2dPulse = function () {
    var self = this;
    this.stopGen2dPulse();
    var start = Date.now();
    this._gen2dRealP = 0;
    this._gen2dPulse = setInterval(function () {
      var elapsed = (Date.now() - start) / 1000;
      var p = Math.max(self._gen2dRealP || 0, Math.min(88, 6 + elapsed * 1.2));
      self.setGen2dBar(p);
      self.setGenRun('2d', p);
    }, 250);
  };
  Customizer.prototype.stopGen2dPulse = function () {
    if (this._gen2dPulse) {
      clearInterval(this._gen2dPulse);
      this._gen2dPulse = null;
    }
  };

  /* Check status 按钮显隐计时：生成中前 100 秒一律不显示（正常出图 20–60 秒就够），
     超过 100 秒仍未结束才浮出按钮，给用户一个手动反查入口。
     以 _gen2dStartedAt（任务提交时间）为基准，切步骤后回到 Step 2 也不会重新计时。 */
  Customizer.prototype.startGen2dWatchdog = function () {
    var self = this;
    this.stopGen2dWatchdog();
    var begin = Number(this._gen2dStartedAt || Date.now());
    if (!this._gen2dStartedAt) this._gen2dStartedAt = begin;
    var remain = GEN2D_STATUS_BTN_DELAY - (Date.now() - begin);
    this._gen2dTimedOut = false;
    this.syncGen2dRefreshBtn();
    if (remain <= 0) {
      this._gen2dTimedOut = true;
      this.syncGen2dRefreshBtn();
      return;
    }
    this._gen2dWatchdog = setTimeout(function () {
      self._gen2dWatchdog = null;
      self._gen2dTimedOut = true;
      self.syncGen2dRefreshBtn();
    }, remain);
  };
  Customizer.prototype.stopGen2dWatchdog = function () {
    if (this._gen2dWatchdog) {
      clearTimeout(this._gen2dWatchdog);
      this._gen2dWatchdog = null;
    }
  };

  /** 按滑块位置裁切「原图」图层，并移动分割线 */
  Customizer.prototype.syncBeforeAfter = function () {
    var v = this.els.baRange ? parseInt(this.els.baRange.value, 10) : 50;
    if (isNaN(v)) v = 50;
    if (this.els.baClip) this.els.baClip.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
    if (this.els.baDivider) this.els.baDivider.style.left = v + '%';
  };

  /** 是否已有可用的 2D 效果图（只有真正出图后才锁定上传/重刷） */
  Customizer.prototype.has2d = function () {
    return !!(this.state && this.state.img2d && this.state.img2d.url);
  };

  Customizer.prototype.renderCustomStatus = function () {
    var box = this.els.customStatus;
    // design-box 无「生成中卡片」markup（进度显示在 AI 框的 gen2d 区），但下方
    // 对比弹窗结果区 / 上传区显隐逻辑仍要执行，不能直接 return
    if (!box && !this.designBox) return;
    var run = this._genRun;
    var img2d = this.state && this.state.img2d;
    var done = !!(img2d && img2d.url);

    // 上传区常驻：不再因生成中/已有结果而收起（结果改由「Before / After」弹窗查看，
    // 上传框右侧展示最近生成记录）
    var zone = this.els.pageUploadZone;
    if (zone) {
      var hasVariant = this.designBox ? this.designBoxReady()
        : !!(this.state.style && (this.findVariant(this.sel) || this.firstAvailableVariantForStyle(this.state.style)));
      zone.hidden = !hasVariant;
    }

    // 「Before / After」入口：仅在已有 2D 结果时显示
    if (this.els.compareOpen) this.els.compareOpen.hidden = !done || (this.photos() || []).length >= 2;
    // 对比弹窗内结果区
    if (this.els.customStatusDone) this.els.customStatusDone.hidden = !done;
    // 结果被清空（重新上传/重开）时关闭对比弹窗
    if (!done && this.els.compare && !this.els.compare.hidden) this.els.compare.hidden = true;

    // 生成中进度条：仅在生成中显示
    if (box) box.hidden = !run;
    if (this.els.customStatusRunning) this.els.customStatusRunning.hidden = !run;

    if (run) {
      var key = run.kind === '3d' ? 'status.generating_3d' : 'status.generating_2d';
      if (this.els.customStatusText) this.els.customStatusText.textContent = t(key, { p: run.pct });
      if (this.els.customStatusProgress) this.els.customStatusProgress.style.width = Math.max(4, run.pct) + '%';
      // 生成状态中的两张图片：始终显示用户上传的原图（Duo 为两张，单张回退第一张），
      // 不显示 AI 生成的主图（从历史记录恢复进入弹窗时，动画图片同样只保留原图）。
      // 用 /f/ 永久地址：签名链接过期后页面进度图会整体空白（用户反馈「进度图片没了」）
      var shots = this.validPhotos();
      var before = shots[0] ? (this.photoFileUrl(shots[0]) || shots[0].url) : '';
      var after = shots[1] ? (this.photoFileUrl(shots[1]) || shots[1].url) : before;
      if (this.els.customStatusShotBack && before) {
        this.els.customStatusShotBack.setAttribute('src', before);
      }
      if (this.els.customStatusShotFront && after) {
        this.els.customStatusShotFront.setAttribute('src', after);
      }
      return;
    }

    if (!done) return;

    // 生成完毕：原图（before）↔ AI 效果图（after）
    var photos = this.photos();
    var before = this.validPhotos()[0]
      ? (this.photoFileUrl(this.validPhotos()[0]) || this.validPhotos()[0].url)
      : '';
    if (before) {
      if (this.els.baBefore && this.els.baBefore.getAttribute('src') !== before) {
        this.els.baBefore.setAttribute('src', before);
      }
      if (this.els.baBeforeThumb && this.els.baBeforeThumb.getAttribute('src') !== before) {
        this.els.baBeforeThumb.setAttribute('src', before);
      }
    }
    if (this.els.baAfter && img2d.url !== this.els.baAfter.getAttribute('src')) {
      this.els.baAfter.setAttribute('src', img2d.url);
    }
    if (this.els.baAfterThumb && img2d.url !== this.els.baAfterThumb.getAttribute('src')) {
      this.els.baAfterThumb.setAttribute('src', img2d.url);
    }
    if (this.els.custom3d) this.els.custom3d.hidden = !(this.state.model3d && this.state.model3d.url);
    this.syncBeforeAfter();
  };

  /* 生成前后对比弹窗：入口在「Upload Your Photo」标题右侧 */
  Customizer.prototype.openCompare = function () {
    var box = this.els.compare;
    if (!box) return;
    this.renderCustomStatus();   // 确保对比图已填充
    box.hidden = false;
  };
  Customizer.prototype.closeCompare = function () {
    if (this.els.compare) this.els.compare.hidden = true;
  };

  /* 放大预览（原图 / AI 效果图） */
  Customizer.prototype.openZoom = function (url) {
    var box = this.els.zoom;
    if (!box || !url) return;
    if (this.els.zoomImg) this.els.zoomImg.src = url;
    box.hidden = false;
  };
  Customizer.prototype.closeZoom = function () {
    if (!this.els.zoom) return;
    this.els.zoom.hidden = true;
    if (this.els.zoomImg) this.els.zoomImg.src = '';
  };

  /* ---------- start / modal ---------- */
  Customizer.prototype.onStart = function (resume) {
    var self = this;

    if (this.designBox) return;   // design-box 无定制弹窗：生成走 startDesignBoxGen
    if (!this.preset.workerUrl) {
      alert(t('err.worker_missing'));
      return;
    }
    if (this.styleIdx < 0 || !this.state.style) return;
    // 场景模式的 Figure 由场景锁定、前端不展示选择器，不能因 state.figure 为空就静默拦住
    if (!this.sceneMode && this.figureIdx >= 0 && !this.state.figure) return;

    // 已有进行中会话：直接打开弹窗继续（风格可在弹窗内切换），不再弹确认
    var open = function () {
      self.lockStyles();
      // 弹窗内风格按钮的选中态与当前风格强制对齐，避免出现"打开弹窗没选中"的错觉
      self.syncModalStyles();
      self.openModal();
      var step = self.state.step || 1;
      self.gotoStep(step);
      if (step >= 2) self.rehydrate();
    };

    if (this.state.session) { open(); return; }

    this.setStartLoading(true);
    var variant = this.findVariant(this.sel) || this.firstAvailableVariantForStyle(this.state.style);
    this.api.verify()
      .then(function () { return self.api.createSession(variant ? variant.id : self.state.style); })
      .then(function (d) {
        self.state.session = d.session_id;
        self.state.step = 1;
        self.saveState();
        open();
      })
      .catch(function (err) {
        alert(t('err.start_failed', { msg: err.message }));
      })
      .then(function () { self.setStartLoading(false); });
  };

  Customizer.prototype.setStartLoading = function (on) {
    var btn = this.els.start;
    this._starting = !!on;
    if (!btn) return;
    btn.disabled = on ? true : (!this.state.style || (!this.sceneMode && this.figureIdx >= 0 && !this.state.figure));
    var label = $(btn, '.ai3d-btn__label');
    if (label) label.textContent = on ? t('btn.starting') : t('btn.start');
    if (!on) this.updateResumeUI();
  };

  Customizer.prototype.lockStyles = function () {
    // 弹窗打开期间锁定商品页风格/人物卡片；尺寸卡片不受影响（仅改价/改变体）
    var self = this;
    this._lockedRadios = [];
    $all(this.root, '.ai3d-style-input, .ai3d-figure-input').forEach(function (b) {
      // 只记录锁定前可用的卡片，关弹窗时按原样还原，避免把售罄风格一并放开
      if (!b.disabled) self._lockedRadios.push(b);
      b.disabled = true;
    });
    if (this.sceneMode && this.scene) {
      this.els.modalStyle.textContent = this.scene.name + (this.state.style ? ' · ' + this.styleName(this.state.style) : '');
    } else {
      this.els.modalStyle.textContent = (this.preset.styleOptionName || 'Style') + ': ' + this.styleName(this.state.style);
    }
  };
  /* 关弹窗后还原商品页风格/人物卡片（仅还原本次锁定的，售罄卡片保持禁用），
     否则风格会一直点不动 */
  Customizer.prototype.unlockStyles = function () {
    (this._lockedRadios || []).forEach(function (b) { b.disabled = false; });
    this._lockedRadios = [];
  };

  Customizer.prototype.openModal = function () {
    if (!this.els.modal) return;
    this.els.modal.hidden = false;
    document.body.style.overflow = 'hidden';
    // 弹窗可见后重测风格条宽度，决定是否显示左右箭头
    this.refreshStyleRails();
  };
  Customizer.prototype.closeModal = function () {
    if (!this.els.modal) return;
    this.closeGen2dPreview();
    this.toggleCreditsPanel(false);   // 关弹窗即收起积分气泡（按钮随弹窗隐藏，气泡不能留在页面上）
    this.els.modal.hidden = true;
    document.body.style.overflow = '';
    // 关弹窗即解锁商品页风格/人物卡片，否则用户无法再切换风格
    this.unlockStyles();
    // 关闭弹窗：清除已选中的直购条目（3D 模型 / 2D 效果图），避免状态残留
    this.selected3d = null;
    this.selected2d = null;
    this.syncRecentSelection();
    // 关弹窗后页面提示进行中状态，按钮变为「Continue · Step N/4」
    this.updateResumeUI();
  };

  /* 居中确认弹窗：替代 window.confirm（原生样式无法定制）。
     「取消/确定」或右上角叉关闭；Esc、点遮罩均按取消处理，避免误触 */
  Customizer.prototype.confirmDialog = function (message, onConfirm) {
    var overlay = document.createElement('div');
    overlay.className = 'ai3d-confirm';
    overlay.innerHTML =
      '<div class="ai3d-confirm__box" role="alertdialog" aria-modal="true">'
      + '<button type="button" class="ai3d-confirm__close" aria-label="Close">'
      + '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>'
      + '</button>'
      + '<p class="ai3d-confirm__msg"></p>'
      + '<div class="ai3d-confirm__actions">'
      + '<button type="button" class="ai3d-confirm__btn ai3d-confirm__btn--ghost" data-confirm-cancel></button>'
      + '<button type="button" class="ai3d-confirm__btn ai3d-confirm__btn--primary" data-confirm-ok></button>'
      + '</div>'
      + '</div>';
    overlay.querySelector('.ai3d-confirm__msg').textContent = message;
    overlay.querySelector('[data-confirm-cancel]').textContent = t('common.cancel');
    overlay.querySelector('[data-confirm-ok]').textContent = t('common.confirm');

    // Esc 取消：capture 拦截并阻断，避免同时触发下层弹窗的 Esc 关闭
    function onKey(e) {
      if (e.key !== 'Escape') return;
      e.stopPropagation();
      e.preventDefault();
      done(false);
    }
    window.addEventListener('keydown', onKey, true);
    function done(ok) {
      window.removeEventListener('keydown', onKey, true);
      overlay.remove();
      if (ok && typeof onConfirm === 'function') onConfirm();
    }

    overlay.querySelector('[data-confirm-cancel]').addEventListener('click', function () { done(false); });
    overlay.querySelector('[data-confirm-ok]').addEventListener('click', function () { done(true); });
    overlay.querySelector('.ai3d-confirm__close').addEventListener('click', function () { done(false); });
    // 点遮罩空白处取消
    overlay.addEventListener('click', function (e) { if (e.target === overlay) done(false); });

    // 挂到带 --ai3d-* 变量的包裹层内（root 是其父级，继承不到变量，
    // 会导致确认按钮 background: var(--ai3d-danger) 失效、白字看不见）
    var host = this.root.querySelector('[data-ai3d-product]') || this.root;
    host.appendChild(overlay);
    overlay.querySelector('[data-confirm-ok]').focus();
  };

  /* 页面「New」重新开始：丢弃当前会话，保留已选风格/人物，回到 Step 1 */
  Customizer.prototype.restart = function () {
    this.resetState();
    this.saveState();
    this.updateResumeUI();
  };

  Customizer.prototype.resetState = function () {
    this.clearState();
    this.state = {
      step: 1,
      style: this.state.style,
      figure: this.state.figure,
      session: null,
      photos: [],
      photo: null,
      img2d: null,
      img2dPending: null,
      img2dHistory: [],
      model3d: null,
      optionSel: null
    };
    this.pendingSlot = null;
    this.selected3d = null;   // 切换风格/人物/重开：清除已选中的 3D 模型
    this.selected2d = null;   // 同步清除已选中的 2D 直购效果图
    this.syncRecentSelection();
    this._genRun = null;   // 重新开始：清掉卡片内的「生成中」状态
    // design-box 没有四步弹窗的按钮，逐个判空
    if (this.els.goto2) this.els.goto2.disabled = true;
    if (this.els.goto3) this.els.goto3.disabled = true;
    if (this.els.goto4) this.els.goto4.disabled = true;
    this.renderPhotos();
    this.setGenView('2d', 'idle');
    this.setGenView('3d', 'idle');
    this.renderGen2dHistory();   // 清掉可能残留的历史缩略图
    this.refreshResumeButton();
  };

  /* ---------- step navigation ---------- */

  /* 后台关闭第 3 步（3D 模型）后：隐藏步骤点/步骤区、Step 2 按钮直接去 Options、
     Options 步骤点改编号 3；配置在弹窗打开后到达也要把停在第 3 步的用户重定向走 */
  Customizer.prototype.syncGen3dStep = function () {
    var off = this.gen3dEnabled === false;
    if (this.els.modal) this.els.modal.classList.toggle('is-gen3d-off', off);
    // Step 2 底部「Next」按钮文案不随开关变化（两种模式都只显示 Next）；
    // 左侧预告文案切换：关 3D 时直接预告 Options 加购步
    if (this.els.step2Note) {
      var teaserText = $(this.els.step2Note, '[data-step2-teaser-text]');
      if (teaserText) teaserText.textContent = off ? t('gen.step2_teaser_off') : t('gen.step2_teaser_on');
    }
    // Options 步骤点编号：4 → 3（恢复开关时还原）
    if (this.els.indicator4) {
      var dot = this.els.indicator4.querySelector('.ai3d-stepper__dot');
      if (dot) dot.textContent = off ? '3' : '4';
    }
    // 配置到达时弹窗正开在第 3 步：直接送到 Options（gotoStep 内同样有兜底映射）
    if (off && this.state && this.state.step === 3 && this.els.modal && !this.els.modal.hidden) {
      this.gotoStep(4);
    }
    // 3D 开关会影响积分文案（是否出现 3D 价格 / 保留积分提示），配置到达后重渲染一次
    this.renderCredits();
    this.updateResumeUI();
  };

  Customizer.prototype.gotoStep = function (n) {
    var self = this;
    if (n < 1 || n > 4) return;
    // 3D 步骤已关闭：任何去往第 3 步的入口（老会话 state.step=3、历史恢复等）都改道 Options
    if (n === 3 && this.gen3dEnabled === false) n = 4;
    this.toggleCreditsPanel(false);   // 切步骤即收起积分气泡（按钮只在 Step 1 存在）
    this.state.step = n;
    this.saveState();

    this.els.steps.forEach(function (s) {
      s.hidden = Number(s.getAttribute('data-ai3d-step')) !== n;
    });
    this.els.indicators.forEach(function (li) {
      var idx = Number(li.getAttribute('data-step-indicator'));
      li.classList.toggle('is-active', idx === n);
      li.classList.toggle('is-done', idx < n);
    });

    if (n === 1) { this.refreshStyleRails(); this.renderPhotos(); }   // Step 1 刚变可见，重测风格条 + 渲染已上传图片
    if (n === 2) this.prepareStep2();
    if (n === 3) this.prepareStep3();
    if (n === 4) this.prepareStep4();

    // re-open model-viewer on revisit
    if (n === 3 && this.state.model3d && this.state.model3d.url) {
      this.els.gen3dViewer.src = this.state.model3d.url;
    }

    // 同步页面上的「Continue · Step N」状态（关弹窗后即为最新步骤）
    this.updateResumeUI();
  };

  /* ---------- step 1: upload（多图：单人1张，双人/人宠最多2张） ---------- */

  Customizer.prototype.photos = function () { return this.state.photos || (this.state.photos = []); };

  /* 识别人物模式：single / double / pet（优先卡片 data-figure-kind，兜底按文案关键词） */
  Customizer.prototype.figureKind = function () {
    // 场景产品没有 Figure 选项：人数由场景包 peopleType 决定
    if (this.sceneMode) return this.sceneKind || 'single';
    var kind = null;
    if (this.figureIdx >= 0) {
      for (var i = 0; i < this.els.figureBtns.length; i++) {
        if (this.els.figureBtns[i].getAttribute('data-figure-value') === this.state.figure) {
          kind = this.els.figureBtns[i].getAttribute('data-figure-kind');
          break;
        }
      }
    }
    if (kind === 'double' || kind === 'pet' || kind === 'pet_only') return kind;
    var k = String(this.state.figure || '').toLowerCase();
    // 含宠物关键词时再区分：带 person/owner/+ 的为「人宠组合」，否则为「单宠物」
    if (/pet|dog|cat|paw/.test(k)) return /person|owner|\+/.test(k) ? 'pet' : 'pet_only';
    if (/2|two|duo|couple|pair|double/.test(k)) return 'double';
    return 'single';
  };

  /* Worker 后台「Figure 变体设置」到达后，按变体值精确覆盖 radio 上的 data-figure-kind / data-photo-count。
     之后 figureKind() 与 themePhotoCount() 原有的 data-* 读取链路自动生效，无需改动其它逻辑。
     仅非场景产品有效：场景产品没有 Figure 选项，人数由场景包 peopleType 决定。 */
  Customizer.prototype.applyFigureConfigs = function () {
    if (this.sceneMode) return;
    var map = this.figureConfigs || {};
    var lower = {};
    Object.keys(map).forEach(function (k) { lower[String(k).toLowerCase().trim()] = map[k]; });
    var changed = false;
    $all(this.root, '.ai3d-figure-input').forEach(function (radio) {
      var cfg = lower[String(radio.getAttribute('data-figure-value') || '').toLowerCase().trim()];
      if (!cfg) return;
      if (cfg.kind === 'single' || cfg.kind === 'double' || cfg.kind === 'pet' || cfg.kind === 'pet_only') {
        radio.setAttribute('data-figure-kind', cfg.kind);
        changed = true;
      }
      if (cfg.photoCount === 1 || cfg.photoCount === 2) {
        radio.setAttribute('data-photo-count', String(cfg.photoCount));
        changed = true;
      }
    });
    if (changed) {
      // 照片张数可能变化：裁剪超额槽位并刷新上传提示
      this.enforcePhotoLimit();
      this.updateUploadHint();
    }
  };

  /* 按店铺语种更新 Figure 卡片显示名：figure_configs 的 label 已由 Worker 按当前语种拍平为字符串，
     直接替换 .ai3d-figure-card__name 的文本；label 为空时保留 Liquid 渲染的变体值本身。
     与 applyFigureConfigs 同一触发时机（配置加载后），仅场景产品无 Figure 选择器，无需处理。 */
  Customizer.prototype.applyFigureLabels = function () {
    var map = this.figureConfigs || {};
    var lower = {};
    Object.keys(map).forEach(function (k) { lower[String(k).toLowerCase().trim()] = map[k]; });
    $all(this.root, '.ai3d-figure-input').forEach(function (radio) {
      var value = String(radio.getAttribute('data-figure-value') || '').toLowerCase().trim();
      var cfg = lower[value];
      if (!cfg || !cfg.label) return;
      // radio 与 label 同属一个 .ai3d-figure-card，向上找到卡片再定位显示名元素
      var card = radio.parentElement;
      while (card && !card.classList.contains('ai3d-figure-card')) card = card.parentElement;
      if (!card) return;
      var nameEl = card.querySelector('.ai3d-figure-card__name');
      if (nameEl) nameEl.textContent = cfg.label;
    });
  };

  /* 主题编辑器 figure_option 配置：优先读取 Liquid 已按 Figure 变体精确计算好的上传数量
     （data-photo-count，由「精确变体名 → kind」匹配得出），保证与图标使用同一套匹配结果；
     兜底再用 figureConfigs 的 kind / match 匹配 */
  Customizer.prototype.themePhotoCount = function () {
    if (this.sceneMode) return null;
    // 优先：选中 Figure 按钮上的 data-photo-count（Liquid 精确匹配结果）
    if (this.figureIdx >= 0) {
      for (var b = 0; b < this.els.figureBtns.length; b++) {
        var btn = this.els.figureBtns[b];
        if (btn.getAttribute('data-figure-value') === this.state.figure) {
          var n = parseInt(btn.getAttribute('data-photo-count'), 10);
          if (n >= 1) return n;
          break;
        }
      }
    }
    var cfgs = (this.preset && this.preset.figureConfigs) || [];
    if (!cfgs.length) return null;
    var kind = this.figureKind();
    var fv = String(this.state.figure || '').toLowerCase().trim();
    // 精确变体名匹配
    for (var i = 0; i < cfgs.length; i++) {
      var m = String(cfgs[i].match || '').toLowerCase().trim();
      if (m && m === fv) return cfgs[i].photoCount || 1;
    }
    // 其次按 kind 精确匹配
    for (var j = 0; j < cfgs.length; j++) {
      var k = String(cfgs[j].kind || '').toLowerCase().trim();
      if (k && k === kind) return cfgs[j].photoCount || 1;
    }
    return null;
  };

  Customizer.prototype.maxPhotos = function () {
    // 主题编辑器为当前 Figure 变体配置了上传数量时优先使用
    var themeCount = this.themePhotoCount();
    if (themeCount) return themeCount;
    var kind = this.figureKind();
    if (this.sceneMode) return (kind === 'double' || kind === 'pet') ? 2 : 1;
    return this.figureIdx >= 0 && (kind === 'double' || kind === 'pet') ? 2 : 1;
  };

  /* 有效照片数量：删除照片时保留槽位（置 null），数量只算非空照片 */
  Customizer.prototype.photoCount = function () {
    var n = 0;
    this.photos().forEach(function (p) { if (p) n++; });
    return n;
  };

  /* 有效照片列表（跳过空槽）：供生成/轮播等按「真实照片」处理的逻辑使用 */
  Customizer.prototype.validPhotos = function () {
    var out = [];
    this.photos().forEach(function (p) { if (p) out.push(p); });
    return out;
  };

  Customizer.prototype.syncPrimaryPhoto = function () {
    // 取第一张非空照片（数组可能含空槽，不能直接用 photos[0]）
    var first = null;
    this.photos().forEach(function (p) { if (first == null && p) first = p; });
    this.state.photo = first;
  };

  /* 切换人物模式后裁剪超额照片（如双人传了2张后切回单人，保留第一张） */
  Customizer.prototype.enforcePhotoLimit = function () {
    var max = this.maxPhotos();
    var valid = this.validPhotos();
    // 仅在真正超额时裁剪（如双人传满后切回单人）。未超限（含含空槽）时保持原数组不动：
    // 上传途中的 _pending 占位也计入 valid，压缩虽不至于丢它，但会把空槽 compact 掉，
    // 破坏「删除后保留槽位」模型；且本函数调用点（applyFigureConfigs 等）不刷产品页，
    // 压缩后页面 DOM 会与 state 不一致，用户点到的槽位号会与数组下标错位
    if (valid.length > max) {
      this.state.photos = valid.slice(0, max);
      this.syncPrimaryPhoto();
      this.saveState();
    }
    this.renderPhotos();
    this.renderPageUpload();
  };

  Customizer.prototype.updateUploadHint = function () {
    if (!this.els.uploadHint) return;
    var kind = this.figureKind();
    this.els.uploadHint.textContent = t((kind === 'double' || kind === 'pet') ? 'step1.slot_multi' : 'step1.slot_single');
  };

  /* 上传进度浮层：圆环 + 「Uploading… N%」文字（懒构建 DOM，避免每次重建） */
  Customizer.prototype.setUploadProgress = function (pct) {
    var sp = this.els.uploadSpinner;
    if (!sp) return;
    if (!sp.firstChild) {
      sp.innerHTML = '<span class="ai3d-ring-spinner" aria-hidden="true"></span><span class="ai3d-upload__pct"></span>';
    }
    var el = sp.querySelector('.ai3d-upload__pct');
    if (el) el.textContent = t('step1.uploading', { pct: pct });
  };

  /* 兼容旧状态：照片数组长度超过人数上限时紧凑化。
     旧版本「删除后重传」会把新图追加到空槽之后（如单人 [null, 图]），
     槽位渲染只取前 max 个，导致图存在却看不到。这里把有效照片重新排到前部。 */
  Customizer.prototype.normalizePhotoSlots = function () {
    var max = this.maxPhotos();
    var arr = this.photos();
    if (arr.length <= max) return;
    var valid = arr.filter(function (p) { return !!p; }).slice(0, max);
    while (valid.length < max) valid.push(null);
    this.state.photos = valid;
    this.syncPrimaryPhoto();
    this.saveState();   // 落盘修正后的槽位结构，避免刷新后又回到坏结构
  };

  /* 渲染缩略图网格：按人数模式渲染 N 个槽位（单人1 / 双人·人宠2），空槽可点击上传 */
  Customizer.prototype.renderPhotos = function () {
    var self = this;
    this.normalizePhotoSlots();
    var photos = this.photos();
    var max = this.maxPhotos();
    this.syncPrimaryPhoto();
    this.updateUploadHint();

    var hasPhotos = this.photoCount() > 0;
    var multi = max > 1;   // 双人/人宠：即使一张未传也直接显示 2 个带序号槽位，人数一眼可见
    var box = this.els.uploadThumbs;
    if (box) {
      box.innerHTML = '';
      var locked = this.has2d();
      // 已有 2D 结果后单向锁定：只渲染已传图片，不再渲染空槽
      var count = locked ? this.photoCount() : max;
      for (var i = 0; i < count; i++) {
        var p = photos[i];

        if (!p) {
          // 单人无照片时不渲染空槽（只留「Drag & drop or browse」一个入口）；双人/人宠始终渲染带序号空槽
          if (!hasPhotos && !multi) continue;
          // 空槽：点击后把文件放入该位置
          var slot = document.createElement('button');
          slot.type = 'button';
          slot.className = 'ai3d-upload__add';
          slot.setAttribute('data-photo-slot', String(i));
          slot.setAttribute('aria-label', 'Add photo ' + (i + 1));
          slot.innerHTML = '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg><span></span>';
          slot.querySelector('span').textContent = multi ? ('Photo ' + (i + 1)) : t('btn.add_photo');
          box.appendChild(slot);
          continue;
        }

        var thumb = document.createElement('div');
        thumb.className = 'ai3d-upload__thumb';
        var img = document.createElement('img');
        img.src = self.photoThumbUrl(p) || '';
        img.alt = 'Reference photo ' + (i + 1);
        self.bindPhotoFallback(img, p);
        thumb.appendChild(img);

        // 点击垃圾桶后弹窗确认（不再在缩略图上展开勾/叉，避免小图里挤两个按钮）
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'ai3d-upload__thumb-rm';
        rm.setAttribute('data-photo-remove', '');
        rm.setAttribute('data-photo-index', String(i));
        rm.setAttribute('aria-label', 'Remove photo ' + (i + 1));
        rm.innerHTML = self.trashIcon();
        thumb.appendChild(rm);

        // 多人/人宠（N>1）且未生成结果时：支持调整照片左右顺序
        if (!locked && max > 1) {
            var mkMove = function (delta, cls) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'ai3d-upload__thumb-mv ai3d-upload__thumb-mv--' + cls;
              b.setAttribute('data-photo-move', String(delta));
              b.setAttribute('data-photo-index', String(i));
              b.setAttribute('aria-label', 'Move photo ' + (i + 1) + (delta < 0 ? ' left' : ' right'));
              b.innerHTML = delta < 0
                ? '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
                : '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
              return b;
            };
            if (i > 0) thumb.appendChild(mkMove(-1, 'prev'));
            if (i < photos.length - 1) thumb.appendChild(mkMove(1, 'next'));
          }
        box.appendChild(thumb);
      }
      box.hidden = !(hasPhotos || multi);
    }
    // 单人无照片时展示整块拖拽提示；双人/人宠直接用带序号槽位（避免两个上传入口并存）
    if (this.els.uploadPlaceholder) this.els.uploadPlaceholder.hidden = hasPhotos || multi;
    // design-box 没有四步弹窗的「下一步」按钮，跳过按钮态同步
    if (this.els.goto2) {
      this.els.goto2.disabled = this.photoCount() === 0;
      // 已生成过 2D（回到第一步查看/重开）时按钮只是「去第二步」，首次上传才是「Generate」
      var goto2Label = $(this.els.goto2, '.ai3d-btn__label');
      if (goto2Label) goto2Label.textContent = this.has2d() ? t('btn.next') : t('btn.generate');
    }
  };

  /* ---------- 产品页上传区渲染 ---------- */
  Customizer.prototype.renderPageUpload = function () {
    var self = this;
    this.normalizePhotoSlots();
    var photos = this.photos();
    var max = this.maxPhotos();
    var zone = this.els.pageUploadZone;
    if (!zone) return;
    // 没选风格/变体时隐藏上传区（生成中/已有结果也常驻，结果改由对比弹窗查看）
    var hasVariant = this.designBox ? this.designBoxReady()
      : !!(this.state.style && (this.findVariant(this.sel) || this.firstAvailableVariantForStyle(this.state.style)));
    zone.hidden = !hasVariant;
    // 外层卡片（标题 + 历史记录入口 + 联系入口）与上传区同显隐
    if (this.els.customCard) this.els.customCard.hidden = !hasVariant;
    if (!hasVariant) return;

    var hasPhotos = this.photoCount() > 0;
    var multi = max > 1;                 // 双人/人宠：即使一张未传也直接渲染 N 个带序号空槽，人数一眼可见
    var locked = this.has2d();           // 已有 2D 结果后单向锁定：只渲染已传图片
    var count = (locked && this.photoCount() > 0) ? this.photoCount() : max;

    // 在原有上传框内渲染 N 个槽位（空槽可点上传 / 已传显示缩略图），与弹窗内 renderPhotos 保持一致。
    // 注意：复用 pageUploadThumbs 容器，不重建 .ai3d-page-upload__box，避免 pageUploadSpinner/Error/Hover 缓存引用失效
    var box = this.els.pageUploadThumbs;
    if (box) {
      box.innerHTML = '';
      var renderSlots = hasPhotos || multi;   // 单人无照片时不渲染槽位，交给大占位符
      for (var i = 0; i < count && renderSlots; i++) {
        var p = photos[i];
        if (!p) {
          // 空槽：点击后把照片放进该位置（点击事件由 pageUploadZone 事件委托处理）
          var slot = document.createElement('button');
          slot.type = 'button';
          slot.className = 'ai3d-page-upload__add';
          slot.setAttribute('data-photo-slot', String(i));
          slot.setAttribute('aria-label', 'Add photo ' + (i + 1));
          slot.innerHTML = '<svg class="ai3d-page-upload__plus" width="30" height="30" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
            + '<span class="ai3d-page-upload__cta">' + (multi ? ('Photo ' + (i + 1)) : 'Upload Photo') + '</span>';
          box.appendChild(slot);
        } else {
          // 缩略图（悬停该图显示「重新上传」图标，点击只替换这一张）
          var thumb = document.createElement('div');
          thumb.className = 'ai3d-page-upload__thumb';
          if (p._pending) {
            thumb.className += ' is-uploading';
            // thumb 内部 spinner：只覆盖正在上传的这张，不影响其他槽位
            var sp = document.createElement('div');
            sp.className = 'ai3d-page-upload__thumb-spinner';
            sp.innerHTML = '<div class="ai3d-page-upload__thumb-spinner-ring"></div><span>' + t('page_upload.uploading') + '</span>';
            thumb.appendChild(sp);
          }
          thumb.setAttribute('data-photo-index', String(i));
          var img = document.createElement('img');
          img.src = self.photoThumbUrl(p) || '';
          img.alt = 'Photo ' + (i + 1);
          self.bindPhotoFallback(img, p);
          thumb.appendChild(img);

          // 删除按钮常显：即使已生成 2D 结果（锁定态）也允许删除原图
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'ai3d-page-upload__thumb-rm';
          rm.setAttribute('data-photo-remove', '');
          rm.setAttribute('data-photo-index', String(i));
          rm.setAttribute('aria-label', 'Remove photo ' + (i + 1));
          rm.innerHTML = self.trashIcon();
          thumb.appendChild(rm);

          // 点击垃圾桶后展开：确认删除（勾）/ 取消（叉），避免误触
          var ok = document.createElement('button');
          ok.type = 'button';
          ok.className = 'ai3d-page-upload__thumb-ok';
          ok.setAttribute('data-photo-confirm', '');
          ok.setAttribute('data-photo-index', String(i));
          ok.setAttribute('aria-label', 'Confirm remove photo ' + (i + 1));
          ok.innerHTML = self.checkIcon();
          thumb.appendChild(ok);

          var cancel = document.createElement('button');
          cancel.type = 'button';
          cancel.className = 'ai3d-page-upload__thumb-cancel';
          cancel.setAttribute('data-photo-cancel', '');
          cancel.setAttribute('data-photo-index', String(i));
          cancel.setAttribute('aria-label', 'Cancel remove photo ' + (i + 1));
          cancel.innerHTML = self.closeIcon();
          thumb.appendChild(cancel);

          // 每个 thumb 的替换 icon：多图时悬停在该图时居中淡入
          var tRep = document.createElement('button');
          tRep.type = 'button';
          tRep.className = 'ai3d-page-upload__thumb-replace';
          tRep.setAttribute('data-photo-replace', String(i));
          tRep.setAttribute('aria-label', 'Replace photo ' + (i + 1));
          tRep.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>';
          thumb.appendChild(tRep);
          box.appendChild(thumb);
        }
      }
      box.hidden = !renderSlots;
    }
    // 大占位符（整块拖拽提示）：仅单人且无照片时显示
    if (this.els.pageUploadPlaceholder) this.els.pageUploadPlaceholder.hidden = hasPhotos || multi;

    // 已传照片才显示「替换」按钮（右上角角标；悬停整个上传框时由 CSS 移到正中央）
    // 多图（双人/人宠）时改为每个 thumb 自己的替换 icon，box 级别的替换按钮隐藏；
    // 上传中（有 _pending 占位照片）也隐藏，避免 spinner 上方浮出替换 icon
    var uploading = photos.some(function (p) { return p && p._pending; });
    if (this.els.pageUploadReplace) this.els.pageUploadReplace.hidden = !hasPhotos || max > 1 || uploading;

    // 替换按钮的两态位置（右上角角标 / 悬停居中）与点击整组替换由 CSS + box 点击委托处理
    // 上传框右侧：最近生成记录一行
    this.renderPageRecent();
    // 上传/删除照片后同步弹窗生图区域里的「你的照片」小窗
    if (this.designBox) this.renderDesignStage();
  };

  /* 最近生成记录的引导气泡：有结果时显示（用户关过一次后不再出现） */
  Customizer.prototype.syncRecentTour = function (hasResults) {
    var el = this.els.recentTour;
    if (!el) return;
    var dismissed = false;
    try { dismissed = window.localStorage.getItem('ai3d_recent_tour_dismissed') === '1'; } catch (err) { /* 忽略 */ }
    el.hidden = !hasResults || dismissed;
  };

  /* 破图兜底：本地结果里的签名链接过期、或该任务已在历史里删除时，图片会加载失败。
     加载失败就把卡片移出弹窗，并从本地结果里剔除，避免右侧留一个「烂图片」 */
  Customizer.prototype.bindDesignResultErrors = function (list) {
    var self = this;
    function drop(img) {
      var card = img.closest('[data-page-upload-recent-item]');
      if (!card) return;
      var id = card.getAttribute('data-page-upload-recent-item');
      card.remove();
      self.state.designResults = (self.state.designResults || []).filter(function (r) {
        return !r || String(r.taskId) !== String(id);
      });
      if (self.state.img2d && String(self.state.img2d.taskId) === String(id)) {
        delete self.state.img2d;
        self.selected2d = null;
        self.syncFormProperties();
      }
      self.saveState();
      self.renderDesignStage();
      // 重渲染：还有卡片时会补上默认选中，没有卡片则显示空态
      self.renderPageRecent();
      self.syncDesignCta();
    }
    $all(list, '[data-page-upload-recent-item] img').forEach(function (img) {
      img.addEventListener('error', function () { drop(img); });
      // 监听前就已加载失败（缓存命中 / 快速失败）的补一次判断
      if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) drop(img);
    });
  };

  /* 当前选中的设计稿（点选卡片 / 默认第一个） */
  Customizer.prototype.selectedDesign = function () {
    var cur = this.state.img2d;
    if (!cur) return null;
    var id = String(cur.taskId);
    var list = this.state.designResults || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i] && String(list[i].taskId) === id) return list[i];
    }
    return cur;
  };

  /* 继续修图：把选中的设计图传回 R2，替换左下角上传框里的照片，
     下一轮生图就以它作为底图继续改（原上传照片被覆盖） */
  Customizer.prototype.refineWithDesign = function (res) {
    var self = this;
    if (!res || !res.url) return;
    if (this._designBatch && this._designBatch.running) return;
    var btn = this.els.designResultActions && this.els.designResultActions.querySelector('[data-design-refine]');
    if (btn) btn.disabled = true;
    this.showNotice(t('design.refine_uploading'), 3000);
    fetch(res.url, { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('design ' + r.status);
        return r.blob();
      })
      .then(function (blob) {
        var ext = (blob.type || '').indexOf('png') >= 0 ? 'png' : 'jpg';
        var file = new File([blob], 'refine-reference.' + ext, { type: blob.type || 'image/jpeg' });
        return self.api.upload(file, self.state.session, 'user-upload');
      })
      .then(function (d) {
        if (!d || !d.key) throw new Error(t('err.upload_failed', { msg: 'no key' }));
        self.state.photos = [{
          key: d.key,
          url: d.view_url,
          thumbKey: d.thumb_key || '',
          thumbUrl: d.thumb_url || ''
        }];
        // 结果图入 face 历史照片列；参考选中切回「该结果最初的用户照片」
        //（photoKey 缺失——历史恢复的结果——则保持原选中）
        self.rememberDesignPhoto(self.state.photos[0]);
        if (res.photoKey) self.state.designPhotoKey = res.photoKey;
        self.pendingSlot = null;
        self.pendingReplace = false;
        self.saveState();
        self.syncPrimaryPhoto();
        self.renderPhotos();
        self.renderPageUpload();
        self.renderDesignModal();
        self.showNotice(t('design.refine_ok'), 4200);
      })
      .catch(function (err) {
        self.showNotice((err && err.message) || t('err.upload_failed', { msg: '' }), 5000);
      })
      .then(function () { if (btn) btn.disabled = false; });
  };

  /* 直接加购：复用商品页标准表单（属性由 syncFormProperties 写入） */
  Customizer.prototype.addDesignToCart = function () {
    var form = this.designBoxForm();
    if (!form) return;
    this.syncDesignBoxSelection();
    this.syncFormProperties();
    var submit = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
    this.closeDesignModal();
    if (submit) submit.click();
    else if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  };

  /* 删除当前选中的设计：本地移除 + 服务端历史软隐藏，避免刷新后又出现 */
  Customizer.prototype.removeSelectedDesign = function () {
    var res = this.selectedDesign();
    if (!res || !res.taskId) return;
    if (this._designBatch && this._designBatch.running) return;
    var self = this;
    this.confirmDialog(t('design.confirm_remove'), function () {
      self.dropDesignResults([res.taskId]);
      self.api.hideHistory({ task_ids: [res.taskId] }).catch(function () { /* 忽略：本地已移除 */ });
      self.showNotice(t('design.remove_done'), 3000);
    });
  };

  /* 上传框右侧「最近生成记录」：3D 模板铺一行缩略图；
     design-box 改为「本次上传照片的 AI 效果图」网格（可多张、可点选） */
  Customizer.prototype.renderPageRecent = function () {
    var self = this;
    var wrap = this.els.pageUploadRecent;
    var list = this.els.pageUploadRecentList;
    if (!wrap || !list) return;

    if (this.designBox) {
      var historyById = {};
      (this.historyItems || []).forEach(function (it) {
        if (it && it.task_id) historyById[it.task_id] = it;
      });
      var results = (this.state.designResults || []).slice();
      // 服务端历史里的签名链接是最新的：按 task_id 回填，避免刷新后旧签名过期
      results.forEach(function (r) {
        var h = historyById[r.taskId];
        if (!h) return;
        if (h.view_url) r.url = h.view_url;
        if (h.key) r.key = h.key;
      });
      // 兼容旧状态：没有本地结果时，回退到当前会话已完成的 2D 图
      if (!results.length && this.state.session) {
        results = (this.historyItems || []).filter(function (it) {
          return it && it.kind === '2d' && it.session_id === this.state.session;
        }, this).slice(0, 8).map(function (it) {
          return { taskId: it.task_id, key: it.key, url: it.view_url || it.thumb_url, sessionId: it.session_id };
        });
      }

      var selectedId = this.state.img2d ? this.state.img2d.taskId : null;
      // 右侧默认选中第一个：没有选中、或选中的已不在列表里（例如刚在历史里删除）
      var hasSel = results.some(function (r) {
        return selectedId && String(r.taskId) === String(selectedId);
      });
      if (results.length && !hasSel) {
        var first = results[0];
        this.state.img2d = { taskId: first.taskId, key: first.key, url: first.url };
        this.selected2d = {
          task_id: first.taskId, key: first.key, view_url: first.url,
          session_id: first.sessionId || this.state.session
        };
        selectedId = first.taskId;
        this.saveState();
        this.renderDesignStage();
        this.syncFormProperties();
      }
      var html = results.map(function (r) {
        var id = escapeHtml(r.taskId || '');
        var on = selectedId && String(selectedId) === String(r.taskId);
        return '<button type="button" class="ai3d-design-result' + (on ? ' is-selected' : '') + '"'
          + ' data-page-upload-recent-item="' + id + '" aria-pressed="' + (on ? 'true' : 'false') + '">'
          + '<img src="' + escapeHtml(r.url || '') + '" alt="" loading="lazy">'
          + '<span class="ai3d-design-result__check" aria-hidden="true">'
          + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4.2 4.2L19 7" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          + '</span></button>';
      }).join('');

      // 生成进度只在输入区上方的进度条里显示，结果区不再插入「Creating design …」占位
      if (!results.length) {
        // 无标题栏：空态时把「Your AI designs」文字居中显示
        html = '<div class="ai3d-design-results__empty"><span>'
          + escapeHtml(t('design.results')) + '</span></div>';
      }
      list.innerHTML = html;
      this.bindDesignResultErrors(list);
      wrap.hidden = false;
      // 底部操作组只在有结果时出现（结果网格内部滚动，操作组固定在最底部）
      if (this.els.designResultActions) this.els.designResultActions.hidden = !results.length;
      this.syncRecentTour(results.length > 0);
      this._designVisibleCount = results.length;
      this.syncRecentSelection();
      this.syncDesignCta();
      // 卡片下方的「最近生成」横条与结果网格同源刷新
      this.renderDesignRecent();
      return;
    }

    // 右侧只显示「当前会话（= 当前上传照片）」生成的 2D 效果图；
    // 其它图片（含 3D、换图前/别的会话的 2D）只进历史记录弹窗
    var curSession = this.state && this.state.session;
    var items = (this.historyItems || []).filter(function (it) {
      return it && it.kind === '2d' && curSession && it.session_id === curSession;
    }).slice(0, 8);
    if (!items.length) {
      wrap.hidden = true;
      list.innerHTML = '';
      this.syncRecentTour(false);
      return;
    }
    list.innerHTML = items.map(function (it) {
      var id = escapeHtml(it.task_id || '');
      var media = '<img src="' + escapeHtml(it.thumb_url || it.view_url || '') + '" alt="" loading="lazy">';
      return '<button type="button" class="ai3d-page-upload__recent-item" data-page-upload-recent-item="' + id + '">' + media + '</button>';
    }).join('');
    wrap.hidden = false;
    this.syncRecentTour(true);
    // 缩略图宽度取决于图片实际比例，加载完再按可见宽度裁掉放不下的
    Array.prototype.forEach.call(list.querySelectorAll('img'), function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () { self.fitPageRecent(); });
    });
    this.fitPageRecent();
    // 重建 DOM 后恢复已选中条目的高亮（2D 直购 / 旧的 3D 直购）
    this.syncRecentSelection();
  };

  /* 卡片下方的「最近生成」横条：直接复用历史接口的数据，点一张即选中为当前设计稿 */
  Customizer.prototype.renderDesignRecent = function () {
    var box = this.els.designRecent;
    var list = this.els.designRecentList;
    if (!box || !list) return;
    if (!this.designBox) { box.hidden = true; return; }
    var items = (this.historyItems || []).filter(function (it) { return it && it.kind !== '3d'; }).slice(0, 12);
    if (!items.length) { box.hidden = true; list.innerHTML = ''; return; }
    var selectedId = this.state.img2d ? this.state.img2d.taskId : null;
    var self = this;
    list.innerHTML = items.map(function (it) {
      var id = escapeHtml(it.task_id || '');
      var on = selectedId && String(selectedId) === String(it.task_id);
      return '<button type="button" class="ai3d-design-recent__item' + (on ? ' is-selected' : '') + '"'
        + ' data-design-recent-item="' + id + '" aria-pressed="' + (on ? 'true' : 'false') + '"'
        + ' title="' + escapeHtml(self.historyStyleLabel(it) || t('history.badge_2d')) + '">'
        + '<img src="' + escapeHtml(it.thumb_url || it.view_url || '') + '" alt="" loading="lazy">'
        + '</button>';
    }).join('');
    box.hidden = false;
  };

  /* 「最近生成记录」只显示完整可见的图片：从第一张放不下的开始，后面的全部隐藏 */
  Customizer.prototype.fitPageRecent = function () {
    var list = this.els.pageUploadRecentList;
    if (!list || !list.children.length) return;
    var items = Array.prototype.slice.call(list.children);
    // clientWidth 含左右 padding（为选中 ring 预留的 3px+3px），可容宽度需扣除，否则会多算一个 item
    var cs = window.getComputedStyle(list);
    var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
    var avail = list.clientWidth - padX;
    if (!avail) return;
    var gap = 10;   // 与 CSS 的 gap 保持一致
    var widths = items.map(function (it) { it.hidden = false; return it.offsetWidth; });
    var used = 0, full = true;
    items.forEach(function (it, i) {
      if (!full) { it.hidden = true; return; }
      var w = widths[i];
      var next = used === 0 ? w : used + gap + w;
      if (next <= avail + 0.5) { it.hidden = false; used = next; }
      else { it.hidden = true; full = false; }
    });
  };

  /* 图片感知哈希（aHash）：缩放到 8x8 灰度，与均值比较得 64 位指纹。
     用于识别「Duo 上传了 2 张相同的图」——完全相同或极近似的图指纹一致，
     汉明距离为 0 时拦截。对压缩/微调过的同一张图也有容忍度（距离 ≤2 视为相同）。 */
  Customizer.prototype.imageHash = function (file) {
    return new Promise(function (resolve) {
      if (!file || typeof file !== 'object') return resolve('');
      var url = URL.createObjectURL(file);
      var img = new Image();
      var done = function (hash) { URL.revokeObjectURL(url); resolve(hash); };
      img.onload = function () {
        try {
          var c = document.createElement('canvas');
          c.width = 8; c.height = 8;
          var ctx = c.getContext('2d');
          ctx.drawImage(img, 0, 0, 8, 8);
          var data = ctx.getImageData(0, 0, 8, 8).data;
          var gray = [];
          for (var i = 0; i < 64; i++) {
            gray.push(data[i * 4] * 0.299 + data[i * 4 + 1] * 0.587 + data[i * 4 + 2] * 0.114);
          }
          var sum = 0;
          for (var i = 0; i < 64; i++) sum += gray[i];
          var avg = sum / 64;
          var hash = '';
          for (var i = 0; i < 64; i++) hash += gray[i] > avg ? '1' : '0';
          done(hash);
        } catch (e) { done(''); }
      };
      img.onerror = function () { done(''); };
      img.src = url;
    });
  };

  // 上传前压缩：手机原图常达 12MP（如 4000×3000），Worker 端 WASM 缩略图解码会触发
  // CPU 超限（Cloudflare Error 1102）导致上传 503。压缩到 ≤1024 宽可让缩略图可靠生成，
  // 同时减小上传体积。只压缩宽度 >1024 的图，小图保持原样；失败回退原图。
  function compressImageFile(file, maxWidth, quality) {
    return new Promise(function (resolve) {
      var objUrl = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h || w <= maxWidth) { URL.revokeObjectURL(objUrl); resolve(file); return; }
        var scale = maxWidth / w;
        var cw = maxWidth, ch = Math.max(1, Math.round(h * scale));
        var canvas = document.createElement('canvas');
        canvas.width = cw; canvas.height = ch;
        var c = canvas.getContext('2d');
        if (!c) { URL.revokeObjectURL(objUrl); resolve(file); return; }
        // PNG/WebP 可能有透明通道，先填白底再画，避免输出 JPEG 时透明区变黑
        if (file.type !== 'image/jpeg') { c.fillStyle = '#fff'; c.fillRect(0, 0, cw, ch); }
        c.drawImage(img, 0, 0, cw, ch);
        canvas.toBlob(function (blob) {
          URL.revokeObjectURL(objUrl);
          if (!blob) { resolve(file); return; }
          var ext = file.type === 'image/png' ? 'png' : file.type === 'image/webp' ? 'webp' : 'jpg';
          var name = (file.name || ('photo.' + ext)).replace(/\.[^.]+$/, '') + '.' + ext;
          resolve(new File([blob], name, { type: file.type }));
        }, file.type, quality);
      };
      img.onerror = function () { URL.revokeObjectURL(objUrl); resolve(file); };
      img.src = objUrl;
    });
  }

  Customizer.prototype.handleFiles = async function (fileList) {
    var self = this;
    // 必须在这里同步把 FileList 快照下来：调用方（input change）在调用后立刻把 input.value 清空，
    // FileList 是「活的」，一 await 就会变成空列表——design-box 上传前要 await 建会话，
    // 以前快照放在 await 之后，导致选完图静默无任何反应（不建会话、不上传、不报错）
    var files = Array.prototype.slice.call(fileList || []).filter(function (f) { return !!f; });
    // ai-custom 页面上传区只有 data-page-upload-error，没有 3D 弹窗的 data-upload-error，
    // 这里必须判空：否则一进 handleFiles 就抛 TypeError，async 函数静默失败（选完图毫无反应）
    var errEl = this.els.uploadError || this.els.pageUploadError || null;
    if (errEl) errEl.hidden = true;
    // 页面上传区报错时弹窗是关着的（uploadError 不可见）：所有错误同步提示到 data-page-upload-error，
    // 否则用户看到的是「选了图毫无反应」（25e0d48 修了 TypeError，但错误提示仍然落空）
    var showErr = function (msg) {
      self.showError(errEl, msg);
      if (self.els.pageUploadError && self.els.pageUploadError !== errEl) self.showError(self.els.pageUploadError, msg);
    };

    // 生成中不允许换照片：否则结果会落到新照片/新会话上
    if (this.designBox && this._designBatch && this._designBatch.running) {
      this.showNotice(t('design.wait'));
      return;
    }

    // design-box：上传前必须有会话（Worker 按会话目录存照片）。没有会话时先静默创建，
    // 避免用户首次上传直接失败。
    if (this.designBox) {
      try {
        await this.ensureDesignBoxSession();
      } catch (e) {
        var startMsg = t('err.start_failed', { msg: e.message || '' });
        this.showError(errEl, startMsg);
        if (this.els.pageUploadError) this.showError(this.els.pageUploadError, startMsg);
        return;
      }
    }

    // 随时可重新上传：已有 2D 结果时再上传 = 换图重开流程（旧作品仍保留在历史记录里）
    if (this.has2d()) {
      this.state.img2d = null;
      this.state.img2dHistory = [];
      this.state.model3d = null;
      this.state.optionSel = null;
      this.state.photos = [];
      if (this.designBox) {
        this.state.designResults = [];
        this.state.designBatch = null;
        delete this.state.designPending;
        this._designBatch = null;
      }
      this.syncPrimaryPhoto();
      this.clearGenRun();
      this.renderCustomStatus();
      this.updateResumeUI();
    }

    // 上传新照片：清除已选中的直购条目（3D 模型 / 2D 效果图），开始新的定制流程
    this.selected3d = null;
    this.selected2d = null;
    this.syncRecentSelection();

    // 文件列表已在函数开头同步快照，这里直接用
    var slot = this.maxPhotos() - this.photoCount();
    if (!slot && files.length) {
      // 槽位已满：不再报「已有一张，请先删除」把用户堵死（拖拽/点框换图都会撞上），
      // 改为整组替换 —— 清空已有照片后按新文件重新上传，与点击上传框替换的语义一致。
      this.state.photos = [];
      this.pendingSlot = null;
      this.pendingReplace = false;
      this.syncPrimaryPhoto();
      this.renderPhotos();
      this.renderPageUpload();
      slot = this.maxPhotos();
    }
    files = files.slice(0, Math.max(0, slot));
    if (!files.length) return;

    files = files.filter(function (file) {
      if (['image/jpeg', 'image/png', 'image/webp'].indexOf(file.type) < 0) {
        showErr(t('err.file_type'));
        return false;
      }
      if (file.size > 20 * 1024 * 1024) {
        showErr(t('err.file_too_large'));
        return false;
      }
      return true;
    });
    if (!files.length) return;

    // Duo/人宠：2 张图不能用同一张。用 aHash 感知哈希识别完全相同或极近似的图
    // （汉明距离 ≤2 视为相同），命中则拦截并提示，避免生成出「两个人一样」的失败结果。
    if (this.maxPhotos() >= 2 && files.length >= 2) {
      var h0 = await this.imageHash(files[0]);
      var h1 = await this.imageHash(files[1]);
      var dist = 99;
      if (h0 && h1 && h0.length === h1.length) {
        dist = 0;
        for (var i = 0; i < h0.length; i++) if (h0[i] !== h1[i]) dist++;
      }
      if (dist <= 2) {
        showErr(t('err.duplicate_photos'));
        return;
      }
    }

    if (this.els.uploadSpinner) this.els.uploadSpinner.hidden = false;
    // 产品页上传中 spinner 改为 thumb 级别（renderPageUpload 给上传中的 thumb 插入），box 级别不再显示
    // if (this.els.pageUploadSpinner) this.els.pageUploadSpinner.hidden = false;
    if (this.els.pageUploadError) this.els.pageUploadError.hidden = true;
    this.setUploadProgress(0);
    // 插入位置：点击空槽上传时落到该槽位；否则优先填第一个空槽，再追加到末尾。
    // （删除照片/上传失败都会保留 null 空槽，若直接 append 到数组末尾，新图会落在
    //  渲染范围之外——页面只看得到空槽、看不到刚上传的图，且再传仍“已有一张”）
    var at = this.pendingSlot;
    this.pendingSlot = null;
    var arrNow = this.photos();
    if (at == null || isNaN(at) || at < 0 || at > arrNow.length) {
      var emptyAt = -1;
      for (var ei = 0; ei < arrNow.length; ei++) {
        if (!arrNow[ei]) { emptyAt = ei; break; }
      }
      at = emptyAt >= 0 ? emptyAt : arrNow.length;
    }

    // 先放本地预览占位，上传成功后替换为 R2 签名 URL（Promise.all 保证多图顺序）。
    // _upId 是槽位的稳定身份：上传途中切换风格/人物会重建会话、state 被快照替换，
    // 上传结果靠它找回迁移后的槽位，而不是写回已经脱离 state 的闭包旧对象。
    // 注意：_upId 会随 state 落盘，而 _upSeq 每次刷新页面都从 0 重新计数；若不先从
    // 已有照片的 _upId 续号，刷新后新图的 _upId 会与恢复出来的老照片撞号，回写时
    // 覆盖到旧槽位，导致「第二张把第一张替换掉、多张显示同一张」。
    var seed = 0;
    this.photos().forEach(function (p) { if (p && p._upId > seed) seed = p._upId; });
    this._upSeq = Math.max(this._upSeq || 0, seed);
    var placeholders = files.map(function (f) {
      self._upSeq += 1;
      return { _upId: self._upSeq, key: '', url: URL.createObjectURL(f), _pending: true };
    });
    var arr = this.photos();
    var rest = placeholders.slice();
    // 落在空槽位：原地替换，后续照片保持原位（不补位）
    while (rest.length && at < arr.length && arr[at] == null) {
      arr[at] = rest.shift();
      at++;
    }
    // 仍有剩余则追加到末尾
    if (rest.length) Array.prototype.splice.apply(arr, [arr.length, 0].concat(rest));
    this.syncPrimaryPhoto();
    this.renderPhotos();
    this.renderPageUpload();

    // 上传进度：多图并行时按「已传字节 / 总字节」汇总成一个百分比
    var prog = files.map(function () { return { loaded: 0, total: 0 }; });
    var paintProgress = function () {
      var loaded = 0, total = 0;
      prog.forEach(function (p) { loaded += p.loaded; total += p.total; });
      self.setUploadProgress(total ? Math.round(loaded / total * 100) : 0);
    };
    // 上传前压缩：降低 Worker 缩略图 CPU 消耗，避免大图触发 Error 1102（见 compressImageFile 注释）
    var uploadFiles = await Promise.all(files.map(function (f) {
      return compressImageFile(f, 1024, 0.85).catch(function () { return f; });
    }));

    // 3D 模板：切换风格/人物后会话会短暂为空（重建请求在后台跑），此时上传会带
    // session_id=null 直接 403。上传前补建会话；失败则照旧交给 withSessionRetry。
    if (!this.designBox && !this.state.session) {
      try {
        var sv = this.findVariant(this.sel) || this.firstAvailableVariantForStyle(this.state.style);
        var sd = await this.api.createSession(sv ? sv.id : this.state.style);
        this.state.session = sd.session_id;
        this.saveState();
      } catch (e) { /* 忽略：上传时会再走一次会话自愈 */ }
    }

    // 会话归属失配（403）时自动重建会话并重试一次
    var runUpload = function () {
      return Promise.all(uploadFiles.map(function (file, i) {
        return self.api.upload(file, self.state.session, 'user-upload', function (loaded, total) {
          prog[i].loaded = loaded; prog[i].total = total; paintProgress();
        });
      }));
    };
    this.withSessionRetry(runUpload).then(function (results) {
      // 按 _upId 回写到「当前」照片数组：上传途中可能已切换风格/人物（会话重建、
      // state 被快照替换、人物模式收窄裁剪），闭包里的占位对象早已不在 state 里。
      var current = self.state.photos || [];
      placeholders.forEach(function (ph, i) {
        var d = results[i];
        if (!d) return;
        var target = null;
        for (var j = 0; j < current.length; j++) {
          if (current[j] && current[j]._upId === ph._upId) { target = current[j]; break; }
        }
        if (target) {
          // thumbKey/thumbUrl 为 Worker 上传时生成的 480 宽缩略图（公开 /f/ 地址）；
          // 生图参考仍只用 key（原图），缩略图仅用于轮播/上传缩略图位展示
          target.key = d.key;
          target.url = d.view_url;
          target.thumbKey = d.thumb_key || '';
          target.thumbUrl = d.thumb_url || '';
          delete target._pending;
          // 追加进 face 历史照片列（跨「重新上传清空 photos」保留）
          self.rememberDesignPhoto(target);
        } else {
          // 槽位已不存在（切人物模式被裁剪/用户删除/主动重开）：结果忽略，R2 孤儿图不影响使用
          console.warn('[ai3d] upload result dropped: slot _upId=' + ph._upId + ' not found');
        }
      });
      self.syncPrimaryPhoto();
      // 旧选中照片不在本批照片组里（重新上传后）：face 参考选中对准当前第一张
      var curPhotos = self.validPhotos();
      var pk = self.state.designPhotoKey;
      var pkValid = pk && curPhotos.some(function (x) { return x && x.key === pk; });
      if (curPhotos.length && !pkValid) self.state.designPhotoKey = curPhotos[0].key;
      self.saveState();
      // 远端图先预加载（浏览器缓存命中）再重建 DOM：否则缩略图的 src 从本地 blob 换到远端地址后
      // 会先渲染成空白、等图加载完才出现，看起来「闪一下」
      var preload = results.map(function (d) {
        return new Promise(function (resolve) {
          // 预加载展示用的缩略图（小图快）；没有缩略图才预加载原图
          var u = (d && d.thumb_url) || (d && d.view_url);
          if (!u) return resolve();
          var im = new Image();
          im.onload = im.onerror = function () { resolve(); };
          im.src = u;
        });
      });
      return Promise.all(preload).then(function () {
        self.renderPhotos();
        self.renderPageUpload();
        // 由「Create AI design」触发的首次上传：传完直接打开设计弹窗
        if (self._designModalPendingOpen) {
          self._designModalPendingOpen = false;
          self.openDesignModal();
        } else if (self.els.designModal && !self.els.designModal.hidden) {
          // 弹窗正开着（替换照片）：同步刷新弹窗里的照片预览
          self.renderDesignModal();
        }
      });
    }).catch(function (e) {
      // 整批失败：本批占位按 _upId 精确「置空回空槽」（map 而非 filter，不 compact 数组，
      // 其余照片保持原位），用户可直接在原空槽重试
      self._designModalPendingOpen = false;
      var batchIds = {};
      placeholders.forEach(function (p) { batchIds[p._upId] = true; });
      self.state.photos = self.photos().map(function (p) {
        return (p && p._pending && batchIds[p._upId]) ? null : p;
      });
      self.syncPrimaryPhoto();
      self.saveState();
      self.renderPhotos();
      self.renderPageUpload();
      // 错误同时提示到产品页上传区：弹窗关闭时 uploadError 不可见，失败会无声无息
      var errMsg = t('err.upload_failed', { msg: e.message });
      self.showError(errEl, errMsg);
      if (self.els.pageUploadError) self.showError(self.els.pageUploadError, errMsg);
    }).then(function () {
      if (self.els.uploadSpinner) self.els.uploadSpinner.hidden = true;
      if (self.els.pageUploadSpinner) self.els.pageUploadSpinner.hidden = true;
    });
  };

  Customizer.prototype.removePhoto = function (index) {
    if (index == null || isNaN(index)) index = 0;
    var arr = this.photos();
    // 保留槽位：只把该位置置空，后续照片不补位（删除图1后图2仍在图2的位置）
    var removed = (index >= 0 && index < arr.length) ? arr[index] : null;
    if (index >= 0 && index < arr.length) arr[index] = null;
    // face 纵向照片列同步删除：删除就是删除，不需要再往列表里补新项；
    // 若删的正是当前参考照片，选中态回落到列表里剩余的最后一张（没有则清空）
    var removedKey = removed && removed.key;
    if (removedKey) {
      this.state.designPhotos = (this.state.designPhotos || []).filter(function (p) {
        return !p || p.key !== removedKey;
      });
      if (this.state.designPhotoKey === removedKey) {
        var rest = this.state.designPhotos;
        this.state.designPhotoKey = rest.length ? rest[rest.length - 1].key : null;
      }
    }
    this.syncPrimaryPhoto();
    this.saveState();
    this.renderPhotos();
    this.renderPageUpload();
    // 弹窗开着时整块刷新（大图/参考图高亮同步）；否则只重建 face 列表
    if (this.designBox && this.els.designModal && !this.els.designModal.hidden) this.renderDesignModal();
    else this.renderDesignFaceList();
  };

  /* 调整照片左右顺序（多人/人宠模式）：delta = -1 左移，+1 右移 */
  Customizer.prototype.movePhoto = function (index, delta) {
    if (this.has2d()) return;
    var photos = this.photos();
    if (index == null || isNaN(index)) return;
    var to = Number(index) + Number(delta);
    if (!(to >= 0 && to < photos.length) || index < 0 || index >= photos.length) return;
    var item = photos.splice(index, 1)[0];
    photos.splice(to, 0, item);
    this.syncPrimaryPhoto();
    this.saveState();
    this.renderPhotos();
  };

  /* 第二步 idle 缩略图：按上传数量渲染（Solo 1 张 / Duo 2 张横向并排，容器加高 1.2 倍）
     图片统一用展示缩略图（缺失自动回退原图），object-fit: contain 保持原比例自适应 */
  Customizer.prototype.renderGen2dThumb = function () {
    var self = this;
    var wrap = this.els.gen2dThumb;
    if (!wrap) return;
    var max = this.maxPhotos();
    var list = this.validPhotos().slice(0, max > 0 ? max : 1);
    wrap.innerHTML = '';
    wrap.classList.toggle('is-multi', list.length > 1);
    if (!list.length) {
      // 无照片时保留空 img 占位（不渲染破图），data-gen2d-source 供上传完成后回填 r2_url 定位首图
      var ph = document.createElement('img');
      ph.setAttribute('data-gen2d-source', '');
      ph.alt = 'Your photo';
      wrap.appendChild(ph);
      this.els.gen2dSource = ph;
      return;
    }
    var first = null;
    list.forEach(function (p, i) {
      var img = document.createElement('img');
      if (i === 0) { img.setAttribute('data-gen2d-source', ''); first = img; }
      img.alt = 'Photo ' + (i + 1);
      var src = self.photoThumbUrl(p);
      if (src) img.src = src;
      self.bindPhotoFallback(img, p);
      wrap.appendChild(img);
    });
    this.els.gen2dSource = first;
  };

  /* ---------- step 2: 2D ---------- */
  Customizer.prototype.prepareStep2 = function () {
    this.renderGen2dThumb();
    var label = this.styleName(this.state.style);
    if (this.figureIdx >= 0 && this.state.figure) label += ' · ' + this.state.figure;
    this.gen2dStyleLabel = label;
    this.renderGen2dDesc();
    this.renderCredits();
    if (this.state.img2d) {
      this.els.gen2dResult.src = this.state.img2d.url;
      this.setGenView('2d', 'done');
      this.els.goto3.disabled = false;
      this.syncRegenControl();
      this.renderGen2dHistory();
    } else {
      this.setGenView('2d', 'idle');
      this.updateGenButtonState();
      // 上次客户端超时/关页面留下的未终结任务：回到 Step 2 自动续轮，不丢任务、不重复扣费
      if (this.state.img2dPending) this.resumeGen2dPolling();
    }
  };

  /* 恢复一条已提交但未终结的 2D 任务轮询（任务号存于 state.img2dPending） */
  Customizer.prototype.resumeGen2dPolling = function () {
    var taskId = this.state.img2dPending;
    if (!taskId) return;
    this._gen2dRealP = 6;
    this._gen2dBarP = 0;   // 恢复轮询：进度条基准重置，从 6% 重新推进
    try {
      this.setGenView('2d', 'running');
      if (this.els.gen2dStatus) this.els.gen2dStatus.textContent = t('gen.status_drawing');
      this.setGen2dBar(6);
      this.setGenRun('2d', 6);
    } catch (e) { /* UI 准备失败不阻断续轮 */ }
    this.startGen2dPulse();
    this.attachGen2dPolling(taskId);
  };

  /* 重刷入口：3D 已生成后单向锁定（隐藏按钮）；积分不足时置灰 */
  Customizer.prototype.syncRegenControl = function () {
    if (!this.els.gen2dRegenWrap) return;
    this.els.gen2dRegenWrap.hidden = !!this.state.model3d;
    if (this.els.gen2dRegen) {
      this.els.gen2dRegen.disabled = this.balance != null && this.balance < this.cost2d;
    }
    this.renderRegenWarn();
  };

  /* 历史预览的数据源：同一张原图（同一会话）下生成过的全部 2D 图（含每次重刷），
     当前大图除外。优先用服务端历史（含所有重刷记录），本地替换池作即时兜底。 */
  Customizer.prototype.gen2dHistoryItems = function () {
    var curId = this.state.img2d ? this.state.img2d.taskId : null;
    var curSession = this.state && this.state.session;
    var seen = {};
    var out = [];
    (this.historyItems || []).forEach(function (x) {
      if (!x || x.kind !== '2d' || !x.task_id) return;
      if (curSession && x.session_id !== curSession) return;
      if (x.task_id === curId || seen[x.task_id]) return;
      seen[x.task_id] = true;
      out.push({ taskId: x.task_id, key: x.key, url: x.view_url || x.thumb_url || '' });
    });
    (this.state.img2dHistory || []).forEach(function (x) {
      if (!x || !x.key || !x.taskId || seen[x.taskId] || x.taskId === curId) return;
      seen[x.taskId] = true;
      out.push({ taskId: x.taskId, key: x.key, url: x.url || '' });
    });
    return out;
  };

  /* 历史预览：同一张原图下生成过的全部 2D 图（可点击切回左侧大图） */
  Customizer.prototype.renderGen2dHistory = function () {
    var self = this;
    var box = this.els.gen2dHistory, list = this.els.gen2dHistoryList;
    if (!box || !list) return;
    var items = this.gen2dHistoryItems();
    this._gen2dHistItems = items;
    if (!items.length) { box.hidden = true; list.innerHTML = ''; return; }
    list.innerHTML = items.map(function (it, i) {
      // 始终渲染 <img>：缺 url 时先占位，签名后再回填（否则首次重刷永远看不到历史图）
      return '<button type="button" class="ai3d-gen__history-item" data-gen2d-history-item="' + i + '">'
        + '<img' + (it.url ? ' src="' + escapeHtml(it.url) + '"' : '') + ' alt="">'
        + '</button>';
    }).join('');
    box.hidden = false;
    // 渲染后同步圆按钮禁用态（隐藏态下测不到尺寸，等一帧再量）
    requestAnimationFrame(function () { self.syncGen2dHistoryNav(); });
    // 预览签名链接 30 分钟过期：缺 url 的按 R2 key 重新签名
    items.forEach(function (it, i) {
      if (it.url || !it.key) return;
      self.api.sign(it.key, self.state.session).then(function (d) {
        it.url = d.view_url;
        var img = list.children[i] && list.children[i].querySelector('img');
        if (img) img.src = it.url;
      }).catch(function () {});
    });
  };

  /* 圆按钮翻页：每次滚过一张缩略图（含 8px 间隙） */
  Customizer.prototype.scrollGen2dHistory = function (dir) {
    var list = this.els.gen2dHistoryList;
    if (!list) return;
    var first = list.children[0];
    var step = first ? first.getBoundingClientRect().width + 8 : list.clientWidth * 0.6;
    if (!step) return;
    list.scrollBy({ left: dir * step, behavior: 'smooth' });
  };

  /* 按滚动位置禁用左右按钮：到头禁左、到尾禁右；不足一屏时两个都禁用 */
  Customizer.prototype.syncGen2dHistoryNav = function () {
    var list = this.els.gen2dHistoryList;
    if (!list) return;
    var max = list.scrollWidth - list.clientWidth;
    if (this.els.gen2dHistoryPrev) this.els.gen2dHistoryPrev.disabled = list.scrollLeft <= 2;
    if (this.els.gen2dHistoryNext) this.els.gen2dHistoryNext.disabled = max <= 2 || list.scrollLeft >= max - 2;
  };

  /* 点历史缩略图：直接切回该图作为当前大图（不再与原图互换）；
     原当前图回到本地替换池，保证服务端历史尚未刷新时也不丢 */
  Customizer.prototype.selectGen2dHistory = function (index) {
    var self = this;
    var items = this._gen2dHistItems || this.gen2dHistoryItems();
    var it = items[index];
    if (!it) return;
    var apply = function () {
      var prev = self.state.img2d || null;
      if (prev && prev.key && prev.taskId !== it.taskId) {
        var exists = (self.state.img2dHistory || []).some(function (x) { return x && x.taskId === prev.taskId; });
        if (!exists) {
          self.state.img2dHistory.unshift({ taskId: prev.taskId, key: prev.key, url: prev.url });
          if (self.state.img2dHistory.length > 8) self.state.img2dHistory.length = 8;
        }
      }
      self.state.img2d = { taskId: it.taskId, key: it.key, url: it.url };
      if (self.els.gen2dResult) self.els.gen2dResult.src = it.url || '';
      self.saveState();
      self.syncRegenControl();
      self.renderGen2dHistory();
      self.syncRecentSelection();
      self.playGen2dSwap();   // 播放「替换」动画：大图已切换到所选历史图
    };
    if (it.url) { apply(); return; }
    if (!it.key) return;
    // 历史图 url 缺失（签名过期/首次）：按 R2 key 重新签名后再切换
    this.api.sign(it.key, this.state.session).then(function (d) {
      it.url = d.view_url;
      apply();
    }).catch(function () {});
  };

  /* 切换大图：播放一次「替换」动画，提示已切换 */
  Customizer.prototype.playGen2dSwap = function () {
    var shot = this.els.gen2dZoom;   // 大图所在的按钮
    if (!shot) return;
    shot.classList.remove('is-swapping');
    void shot.offsetWidth;
    shot.classList.add('is-swapping');
    shot.addEventListener('animationend', function () { shot.classList.remove('is-swapping'); }, { once: true });
  };

  Customizer.prototype.updateGenButtonState = function () {
    var insufficient2 = this.balance != null && this.balance < this.cost2d;
    var insufficient3 = this.balance != null && this.balance < this.cost3d;
    if (this.els.gen2dStart) this.els.gen2dStart.disabled = !!insufficient2;
    if (this.els.gen2dRegen) this.els.gen2dRegen.disabled = !!insufficient2;
    this.renderRegenWarn();
    if (this.els.gen3dStart) this.els.gen3dStart.disabled = !!insufficient3;
    this.setInlineNote(this.els.gen2dCost, insufficient2 ? t('msg.not_enough_credits') : null);
    this.setInlineNote(this.els.gen3dCost, insufficient3 ? t('msg.not_enough_credits') : null);
  };
  Customizer.prototype.setInlineNote = function (el, note) {
    if (!el) return;
    el.dataset.base = el.dataset.base || el.textContent;
    var text = note || el.dataset.base;
    // 文案可能带链接（如积分不足提示里的 WhatsApp 入口），含标签时按 HTML 渲染
    if (text.indexOf('<') !== -1) el.innerHTML = text; else el.textContent = text;
    el.style.color = note ? '#b42318' : '';
  };

  /* 统一拼接 2D 生成提示词。cust 为客户自定义说明（弹窗提示词 + 预设标签），
     为空时等同于原流程（不追加 Customer instructions）。 */
  Customizer.prototype.buildGen2dPrompt = function (cust) {
    var self = this;
    var photos = this.validPhotos();
    if (!photos.length || !photos[0].key) return '';
    // 风格附加参考图（后台「风格管理」配置）：作为「参考图1」排在最前，用户照片顺延
    // 姿态参考图（后台按风格绑定的姿态）：紧跟风格草图，用户照片再顺延
    var refKey = (this.serverStyleRefs || {})[this.state.style] || '';
    var poseRef = (this.serverPoseRefs || {})[this.state.style] || '';
    var refOffset = (refKey ? 1 : 0) + (poseRef ? 1 : 0);
    // 统一拼接（通用产品与场景产品同一套）：
    // 风格基础提示词（后台「风格管理」＞ 主题 Section ＞ 内置默认）＋ 多主体构图约束
    // ＋ 场景道具/附加词（仅场景产品，风格中性）＋ 用户定制项 ＋ 全局后缀
    var promptMap = {};
    var sectionPrompts = parsePrompts(this.preset.stylePrompts);
    if (sectionPrompts) Object.keys(sectionPrompts).forEach(function (k) { promptMap[k] = sectionPrompts[k]; });
    if (this.serverPrompts) Object.keys(this.serverPrompts).forEach(function (k) { promptMap[k] = self.serverPrompts[k]; });
    var kind = this.figureKind();   // 场景模式返回场景锁定的人数（single/double/pet）
    var parts = [];
    var clause = figureClause(kind, photos.length, refOffset);
    if (clause) parts.push(clause);
    // 姿态（后台按风格固定绑定）：明确指定身体姿态，优先于「复刻原照姿势」
    var posePrompt = (this.serverPosePrompts || {})[this.state.style] || '';
    if (posePrompt) parts.push('Required pose: ' + posePrompt);
    // 场景附加词：只描述道具/姿势/连接/底座/打印约束，不重复风格长相
    if (this.sceneMode && this.scene && this.scene.promptAddon) parts.push(this.scene.promptAddon);
    // 场景设置里的「道具」文案（英文）由 worker 自动下发，避免文案改了提示词没跟着改
    if (this.sceneMode && this.scene && this.scene.promptProp) parts.push(this.scene.promptProp);
    // 用户定制项：服装配色（固定色板单选，标准英文色名 + 色值，通用产品无此输入时为空）
    var si = this.sceneInputValues();
    if (si.color) {
      var colorText = si.color + (si.colorHex ? ' (' + si.colorHex + ')' : '');
      parts.push('Customer-selected clothing color: "' + colorText.replace(/["<>]/g, '')
        + '". Redraw the outfit in this exact color while keeping the garment style, fit and materials from the reference photo(s); keep the face and likeness unchanged.');
    }
    var sizeNow = (this.sizeIdx >= 0 && this.sel[this.sizeIdx]) ? String(this.sel[this.sizeIdx]) : '';
    if (/^\s*6(\.0)?\s*cm/i.test(sizeNow)) {
      parts.push('Adapt the design for a 6 cm print: simplify tiny details, merge thin accessories and ribbon into bold connected shapes, and keep clear facial features.');
    }
    var suffix = this.preset.promptSuffix || '';
    if (kind === 'double' || kind === 'pet' || kind === 'pet_only') {
      suffix = suffix.replace(/single character reference/i, 'single combined reference of all subjects');
    }
    // 客户提示词（弹窗输入 + 预设标签）：追加到构图约束之后、全局后缀之前
    var text = cust ? String(cust).trim() : '';
    if (text) parts.push('Customer instructions: "' + text.replace(/["<>]/g, '') + '".');
    if (suffix) parts.push(suffix);
    return withBackground(withFullBody(buildPrompt(this.state.style, promptMap, parts.join(' '))), this.defaultBackground);
  };

  /* 2D 生成参数：每次调用都读取当前 state.session / 照片，
     403 自愈重建会话后重试能拿到新 session_id。 */
  // ai-custom 单弹窗：主图上的商品参考图（section 设置或商品主图），作为参考图 1 发给模型
  Customizer.prototype.designProductRefUrl = function () {
    var img = this.els.designStageImg;
    var ref = img ? (img.getAttribute('data-ref-src') || '') : '';
    if (!ref) return '';
    try { return new URL(ref, window.location.href).href; } catch (err) { return ref; }
  };

  /* 商品参考图传到 R2 后再作为 ref_key 提交：
     服务端直连店铺域名拉图在部分站点会被拦（表现为 502 Failed to prepare image），
     浏览器同源取图 + 复用已有的上传通道最稳；成功后缓存 key，整批只传一次 */
  Customizer.prototype.ensureDesignRefKey = function () {
    var self = this;
    if (!this.designBox) return Promise.resolve('');
    if (this._designRefKey) return Promise.resolve(this._designRefKey);
    if (this._designRefPromise) return this._designRefPromise;
    var url = this.designProductRefUrl();
    if (!url) return Promise.resolve('');
    this._designRefPromise = fetch(url, { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('ref image ' + r.status);
        return r.blob();
      })
      .then(function (blob) {
        var ext = (blob.type || '').indexOf('png') >= 0 ? 'png' : 'jpg';
        var file = new File([blob], 'product-reference.' + ext, { type: blob.type || 'image/jpeg' });
        return self.api.upload(file, self.state.session, 'user-upload');
      })
      .then(function (res) {
        var key = (res && res.key) || '';
        if (key) self._designRefKey = key;
        self._designRefPromise = null;
        return key;
      })
      .catch(function () {
        self._designRefPromise = null;
        return '';
      });
    return this._designRefPromise;
  };

  Customizer.prototype.buildGen2dPayload = function (prompt) {
    var photos = this.validPhotos();
    if (!photos.length || !photos[0].key) return null;
    // face 照片列点选的参考照片作为主体：把它排到 photos[0]（r2_key），
    // 只影响生图主体顺序，不动 state.photos / 结果选中态
    var faceKey = this.state.designPhotoKey;
    if (faceKey) {
      for (var i = 0; i < photos.length; i++) {
        if (photos[i] && photos[i].key === faceKey && i > 0) {
          photos.unshift(photos.splice(i, 1)[0]);
          break;
        }
      }
    }
    var refKey = (this.serverStyleRefs || {})[this.state.style] || '';
    var poseRef = (this.serverPoseRefs || {})[this.state.style] || '';
    var posePrompt = (this.serverPosePrompts || {})[this.state.style] || '';
    var payload = {
      session_id: this.state.session,
      r2_key: photos[0].key,
      r2_keys: photos.map(function (p) { return p.key; }),
      prompt: prompt,
      n: 1
    };
    // 单弹窗（ai-custom）没有风格库：参考图 1 = 商品主图，只把用户照片的头换上去。
    // 背景约束走全局设置；姿态以商品主图为准，不能追加「复刻用户照片姿势」，
    // 风格草图/姿态参考图也一并跳过（会覆盖掉商品参考图的 ref_key）
    if (this.designBox) {
      if (this._designRefKey) payload.ref_key = this._designRefKey;
      // 锁定内容：后台按商品配置的基础指令，始终在最前、顾客改不掉；没配则用内置通用指令
      var locked = this._designLockedPrompt || DESIGN_PRODUCT_PROMPT;
      payload.prompt = locked
        + (prompt ? ' Customer request (follow it where it conflicts with the instructions above): ' + prompt.replace(/["<>]/g, '') : '');
      payload.prompt = withBackground(payload.prompt, this.defaultBackground);
      return payload;
    }
    // 风格附加参考图：作为参考图1排在用户照片之前
    if (refKey) {
      payload.ref_key = refKey;
      payload.prompt = payload.prompt
        + ' Reference image 1 is a composition/layout sketch ONLY (it is not a subject person or pet): keep that framing and place the subjects where they appear there, while preserving the face, likeness and outfit of each subject from the reference image(s) that follow it.';
    }
    // 姿态参考图：排在风格草图之后（顺序：风格草图 → 姿态参考图 → 用户照片）
    if (poseRef) {
      payload.pose_ref_key = poseRef;
      var poseIdx = refKey ? 2 : 1;
      payload.prompt = payload.prompt
        + ' Reference image ' + poseIdx + ' is a pose/posture reference ONLY (it is not a subject person or pet): match its body posture, limb positions and facing direction, while preserving the face, likeness and outfit of each subject from the reference image(s) that follow it.';
    }
    // 姿势/动作复刻约束：放在提示词末尾，作为最强约束统一生效；
    // 后台已按风格绑定姿态时不再追加（否则会与指定姿态冲突）
    if (!posePrompt) payload.prompt = withPose(payload.prompt);
    return payload;
  };

  Customizer.prototype.runGen2D = function () {
    var self = this;
    var errEl = this.els.gen2dError;
    errEl.hidden = true;

    var photos = this.validPhotos();
    if (!photos.length || !photos[0].key) return;
    // 客户提示词输入框（新 AI 模板 enable_prompt_input）：追加到构图约束之后、全局后缀之前
    var custEl = document.querySelector('[data-prompt-input]');
    var cust = custEl && custEl.value ? String(custEl.value).trim() : '';
    var prompt = this.buildGen2dPrompt(cust);

    // 新一轮生成：立刻重置 Check status 计时（上一轮超时标记不能残留），
    // 保证按钮从 0 开始重新计 100 秒
    this.stopGen2dWatchdog();
    this._gen2dStartedAt = Date.now();
    this._gen2dTimedOut = false;
    this.syncGen2dRefreshBtn();

    try {
      this.setGenView('2d', 'running');
      if (this.els.gen2dStatus) this.els.gen2dStatus.textContent = t('gen.status_submitting');
      this._gen2dBarP = 0;   // 新一轮生成：进度条基准重置
      this.setGen2dBar(6);
      this.setGenRun('2d', 6);   // 关弹窗后卡片内继续显示进度
    } catch (e) { /* UI 准备失败不阻断下方生图请求 */ }
    // 脉冲放在 UI 初始化之后启动：避免先画 6.25% 又被写回 6% 的微观倒退；
    // 它与生图请求无依赖，UI 异常也不会挡住提交
    this.startGen2dPulse();    // 提交阶段与轮询间隙也持续平滑推进，进度条不会长时间纹丝不动

    var runGen2D = function () {
      return self.api.gen2d(self.buildGen2dPayload(prompt));
    };
    this.withSessionRetry(runGen2D).then(function (d) {
      self.updateBalance(d.points_balance);
      // 任务号落盘：客户端超时/关页面后，重进 Step 2 可凭它自动续轮（Worker 侧也有反查自愈兜底）
      self.state.img2dPending = d.task_id;
      self.saveState();
      self._gen2dStartedAt = Date.now();   // Check status 的 100s 计时基准
      self.attachGen2dPolling(d.task_id);
    }).catch(function (err) {
      // 提交阶段失败（402 余额不足 / 502 上游异常 / 网络中断）
      if (err.status === 409 || err.network) {
        // 409：上一条任务其实还在生成（Worker 防并发锁）；
        // 网络中断：请求可能已送达服务端并真的开始生成，只是浏览器没收到响应。
        // 两种情况都不能定性失败、更不能说「已退款」——保持「生成中」并按会话找回任务。
        self.recoverGen2dTask();
        return;
      }
      self.refreshBalanceAfterFailure();
      self.clearGenRun();
      if (self.state.img2d) {
        self.setGenView('2d', 'done');
        self.syncRegenControl();
        self.renderGen2dHistory();
      } else {
        self.setGenView('2d', 'idle');
      }
      self.showRetryError(errEl, err.message || t('err.gen_failed'), function () { self.runGen2D(); },
        err.status === 402 ? null : t('msg.refunded'));
    });
  };

  /* 挂载 2D 任务轮询：首次生成 / 重刷 / 超时后续轮 / 重开定制器恢复共用同一条链。
     - 成功或真失败：清除 state.img2dPending；
     - 仅客户端等待超时：保留任务号，下次进 Step 2 自动续轮（任务在服务端可能仍会成功）。 */
  Customizer.prototype.attachGen2dPolling = function (taskId) {
    var self = this;
    var errEl = this.els.gen2dError;
    // 同一任务的轮询链已活着（如在步骤间切换又回到 Step 2）：不重复挂载，避免双倍请求
    if (this._gen2dAttaching === taskId) return;
    this._gen2dAttaching = taskId;
    this.startGen2dWatchdog();   // 生成中满 100s 才显示 Check status
    this.pollTask(taskId, 'apimart', {
      interval: POLL_2D_MS, timeout: TIMEOUT_2D_MS,
      onTick: function (p, status) {
        if (self.els.gen2dStatus) {
          self.els.gen2dStatus.textContent = status === 'queued' ? t('gen.status_queued') : t('gen.status_drawing');
        }
        // 真实进度只升不降：接口偶尔回传较小值时若直接绘制会造成进度倒退，
        // 这里仅记录峰值，进度条统一由 startGen2dPulse 按「峰值与模拟增速取较大者」单调绘制
        if (p > (self._gen2dRealP || 0)) self._gen2dRealP = p;
        // 注意：进度到 100% 也不显示 Check status——任务完成后轮询链自己会收尾，
        // 提前露出按钮只会让用户误以为卡住（按钮仅在严重超时/断线后出现）
        if (!self._gen2dPulse) {   // 脉冲万一已停：按峰值直接绘制，进度不会卡死
          var np = self._gen2dRealP || 0;
          self.setGen2dBar(np);
          self.setGenRun('2d', np);
        }
      }
    }).then(function (r) {
      delete self._gen2dAttaching;
      // 任务收尾：停掉 100s 计时并收起 Check status
      self.stopGen2dWatchdog();
      self._gen2dStartedAt = null;
      self._gen2dTimedOut = false;
      self.syncGen2dRefreshBtn();
      delete self.state.img2dPending;
      self.saveState();
      // 重刷：旧图移入历史预览（仅展示、不可回选），当前图替换为最新一张
      var prev = self.state.img2d;
      if (prev && prev.key) {
        self.state.img2dHistory.unshift({ taskId: prev.taskId, key: prev.key });
        if (self.state.img2dHistory.length > 8) self.state.img2dHistory.length = 8;
      }
      self.state.img2d = { taskId: r.task_id, key: r.r2_key, url: r.r2_url };
      self.saveState();
      if (self.els.goto3) self.els.goto3.disabled = false;
      self.syncRegenControl();
      self.renderGen2dHistory();
      self.loadHistory();            // 新出图同步刷新主图下方的生成历史
      // 预加载新图完成后再换 src + 切 done 视图：r2_url 是新签名链接，
      // 直接换 src 会先清空大图再空白等待加载（earlier portraits 越多越明显）
      var showDone = function () {
        if (self.els.gen2dResult) self.els.gen2dResult.src = r.r2_url;
        self.setGenView('2d', 'done');
        self.clearGenRun();          // 卡片内改为显示前后对比
      };
      var probe = new Image();
      probe.onload = showDone;
      probe.onerror = showDone;      // 预加载失败也切回，避免卡在生成中视图
      probe.src = r.r2_url;
    }).catch(function (err) {
      delete self._gen2dAttaching;   // 链已结束（含超时）：允许稍后重新挂载
      self.stopGen2dWatchdog();      // 客户端计时到此为止，下面按结果决定按钮显隐
      self.refreshBalanceAfterFailure();
      // 客户端等待超时 / 轮询途中网络中断：任务在服务端大概率还在跑，
      // 绝不能定性为失败或「已退款」。保留任务号、保持「生成中」视图，
      // 并给出「Check status」手动入口（重进 Step 2 也会自动续轮）。
      if (err.timedOut || err.network) {
        if (self.els.gen2dStatus) self.els.gen2dStatus.textContent = t('gen.status_drawing');
        self.startGen2dPulse();
        self.setGenView('2d', 'running');
        // 超时/断网：任务在服务端大概率还在跑。重新挂上 100 秒计时，
        // 到点后才浮出 Check status（断网发生得早时不会立刻出现）
        self.startGen2dWatchdog();
        // 只留文案，手动入口统一用上面那个按钮，避免同屏出现两个同名按钮
        self.showError(errEl, t('msg.check_status'));
        return;
      }
      // 服务端明确判定失败（含已退款）：清任务号，回到可重试状态
      delete self.state.img2dPending;
      self._gen2dStartedAt = null;
      self._gen2dTimedOut = false;
      self.syncGen2dRefreshBtn();
      self.saveState();
      self.clearGenRun();
      if (self.state.img2d) {
        // 重刷失败：保留原效果图，回到已生成视图
        self.setGenView('2d', 'done');
        self.syncRegenControl();
        self.renderGen2dHistory();
      } else {
        self.setGenView('2d', 'idle');
      }
      self.showRetryError(errEl, err.message || t('err.gen_failed'), function () { self.runGen2D(); },
        err.status === 402 ? null : t('msg.refunded'));
    });
  };

  /* 找回 2D 任务并继续等待出图。
     触发场景：① 提交请求网络中断（浏览器拿不到 task_id）；② 撞上 Worker 防并发锁（409）；
     ③ 用户点「生成中」面板上的 Check status；④ 客户端超时/轮询中断后点提示里的按钮。
     任务可能已在服务端生成中甚至已完成，所以既不报失败也不重新提交（会双扣积分）：
     先看本地任务号，没有就按会话反查服务端最新任务，拿到后交给同一条轮询链收尾。
     只有反查确认「该会话确实没有任何任务」时，才提示重试（此时未扣费，不浪费用户积分）。 */
  Customizer.prototype.recoverGen2dTask = function () {
    var self = this;
    var errEl = this.els.gen2dError;
    var btn = this.els.gen2dRefresh;
    var taskId = this.state.img2dPending;
    // 手动反查也算一次「生成中」：没有起始时间时以本次点击为基准（按钮仍按 100 秒规则出现）
    if (!this._gen2dStartedAt) this._gen2dStartedAt = Date.now();
    if (errEl) errEl.hidden = true;
    if (btn) btn.disabled = true;

    // 保持「生成中」视图：进度条继续跑，用户看到的是「还在处理」而不是「失败了」
    this.setGenView('2d', 'running');
    if (this.els.gen2dStatus) this.els.gen2dStatus.textContent = t('gen.status_reconnecting');
    this.startGen2dPulse();

    var release = function () { if (btn) btn.disabled = false; };
    var req = taskId
      ? this.api.task(taskId, 'apimart')
      : this.api.taskLatest(this.state.session, 'apimart');

    req.then(function (r) {
      release();
      var id = r.task_id || taskId;
      if (id && id !== self.state.img2dPending) {
        self.state.img2dPending = id;
        self.saveState();
      }
      if (!id) throw new Error(t('err.gen_failed'));
      // completed / failed / running 统一交给轮询链收尾：
      // 链还活着时它自己会拿到结果；链已结束（超时/断网中断）则由这里重新挂上
      if (r.status === 'completed' || r.status === 'failed') {
        self.attachGen2dPolling(id);
        return;
      }
      if (r.progress > (self._gen2dRealP || 0)) self._gen2dRealP = r.progress;
      if (self.els.gen2dStatus) self.els.gen2dStatus.textContent = t('gen.status_drawing');
      self.attachGen2dPolling(id);
    }).catch(function (err) {
      release();
      // 反查确认服务端没有该会话的任务：提交没送达、未扣费 → 这才提示重试
      if (err.status === 404) {
        self.clearGenRun();
        if (self.state.img2d) {
          self.setGenView('2d', 'done');
          self.syncRegenControl();
          self.renderGen2dHistory();
        } else {
          self.setGenView('2d', 'idle');
        }
        self.showRetryError(errEl, t('msg.not_submitted'), function () { self.runGen2D(); });
        return;
      }
      // 查询本身也失败（网络仍未恢复）：保持「生成中」，给一个可再次点击的入口
      self.showRetryError(errEl, t('msg.check_status'), function () { self.recoverGen2dTask(); },
        null, t('btn.check_status'));
    });
  };

  /* ---------- step 3: 3D ---------- */
  Customizer.prototype.prepareStep3 = function () {
    if (this.state.img2d && this.state.img2d.url) this.els.gen3dSource.src = this.state.img2d.url;
    this.renderCredits();
    if (this.state.model3d) {
      this.els.gen3dViewer.src = this.state.model3d.url;
      this.setGenView('3d', 'done');
      this.els.goto4.disabled = false;
    } else {
      this.setGenView('3d', 'idle');
      this.updateGenButtonState();
    }
  };

  Customizer.prototype.runGen3D = function () {
    var self = this;
    var errEl = this.els.gen3dError;
    errEl.hidden = true;

    if (!this.state.img2d) return;

    this.setGenView('3d', 'running');
    this.els.gen3dStatus.textContent = t('gen.status_3d_queued');
    this.els.gen3dPct.textContent = '5%';
    this.setGenRun('3d', 5);   // 关弹窗后卡片内继续显示进度

    var runGen3D = function () {
      return self.api.gen3d({
        session_id: self.state.session,           // 每次读取，403 自愈重建后取到新会话
        r2_key: self.state.img2d.key
      });
    };
    this.withSessionRetry(runGen3D)
      .then(function (d) {
        self.updateBalance(d.points_balance);
        return self.pollTask(d.task_id, 'tripo', {
          interval: POLL_3D_MS, timeout: TIMEOUT_3D_MS,
          onTick: function (p, status) {
            self.els.gen3dStatus.textContent = status === 'queued'
              ? t('gen.status_3d_queued')
              : t('gen.status_sculpting');
            self.els.gen3dPct.textContent = p + '%';
            self.setGenRun('3d', p);
          }
        });
      }).then(function (r) {
        self.state.model3d = { taskId: r.task_id, key: r.r2_key, url: r.r2_url };
        self.els.gen3dViewer.src = r.r2_url;
        self.saveState();
        self.setGenView('3d', 'done');
        self.clearGenRun();          // 卡片内恢复前后对比（并显示 3D 预览入口）
        self.els.goto4.disabled = false;
        self.loadHistory();          // 新模型同步刷新主图下方的生成历史
      }).catch(function (err) {
        self.setGenView('3d', 'idle');
        self.refreshBalanceAfterFailure();
        self.clearGenRun();
        self.showRetryError(errEl, err.message || t('err.gen_failed'), function () { self.runGen3D(); },
          err.status === 402 ? null : t('msg.refunded'));
      });
  };

  /* ---------- polling ---------- */
  Customizer.prototype.pollTask = function (taskId, provider, opts) {
    var self = this;
    var start = Date.now();
    var baseProgress = provider === 'tripo' ? 5 : 8;
    var speed = provider === 'tripo' ? 0.12 : 0.35; // % per second fake growth

    function timedOutError() {
      var te = new Error('Timed out. Your generation may still finish — it will resume automatically when you reopen this step.');
      te.timedOut = true;   // 调用方据此保留任务号，不当作最终失败清掉
      return te;
    }

    function tick() {
      return self.api.task(taskId, provider).then(function (r) {
        if (r.status === 'completed') return r;
        if (r.status === 'failed') {
          var msg = (r.error && r.error.message) || 'Generation failed';
          var e = new Error(msg); e.refunded = r.refunded; throw e;
        }
        var elapsed = (Date.now() - start) / 1000;
        var p = (r.progress && r.progress > 0) ? r.progress : Math.min(88, baseProgress + elapsed * speed);
        opts.onTick && opts.onTick(Math.round(p), r.status);
        if (Date.now() - start > opts.timeout) throw timedOutError();
        return sleep(opts.interval).then(tick);
      }).catch(function (err) {
        // 单次请求抖动（短暂断网）不算严重超时：在总时限内继续轮询，
        // 避免网络一抖就冒出 Check status；真到时限才按严重超时处理
        if (err && err.network) {
          if (Date.now() - start > opts.timeout) throw timedOutError();
          return sleep(opts.interval).then(tick);
        }
        throw err;
      });
    }
    return tick();
  };

  /* ---------- 按需格式转换下载（不扣积分） ---------- */
  Customizer.prototype.runConvert3D = function (format) {
    var self = this;
    var btn = this.els.convertBtns[format];
    if (!btn || btn.disabled) return;

    btn.disabled = true;
    var spinner = btn.querySelector('.ai3d-btn__spinner');
    var label = btn.querySelector('.ai3d-btn__label');
    var origLabel = label ? label.textContent : ('Download ' + format);
    if (spinner) spinner.hidden = false;
    if (label) label.textContent = 'Converting…';

    this.api.convert3d({
      session_id: this.state.session,
      format: format
    }).then(function (d) {
      return self.pollTask(d.task_id, 'tripo_convert', {
        interval: POLL_3D_MS, timeout: TIMEOUT_3D_MS,
        onTick: function (p, status) {
          if (label) label.textContent = 'Converting… ' + p + '%';
        }
      });
    }).then(function (r) {
      // 转换完成：触发浏览器下载
      var a = document.createElement('a');
      a.href = r.r2_url;
      a.download = 'model.' + format.toLowerCase();
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }).catch(function (err) {
      self.els.gen3dError.textContent = (err && err.message) || 'Conversion failed. Please try again.';
      self.els.gen3dError.hidden = false;
    }).then(function () {
      // 恢复按钮（无论成功失败）
      btn.disabled = false;
      if (spinner) spinner.hidden = true;
      if (label) label.textContent = origLabel;
    });
  };

  Customizer.prototype.refreshBalanceAfterFailure = function () {
    var self = this;
    this.api.verify().then(function (d) { self.updateBalance(d.points_balance); }).catch(function () {});
  };

  /* ---------- step 4: options + cart ---------- */
  Customizer.prototype.enterStep4 = function () {
    this.gotoStep(4);
  };

  Customizer.prototype.prepareStep4 = function () {
    var self = this;

    // 恢复/初始化选项
    if (this.state.optionSel) {
      this.sel = {};
      var saved = this.state.optionSel;
      Object.keys(saved).forEach(function (k) { self.sel[k] = saved[k]; });
    }
    // 风格/人物模式是本流程内的锁定项：始终回填，保证只读组选中态与加价基准正确
    if (this.styleIdx >= 0 && this.state.style) this.sel[this.styleIdx] = this.state.style;
    if (this.figureIdx >= 0 && this.state.figure) this.sel[this.figureIdx] = this.state.figure;

    this.renderOptionGroups();
    this.applySelectionToGroups();
    this.updateSummary();

    this.els.summary2d.src = this.state.img2d ? this.state.img2d.url : '';
    // 3D 只留入口按钮：有模型才显示，地址存下来，点击时才在 lightbox 里加载
    var mv3d = this.state.model3d;
    this.els.summary3d.hidden = !mv3d;
    if (mv3d) this.els.summary3d.setAttribute('data-src', mv3d.url);
    else this.els.summary3d.removeAttribute('data-src');
    this.els.summaryStyle.textContent = (this.preset.styleOptionName || 'Style') + ': ' + this.styleName(this.state.style);
  };

  // Step 4 选项组：列出产品全部选项（含在定制流程内已锁定的 Style / Figure，只读展示加价），
  // 每个值都显示相对基准组合的加价（不同选项加价不同）
  Customizer.prototype.renderOptionGroups = function () {
    var self = this;
    var area = this.els.optionsArea;
    area.innerHTML = '';

    (this.options || []).forEach(function (optionName, idx) {
      // 风格/人物模式在进入定制前已锁定：这里只读展示（含加价），不提供切换入口
      var locked = (idx === self.styleIdx || idx === self.figureIdx);
      var values = self.optionValues(idx);
      if (!values.length) return;

      var group = document.createElement('div');
      group.className = 'ai3d-option-group' + (locked ? ' is-locked' : '');
      group.setAttribute('data-option-index', idx);

      var label = document.createElement('p');
      label.className = 'ai3d-option-group__label';
      label.textContent = optionName;
      if (locked) {
        var lock = document.createElement('span');
        lock.className = 'ai3d-option-group__lock';
        lock.textContent = '🔒 ' + t('step4.locked');
        label.appendChild(lock);
      }
      group.appendChild(label);

      var row = document.createElement('div');
      row.className = 'ai3d-option-values';

      values.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ai3d-option-value';
        b.setAttribute('data-value', val);

        var nameSpan = document.createElement('span');
        nameSpan.className = 'ai3d-option-value__name';
        nameSpan.textContent = (idx === self.styleIdx) ? (self.styleName(val) || val) : val;
        b.appendChild(nameSpan);

        var delta = document.createElement('span');
        delta.className = 'ai3d-option-value__delta';
        delta.hidden = true;
        b.appendChild(delta);

        if (locked) {
          b.disabled = true;
          b.classList.add('is-locked');
          b.setAttribute('aria-disabled', 'true');
        } else {
          b.addEventListener('click', function () {
            self.sel[idx] = val;
            self.state.optionSel = self.optionSelSnapshot();
            self.saveState();
            self.applySelectionToGroups();
            self.updateSummary();
          });
        }
        row.appendChild(b);
      });

      group.appendChild(row);
      area.appendChild(group);
    });
  };

  // 选项值的权威来源：优先取产品选项定义（liquid 下发的 options_with_values），
  // 变体矩阵仅作回退（值未生成变体组时也能完整展示）
  Customizer.prototype.optionValues = function (idx) {
    var defs = this.preset.optionsWithValues || [];
    var def = defs[idx];
    if (def && def.values && def.values.length) {
      if (!def.name || def.name === this.options[idx]) return def.values.slice();
    }
    return this.uniqueOptionValues(idx);
  };

  Customizer.prototype.uniqueOptionValues = function (idx) {
    var seen = {}, out = [];
    (this.product.variants || []).forEach(function (v) {
      var val = v.options[idx];
      if (val && !seen[val]) { seen[val] = 1; out.push(val); }
    });
    return out;
  };

  // 加价基准价（分为单位）：默认「当前已选组合」；后台可切为「最低价组合」
  Customizer.prototype.priceDeltaBase = function () {
    if (this.priceDeltaBaseMode === 'lowest') {
      var lo = null;
      (this.product.variants || []).forEach(function (v) {
        if (typeof v.price !== 'number') return;
        if (lo === null || v.price < lo) lo = v.price;
      });
      return lo;
    }
    var cur = this.findVariant(this.sel);
    if (cur) return cur.price;
    // 当前组合缺变体时退回最低价，避免整组加价都显示不出来
    var min = null;
    (this.product.variants || []).forEach(function (v) {
      if (typeof v.price !== 'number') return;
      if (min === null || v.price < min) min = v.price;
    });
    return min;
  };

  // 某选项值的加价（分为单位）；无对应变体或无基准时返回 null
  Customizer.prototype.priceDeltaFor = function (idx, val, base) {
    var probe = {};
    for (var k in this.sel) probe[k] = this.sel[k];
    probe[idx] = val;
    var v = this.findVariant(probe);
    if (!v || typeof v.price !== 'number') return null;
    if (base === null || base === undefined) return null;
    var d = v.price - base;
    // 后台覆盖值（店铺货币单位）优先于自动算出的差额
    var ov = this.priceDeltaOverrides[this.options[idx] + '|' + val];
    if (ov !== undefined && ov !== null && ov !== '') {
      var n = parseFloat(ov);
      if (isFinite(n)) d = Math.round(n * 100);
    }
    return d;
  };

  Customizer.prototype.optionSelSnapshot = function () {
    var o = {};
    for (var i = 0; i < this.options.length; i++) {
      if (i !== this.styleIdx && i !== this.figureIdx && this.sel[i]) o[i] = this.sel[i];
    }
    return o;
  };

  // 选中态 + 不可用态 + 加价（根据风格固定 + 其它已选项计算）
  Customizer.prototype.applySelectionToGroups = function () {
    var self = this;
    var base = this.priceDeltaBase();
    var groups = $all(this.els.optionsArea, '.ai3d-option-group');
    groups.forEach(function (group) {
      var idx = Number(group.getAttribute('data-option-index'));
      // 只读组（Style / Figure）：仅作参考展示，不标「不可用」，避免看起来像选项缺失
      var locked = group.classList.contains('is-locked');
      $all(group, '.ai3d-option-value').forEach(function (btn) {
        var val = btn.getAttribute('data-value');
        var probe = {};
        for (var k in self.sel) probe[k] = self.sel[k];
        probe[idx] = val;
        var v = self.findVariant(probe);
        var available = !!(v && v.available);
        btn.classList.toggle('is-selected', self.sel[idx] === val);
        btn.classList.toggle('is-unavailable', !locked && !available);

        // 加价标签：基准值为 0（不显示），其余显示 +/− 差额
        var deltaEl = $(btn, '.ai3d-option-value__delta');
        if (!deltaEl) return;
        var d = self.priceDeltaFor(idx, val, base);
        if (d === null || d === 0) {
          deltaEl.hidden = true;
          deltaEl.textContent = '';
          deltaEl.classList.remove('is-plus', 'is-minus');
        } else {
          deltaEl.hidden = false;
          deltaEl.textContent = (d > 0 ? '+' : '−') + formatMoney(Math.abs(d), self.preset.moneyFormat);
          // 加价红 / 减价紫：颜色区分加钱与省钱
          deltaEl.classList.toggle('is-plus', d > 0);
          deltaEl.classList.toggle('is-minus', d < 0);
        }
      });
    });
  };

  Customizer.prototype.updateSummary = function () {
    var variant = this.findVariant(this.sel);
    var parts = [];
    for (var i = 0; i < this.options.length; i++) {
      if (i !== this.styleIdx && this.sel[i]) parts.push(this.options[i] + ': ' + this.sel[i]);
    }
    this.els.summaryVariant.textContent = parts.join(' · ');

    if (variant) {
      this.els.summaryPrice.textContent = formatMoney(variant.price, this.preset.moneyFormat);
      this.els.addToCart.disabled = !variant.available;
      this.els.optionsHint.textContent = variant.available ? '' : t('step4.sold_out');
      this.els.optionsError.hidden = true;
      this.currentVariant = variant;
    } else {
      this.els.summaryPrice.textContent = '—';
      this.els.addToCart.disabled = true;
      this.els.optionsHint.textContent = t('step4.select_all');
    }
  };

  Customizer.prototype.submitCart = function () {
    var self = this;
    var variant = this.currentVariant;
    // 页面直接加购（选中最近记录的 2D 效果图 / 3D 模型）时错误显示在页面上传区，弹窗关闭着，不能写弹窗内的错误位
    var directCart = !!(this.selected3d || this.selected2d);
    var errEl = directCart ? this.els.pageUploadError : this.els.optionsError;
    // 加购按钮：弹窗内用 addToCart，页面直接加购（选中 2D 效果图 / 3D 模型）用 start
    var btn = directCart ? this.els.start : this.els.addToCart;
    var spinner = btn ? $(btn, '.ai3d-btn__spinner') : null;
    // 页面按钮不是 flex 布局，转圈会掉到文字上方：加载时给按钮加 class 隐藏文案、只留居中转圈
    var isPageBtn = !!btn && btn === this.els.start;
    var setSpinner = function (show) {
      if (spinner) spinner.hidden = !show;
      if (isPageBtn) btn.classList.toggle('is-carting', !!show);
    };
    if (!variant) {
      // 页面直购时变体可能还没锁完（选图后 sessionGet 未返回/失败）：补查一次会话
      // 锁定变体再提交，避免点了只报「Please select all options.」
      var pick = this.selected2d || this.selected3d;
      if (directCart && pick && pick.session_id && !this._variantRetry) {
        var me = this;
        var resetBtn = function () { if (btn) btn.disabled = false; setSpinner(false); };
        this._variantRetry = true;
        if (errEl) errEl.hidden = true;
        // 点击后立即转圈：反查会话锁定变体的网络请求期间给出响应反馈
        if (btn) btn.disabled = true;
        setSpinner(true);
        this.api.sessionGet(pick.session_id).then(function (d) {
          me._variantRetry = false;
          var v = me.variantBySessionId(d && d.style_variant_id);
          if (!v) { resetBtn(); if (errEl) me.showError(errEl, t('step4.select_all')); return; }
          me.currentVariant = v;
          me.updatePagePrice(v);
          me.submitCart();
        }).catch(function () {
          me._variantRetry = false;
          resetBtn();
          if (errEl) me.showError(errEl, t('step4.select_all'));
        });
        return;
      }
      if (errEl) this.showError(errEl, t('step4.select_all'));
      return;
    }
    if (!variant.available) {
      if (errEl) this.showError(errEl, t('step4.sold_out'));
      setSpinner(false);
      this.els.start.disabled = true;
      return;
    }

    btn.disabled = true;
    setSpinner(true);
    var label = $(btn, '.ai3d-btn__label');

    var workerBase = (this.api && this.api.base) || '';
    var photoKeys = this.photos().map(function (p) { return p.key; }).filter(Boolean).join(',');
    var properties = {
      'Style': this.state.style,
      'Customization': '3D AI Figurine',
      '_ai_session_id': this.state.session,
      '_ai_photo_key': photoKeys,
      '_ai_2d_key': this.state.img2d ? this.state.img2d.key : '',
      '_ai_3d_key': this.state.model3d ? this.state.model3d.key : '',
      // Shopify 特殊属性：值为图片地址时，购物车/结账/订单/邮件统一用该图作为本行商品图
      '_img_url': (this.state.img2d && workerBase) ? workerBase + '/f/' + this.state.img2d.key : '',
      // 3D 模型在线预览页（下划线属性不会在结账页显示为文字）
      '_ai_3d_url': (this.state.model3d && workerBase) ? workerBase + '/m/' + this.state.model3d.key : ''
    };
    if (this.figureIdx >= 0 && this.state.figure) properties['Figure'] = this.state.figure;
    if (this.sceneMode) {
      var si = this.sceneInputValues();
      if (this.scene && this.scene.name) properties['Scene'] = this.scene.name;
      if (this.scene && this.scene.prop) properties['Scene prop'] = this.scene.prop;
      if (si.color) properties['Clothing color'] = si.color + (si.colorHex ? ' (' + si.colorHex + ')' : '');
      if (si.engraving) properties['Base engraving'] = si.engraving;
      if (si.message) properties['Gift message'] = si.message;
    }
    // 顾客填写的生图需求：同时记到订单属性，艺术家/客服能看到顾客到底要什么
    var promptInputEl = document.querySelector('[data-prompt-input]');
    var customInstructions = promptInputEl ? String(promptInputEl.value || '').trim() : '';
    if (customInstructions) properties['Custom instructions'] = customInstructions;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variant.id, quantity: 1, properties: properties })
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) {
          var msg = (body && body.description) || (body && body.message) || t('err.add_to_cart_failed');
          throw new Error(msg);
        }
        return body;
      });
    }).then(function () {
      // 加购成功：清除本地进度，跳转购物车
      self.clearState();
      window.location.href = '/cart';
    }).catch(function (err) {
      if (errEl) self.showError(errEl, err.message);
      btn.disabled = false;
      setSpinner(false);
    });
  };

  /* ---------- design-box（标准商品页 + AI 定制框，辅助设计） ----------
   * 变体由标准选择器（custom-options1 的 radio/select）驱动；AI 框只负责上传照片、
   * 生成效果图。效果图与会话信息写入表单隐藏属性，随标准 Add to cart 提交为行属性
   * （_img_url = Shopify 购物车/订单行图）。 */

  /* 从表单标准选择器重建 sel/state（data-index="optionN" 为 1 起，sel 为 0 起） */
  Customizer.prototype.syncDesignBoxSelection = function () {
    if (!this.designBox) return;
    var sel = {};
    $all(this.root, '[data-index^="option"]').forEach(function (el) {
      var idx = parseInt(String(el.getAttribute('data-index') || '').replace('option', ''), 10) - 1;
      if (isNaN(idx) || idx < 0) return;
      if (el.tagName === 'SELECT') {
        if (el.value) sel[idx] = el.value;
      } else if (el.type === 'radio' && el.checked) {
        sel[idx] = el.value;
      }
    });
    this.sel = sel;
    var prevFigure = this.state.figure;
    if (this.styleIdx >= 0) this.state.style = sel[this.styleIdx] || this.state.style;
    if (this.figureIdx >= 0) this.state.figure = sel[this.figureIdx] || this.state.figure;

    // Figure 切换后联动 Style：当前 Style 在新 Figure 下没有可售组合时，自动切到该 Figure 下
    // 第一个可售 Style，并改写标准 Style radio（Slate 按所有选中 radio 精确匹配变体，
    // 组合不存在时不会自行换 Style，页面会一直停在旧 Style）。
    if (this.styleIdx >= 0 && this.figureIdx >= 0 && this.state.figure
        && !this.styleAvailableForFigure(this.state.style, this.state.figure)) {
      var firstStyle = this.firstStyleAvailableForFigure(this.state.figure);
      if (firstStyle && firstStyle !== this.state.style) {
        this.state.style = firstStyle;
        this.sel[this.styleIdx] = firstStyle;
        $all(this.root, '[data-index="option' + (this.styleIdx + 1) + '"]').forEach(function (el) {
          if (el.tagName === 'SELECT') el.value = firstStyle;
          else if (el.type === 'radio' && el.value === firstStyle) el.checked = true;
        });
      }
    }
    if (this.figureIdx >= 0 && this.state.figure !== prevFigure) {
      // 人物模式变化 → 上传照片数量变化：裁剪超额照片槽位
      this.enforcePhotoLimit();
    }
    // Style / Figure 变化后，之前的生成结果不再对应当前变体：清空结果区并让下次生成重建会话。
    // 首次初始化（还没有 prev 值）不清空，避免刷新页面丢失已生成结果。
    var hadPrev = (this._designPrevStyle !== undefined || this._designPrevFigure !== undefined);
    if (hadPrev && (this._designPrevStyle !== this.state.style || this._designPrevFigure !== this.state.figure)) {
      // 变体变化时中止正在跑的多轮队列（在途任务仍会进历史，但不再写入新变体的结果区）
      if (this._designBatch && this._designBatch.running) this._designBatch.running = false;
      this.resetDesignResults();
    }
    this._designPrevStyle = this.state.style;
    this._designPrevFigure = this.state.figure;
    this.saveState();
    this.renderPageUpload();
  };

  /* 清空卡片右侧效果图 / 已选设计稿（换风格、换人物或换照片时调用） */
  Customizer.prototype.resetDesignResults = function () {
    if (!this.designBox) return;
    this.state.designResults = [];
    this.state.img2d = null;
    this.state.model3d = null;
    this.state.designBatch = null;
    delete this.state.designPending;
    this.selected2d = null;
    this.selected3d = null;
    this._designBatch = null;
    this._designSessionStale = true;
    this.saveState();
    if (this.els.designModal && !this.els.designModal.hidden) this.renderDesignModal();
  };

  /* ---------- design-box：设计弹窗 / 预设标签 / 多轮生图 ---------- */

  /* 上传/生成前确保有可用的定制会话；Style / Figure 变化后自动重建 */
  Customizer.prototype.ensureDesignBoxSession = function () {
    var self = this;
    if (!this.designBox) return Promise.resolve(this.state.session);
    this.syncDesignBoxSelection();
    var variant = this.findVariant(this.sel) || this.firstAvailableVariantForStyle(this.state.style);
    var vid = variant ? String(variant.id) : '';
    var stale = !!this._designSessionStale
      || (this.state.session && this.state.designSessionVariantId && vid
        && String(this.state.designSessionVariantId) !== vid);
    if (this.state.session && !stale) return Promise.resolve(this.state.session);
    if (this._designSessionPromise) return this._designSessionPromise;
    this._designSessionPromise = this.api.verify()
      .then(function () { return self.api.createSession(vid || self.state.style); })
      .then(function (d) {
        self.state.session = d.session_id;
        self.state.designSessionVariantId = vid || null;
        self._designSessionStale = false;
        self.saveState();
        self._designSessionPromise = null;
        return d.session_id;
      }, function (err) {
        self._designSessionPromise = null;
        throw err;
      });
    return this._designSessionPromise;
  };

  Customizer.prototype.initDesignBoxUI = function () {
    var self = this;
    // 设计弹窗移出表单/产品信息列：避免父级 sticky/层叠上下文把 fixed 弹窗压在图片列下面
    var stage = this.root.querySelector('[data-ai3d-product]');
    if (stage && this.els.designModal && this.els.designModal.parentNode !== stage) {
      stage.appendChild(this.els.designModal);
    }
    this._designTagDefs = parseTags(this.preset.promptTags);
    this.applyProductDesign();   // 后台按商品配置的标签/提示词/参考图/锁定内容，覆盖主题 Section 默认
    this.renderDesignTags();
    this.setDesignQuantity(this.state.designQty || 1, true);
    // 刷新后恢复「当前选中的设计稿」高亮
    if (this.state.img2d && this.state.img2d.taskId && !this.selected2d) {
      this.selected2d = {
        task_id: this.state.img2d.taskId,
        key: this.state.img2d.key,
        view_url: this.state.img2d.url,
        session_id: this.state.session
      };
    }
    this.renderDesignModal();
    // 卡片打字机引导句 + 弹窗生图区域（参考产品图 / 用户照片小窗）
    this.startDesignTyper();
    this.renderDesignStage();
    // 刷新后签名链接可能过期：缺 url 的结果按 R2 key 重新签名
    (this.state.designResults || []).forEach(function (r) {
      if (!r || !r.key || r.url) return;
      self.api.sign(r.key, r.sessionId || self.state.session).then(function (d) {
        r.url = d.view_url;
        self.saveState();
        self.renderPageUpload();
      }).catch(function () {});
    });
  };

  /* 后台按商品单独配置（快捷标签 / 默认提示词 / 参考图 / 锁定内容）覆盖主题 Section 默认。
     后台没配的项保持主题原值；标签选中项按新的标签数组重新对齐，避免越界。 */
  Customizer.prototype.applyProductDesign = function () {
    var pd = this.productDesign;
    if (!pd || !this.designBox) return;
    if (pd.promptTags) {
      this._designTagDefs = parseTags(pd.promptTags);
      var max = this._designTagDefs.length;
      this.state.designTags = (this.state.designTags || []).filter(function (i) { return i >= 0 && i < max; });
    }
    // 默认提示词：只在顾客还没写过内容时预填
    var input = this.root.querySelector('[data-prompt-input]');
    if (pd.promptDefault && input && !String(input.value || '').trim()) {
      input.value = pd.promptDefault;
    }
    // 参考图：直接用后台传好的 R2 key，跳过「下载主题图再上传」那一步
    if (pd.refImage) {
      this._designRefKey = pd.refImage;
      this._designRefPromise = null;
      if (pd.refImage_url && this.els.designStageImg) {
        this.els.designStageImg.setAttribute('src', pd.refImage_url);
        this.els.designStageImg.setAttribute('data-ref-src', pd.refImage_url);
      }
    }
    // 锁定内容：始终拼在提示词最前，顾客改不掉
    if (pd.lockedPrompt) this._designLockedPrompt = pd.lockedPrompt;
  };

  /* 预设标签：后台 Section 配置的「标签|提示词」，点击切换选中 */
  Customizer.prototype.renderDesignTags = function () {
    var wrap = this.els.promptTags;
    var box = this.els.promptTagsWrap;
    if (!wrap || !box) return;
    var defs = this._designTagDefs || [];
    if (!defs.length) {
      wrap.innerHTML = '';
      box.hidden = true;
      return;
    }
    var selected = this.state.designTags || [];
    var running = !!(this._designBatch && this._designBatch.running);
    wrap.innerHTML = defs.map(function (d, i) {
      var on = selected.indexOf(i) >= 0;
      return '<button type="button" class="ai3d-design-tag" data-design-tag="' + i + '"'
        + ' aria-pressed="' + (on ? 'true' : 'false') + '"' + (running ? ' disabled' : '') + '>'
        + escapeHtml(d.label) + '</button>';
    }).join('');
    box.hidden = false;
  };

  Customizer.prototype.designQuantity = function () {
    return Math.max(1, Math.min(4, parseInt(this.state.designQty, 10) || 1));
  };

  Customizer.prototype.setDesignQuantity = function (n, silent) {
    n = Math.max(1, Math.min(4, parseInt(n, 10) || 1));
    this.state.designQty = n;
    (this.els.designQtyBtns || []).forEach(function (b) {
      b.classList.toggle('is-active', parseInt(b.getAttribute('data-design-qty-value'), 10) === n);
    });
    // 胶囊滑块的位移交给 CSS transition（--qty-i 为 0-based 序号）
    if (this.els.designQty) this.els.designQty.style.setProperty('--qty-i', String(n - 1));
    if (!silent) this.saveState();
    this.renderDesignCost();
  };

  /* 弹窗里的价格文案：单张价 × 数量 + 余额 */
  Customizer.prototype.renderDesignCost = function () {
    var el = this.els.gen2dCost;
    if (!el) return;
    var q = this.designQuantity();
    var cost = this.cost2d > 0 ? this.cost2d : 0;
    var lack = cost > 0 && this.balance != null && this.balance < cost * q;
    if (!cost) {
      el.textContent = t('design.cost_free', { qty: q });
    } else if (lack) {
      el.textContent = t('design.not_enough', { n: q, total: cost * q, balance: this.balance });
    } else {
      el.textContent = t('design.cost', {
        qty: q,
        n: cost,
        total: cost * q,
        balance: this.balance == null ? '–' : this.balance
      });
    }
    el.style.color = lack ? '#b42318' : '';
    el.dataset.base = el.textContent;
    this.syncDesignGenerateButton();
  };

  Customizer.prototype.syncDesignGenerateButton = function () {
    var btn = this.els.gen2dStart;
    if (!btn) return;
    var b = this._designBatch;
    var running = !!(b && b.running);
    // 生成中：输入框底部操作条让位给进度条
    if (this.els.designComposer) this.els.designComposer.classList.toggle('is-running', running);
    var q = this.designQuantity();
    var lack = this.cost2d > 0 && this.balance != null && this.balance < this.cost2d * q;
    btn.disabled = running || lack;
    var spinner = $(btn, '.ai3d-btn__spinner');
    if (spinner) spinner.hidden = !running;
    var label = this.els.designGenerateLabel;
    if (!label) return;
    if (running) {
      label.textContent = t('design.running', { i: Math.min((b.completed || 0) + 1, b.total || q), n: b.total || q });
    } else {
      // 按钮文案固定为 GENERATE，不随数量变化
      label.textContent = t('design.generate');
    }
  };

  Customizer.prototype.syncDesignCta = function () {
    var hasPhotos = this.photoCount() > 0;
    var results = Math.max((this.state.designResults || []).length, this._designVisibleCount || 0);
    if (this.els.designOpenLabel) {
      this.els.designOpenLabel.textContent = results ? t('design.open_again') : t('design.open');
    }
    if (this.els.designCtaHint) {
      this.els.designCtaHint.textContent = hasPhotos ? t('design.hint_ready') : t('design.hint');
    }
  };

  /* 生图区域：默认显示参考产品图；已选中效果图时大图切换为该结果。
     右侧纵向照片列（从底部向上）显示历史上传的照片，点选切换生图参考图 */
  Customizer.prototype.renderDesignStage = function () {
    var img = this.els.designStageImg;
    if (!img) return;
    var sel = (this.state.img2d && this.state.img2d.url) ? this.state.img2d : null;
    var ref = img.getAttribute('data-ref-src') || '';
    if (sel) img.src = sel.url;
    else if (ref) img.src = ref;
    // 显示的是用户的设计结果时，按原比例缩放进正方形框（不裁切）
    if (this.els.designStage) this.els.designStage.classList.toggle('is-result', !!sel);
    if (this.els.designStageBadge) {
      this.els.designStageBadge.textContent = sel ? t('design.stage_result') : t('design.stage_reference');
      this.els.designStageBadge.classList.toggle('is-result', !!sel);
    }
    this.renderDesignFaceList();
  };

  /* 上传/修图成功的照片记入 face 历史照片列（去重、上限 12 张，跨「重新上传」保留） */
  Customizer.prototype.rememberDesignPhoto = function (p) {
    if (!p || !p.key) return;
    var list = (this.state.designPhotos || []).slice();
    for (var i = list.length - 1; i >= 0; i--) {
      if (list[i] && list[i].key === p.key) list.splice(i, 1);
    }
    list.push({
      key: p.key,
      url: p.url || '',
      thumbKey: p.thumbKey || '',
      thumbUrl: p.thumbUrl || ''
    });
    if (list.length > 12) list = list.slice(list.length - 12);
    this.state.designPhotos = list;
    // 默认参考照片：尚未点选过时取最新一张（与 photos[0] 一致）
    if (!this.state.designPhotoKey) this.state.designPhotoKey = p.key;
  };

  /* 渲染 face 纵向照片列：最新照片在最下（column-reverse），
     选中态只跟随 designPhotoKey，与右侧结果选中态互不影响 */
  Customizer.prototype.renderDesignFaceList = function () {
    var self = this;
    var listEl = this.els.designFaceList;
    if (!listEl) return;
    var items = [];
    (this.state.designPhotos || []).forEach(function (p) {
      if (!p || !p.key) return;
      var u = self.photoThumbUrl(p) || self.photoFileUrl(p) || '';
      if (u) items.push({ p: p, url: u });
    });
    if (this.els.designFace) this.els.designFace.hidden = !items.length;
    if (!items.length) { listEl.innerHTML = ''; return; }
    var active = this.state.designPhotoKey || '';
    listEl.innerHTML = items.map(function (it) {
      var on = it.p.key === active;
      return '<button type="button" class="ai3d-design-face__item' + (on ? ' is-selected' : '') + '"'
        + ' data-design-face-item="' + escapeHtml(it.p.key) + '"'
        + ' aria-pressed="' + (on ? 'true' : 'false') + '">'
        + '<img src="' + escapeHtml(it.url) + '" alt=""></button>';
    }).join('');
    $all(listEl, '[data-design-face-item]').forEach(function (b, i) {
      self.bindPhotoFallback(b.querySelector('img'), items[i].p);
    });
  };

  /* 卡片打字机：逐字打出 → 停留 → 直接换下一句重新打字（不做逐字删除）；
     系统开启减少动态效果时只显示第一句 */
  Customizer.prototype.startDesignTyper = function () {
    var el = this.els.designTyper;
    if (!el || this._typerTimer) return;
    var lines = [t('design.typer_1'), t('design.typer_2'), t('design.typer_3'), t('design.typer_4')];
    var reduce = false;
    try { reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (err) { /* 忽略 */ }
    if (reduce) { el.textContent = lines[0]; return; }
    var self = this;
    var li = 0, ci = 0;
    el.textContent = '';
    function tick() {
      if (self._destroyed) return;
      var line = lines[li] || '';
      ci++;
      el.textContent = line.slice(0, ci);
      if (ci >= line.length) {
        // 整句打完：停留一会儿后清空，直接开始打下一句（不逐字回删）
        self._typerTimer = setTimeout(function () {
          li = (li + 1) % lines.length;
          ci = 0;
          el.textContent = '';
          self._typerTimer = setTimeout(tick, 220);
        }, 1900);
        return;
      }
      self._typerTimer = setTimeout(tick, 48);
    }
    this._typerTimer = setTimeout(tick, 420);
  };

  Customizer.prototype.stopDesignTyper = function () {
    if (this._typerTimer) { clearTimeout(this._typerTimer); this._typerTimer = null; }
  };

  /* 点击预设标签：把该标签的提示词放到输入框最前面（用户已写的内容原样保留在后面）；
     再点一次只移除当初插入的那一段 */
  Customizer.prototype.applyDesignTag = function (idx) {
    var def = (this._designTagDefs || [])[idx];
    var input = this.root.querySelector('[data-prompt-input]');
    if (!def || !input) return;
    var add = String(def.prompt || '').trim();
    var cur = String(input.value || '');
    var list = (this.state.designTags || []).slice();
    var pos = list.indexOf(idx);
    this._tagInserted = this._tagInserted || {};
    var prev = this._tagInserted[idx] || '';
    if (pos >= 0) {
      // 取消选中：优先按当初插入的完整片段移除；找不到时移除该句本身
      var seg = prev || add;
      if (seg && cur.indexOf(seg) >= 0) {
        cur = cur.replace(seg, '');
        cur = cur.replace(/,\s*,/g, ', ').replace(/^[\s,]+/, '').replace(/[\s,]+$/, '');
        input.value = cur;
      }
      delete this._tagInserted[idx];
      list.splice(pos, 1);
    } else {
      list.push(idx);
      if (add && cur.toLowerCase().indexOf(add.toLowerCase()) < 0) {
        var ins = add + (cur ? ', ' : '');
        input.value = ins + cur;
        this._tagInserted[idx] = ins;
      }
    }
    this.state.designTags = list;
    this.state.designPrompt = input.value;
    this.saveState();
    this.renderDesignTags();
    input.focus();
  };

  Customizer.prototype.openDesignModal = function () {
    if (!this.els.designModal) return;
    this.syncDesignBoxSelection();
    // 上传照片已移到弹窗内，这里不再强制先有照片
    this.renderDesignModal();
    this.els.designModal.hidden = false;
    document.body.style.overflow = 'hidden';
    this.stopDesignTyper();
  };

  Customizer.prototype.closeDesignModal = function () {
    if (!this.els.designModal) return;
    this.els.designModal.hidden = true;
    document.body.style.overflow = '';
    this.syncDesignCta();
    this.startDesignTyper();
  };

  Customizer.prototype.renderDesignModal = function () {
    var self = this;
    if (!this.els.designModal) return;
    var photos = this.validPhotos();
    if (this.els.designPhotos) {
      this.els.designPhotos.innerHTML = photos.map(function (p) {
        return '<img src="' + escapeHtml(self.photoThumbUrl(p) || '') + '" alt="">';
      }).join('');
    }
    // 生图区域：参考产品图 / 选中的效果图 + 用户照片小窗
    this.renderDesignStage();
    var input = this.root.querySelector('[data-prompt-input]');
    if (input && document.activeElement !== input) input.value = this.state.designPrompt || '';
    this.renderDesignTags();
    this.setDesignQuantity(this.state.designQty || 1, true);

    var b = this._designBatch;
    var running = !!(b && b.running);
    if (this.els.designProgress) this.els.designProgress.hidden = !running;
    if (running) {
      var i = Math.min(b.total || 1, (b.completed || 0) + 1);
      // 状态文字由 setDesignRound/轮询 onTick 驱动（Submitting/Queued/Drawing），
      // 这里只更新 rounds，避免与 status 显示重复文案
      if (this.els.designRounds) this.els.designRounds.textContent = t('design.running', { i: i, n: b.total || 1 });
    }
    if (input) input.disabled = running;
    (this.els.designQtyBtns || []).forEach(function (btn) { btn.disabled = running; });
    // 生成中禁用「继续修图 / 删除」，避免中途换底图或删稿
    if (this.els.designResultActions) {
      $all(this.els.designResultActions, '[data-design-refine], [data-design-remove]').forEach(function (btn) {
        btn.disabled = running;
      });
    }
    if (this.els.promptTags) {
      $all(this.els.promptTags, '[data-design-tag]').forEach(function (btn) { btn.disabled = running; });
    }
    this.syncDesignGenerateButton();
  };

  /* 客户提示词 = 输入框内容（预设标签点击后已作为文字插入输入框，不再重复拼接） */
  Customizer.prototype.collectDesignPrompt = function () {
    var el = this.root.querySelector('[data-prompt-input]');
    return el && el.value ? String(el.value).trim() : '';
  };

  /* 点选卡片右侧的效果图：作为订单设计稿（加购带 _img_url / _ai_2d_key） */
  Customizer.prototype.selectDesignResult = function (res) {
    if (!res) return;
    this.state.img2d = { taskId: res.taskId, key: res.key, url: res.url };
    this.selected2d = {
      task_id: res.taskId,
      key: res.key,
      view_url: res.url,
      session_id: res.sessionId || this.state.session
    };
    this.selected3d = null;
    this.saveState();
    this.syncRecentSelection();
    this.renderDesignStage();
    this.updateResumeUI();
  };

  Customizer.prototype.setDesignRound = function (round, total, pct, statusText) {
    if (statusText && this.els.gen2dStatus) this.els.gen2dStatus.textContent = statusText;
    // 接口回传的进度可能在轮询间抖动回退：记录峰值，绘制只用峰值，
    // 与脉冲的 max(真实进度, 模拟增速) 取同一来源，进度条同轮内只升不降
    if (pct > (this._gen2dRealP || 0)) this._gen2dRealP = pct;
    var p = Math.max(4, Math.min(100, this._gen2dRealP || 4));
    this.setGen2dBar(p);
    if (this.els.designRounds) {
      this.els.designRounds.textContent = t('design.running', { i: round, n: total });
    }
    this.setGenRun('2d', p);
  };

  /* 弹窗 Generate：一次点击按数量排队生成，每轮完成后再隔 1–2 秒发起下一轮
     （上游同一会话只允许一条 2D 任务，串行可避免 409，也保证每张单独计费/可退款） */
  Customizer.prototype.startDesignBoxGen = function () {
    var self = this;
    if (!this.preset.workerUrl) { alert(t('err.worker_missing')); return; }
    if (this._designBatch && this._designBatch.running) return;
    this.syncDesignBoxSelection();
    var photos = this.validPhotos();
    if (!photos.length || !photos[0].key) {
      if (this.els.gen2dError) this.showError(this.els.gen2dError, t('err.need_photo'));
      this.openDesignModal();
      return;
    }
    var qty = this.designQuantity();
    var totalCost = this.cost2d * qty;
    if (this.cost2d > 0 && this.balance != null && this.balance < totalCost) {
      if (this.els.gen2dError) {
        this.showError(this.els.gen2dError, t('design.not_enough', { n: qty, total: totalCost, balance: this.balance }));
      }
      return;
    }
    var promptEl = this.root.querySelector('[data-prompt-input]');
    if (promptEl) this.state.designPrompt = promptEl.value || '';
    var cust = this.collectDesignPrompt();
    // 上次任务尚未终结（断网/关页面）：先取回该任务再继续，避免重复提交扣费
    if (this.state.designPending) {
      if (!this._designBatch) {
        this._designBatch = {
          total: qty,
          completed: (this.state.designBatch && this.state.designBatch.completed) || 0,
          running: false,
          prompt: cust
        };
      } else {
        this._designBatch.total = qty;
        this._designBatch.prompt = cust;
      }
      this.retryDesignBatch();
      return;
    }
    this._designBatch = { total: qty, completed: 0, running: true, prompt: cust };
    var batch = this._designBatch;
    this.state.designBatch = { total: qty, completed: 0, running: true };
    this.saveState();
    if (this.els.gen2dError) this.els.gen2dError.hidden = true;
    if (this.els.pageUploadError) this.els.pageUploadError.hidden = true;
    this.renderPageRecent();
    this.renderDesignModal();
    this.ensureDesignBoxSession()
      .then(function () { return self.runDesignQueue(cust, qty, 0); })
      .then(function () {
        if (self._designBatch === batch) self.finishDesignBatch();
      })
      .catch(function (err) {
        if (self._designBatch === batch) self.failDesignBatch(err);
      });
  };

  /* 串行生成队列：startAt 为已完成的轮数（重试时从失败的那一轮继续） */
  Customizer.prototype.runDesignQueue = function (prompt, total, startAt) {
    var self = this;
    var batch = this._designBatch;
    if (!batch) return Promise.resolve();
    batch.running = true;
    batch.total = total;
    batch.prompt = prompt;
    batch.completed = startAt || 0;

    function step() {
      if (!batch.running || batch.completed >= total) return Promise.resolve();
      var round = batch.completed + 1;
      batch.current = round;
      self.state.designBatch = { total: total, completed: batch.completed, running: true };
      self.saveState();
      // 新一轮进度从头开始：清掉上一轮的进度峰值与进度条基准
      self._gen2dRealP = 0;
      self._gen2dBarP = 0;
      self.setDesignRound(round, total, 4, t('gen.status_submitting'));
      return self.submitDesignRound(prompt, round, total, batch).then(function (result) {
        // 队列已被取消（切换了 Style/Figure）或在途期间被替换：不再写入结果
        if (!batch.running || self._designBatch !== batch) return;
        batch.completed = round;
        batch.current = null;
        self.state.designBatch = { total: total, completed: round, running: true };
        self.saveState();
        self.addDesignResult(result);
        if (batch.completed >= total) return;
        // 错开 1–2 秒再发起下一轮（也给上游任务收尾留出缓冲）
        return sleep(1000 + Math.floor(Math.random() * 1000)).then(step);
      }).catch(function (err) {
        // 队列已被替换/取消：旧请求的失败不能影响新批次
        if (!batch.running || self._designBatch !== batch) return;
        throw err;
      });
    }
    return step();
  };

  Customizer.prototype.submitDesignRound = function (prompt, round, total, batch) {
    var self = this;
    var taskId = null;
    var photoKey = null;    // 本轮生图主体（face 选中的参考照片），写进结果供回选时高亮
    // 队列已被替换：旧轮次不再发起请求/改动进度条
    if (batch && this._designBatch !== batch) return Promise.reject(new Error('cancelled'));
    this.startGen2dPulse();
    // 先把商品参考图传到 R2，作为参考图 1（只传一次，后续轮次复用）
    return this.ensureDesignRefKey().then(function () {
      return self.withSessionRetry(function () {
        var payload = self.buildGen2dPayload(prompt);
        if (!payload) throw new Error(t('err.need_photo'));
        photoKey = payload.r2_key || null;
        return self.api.gen2d(payload);
      });
    }).then(function (d) {
      self.updateBalance(d.points_balance);
      taskId = d.task_id;
      self.state.designPending = taskId;
      self.saveState();
      self.setDesignRound(round, total, 6, t('gen.status_queued'));
      return self.pollTask(taskId, 'apimart', {
        interval: POLL_2D_MS, timeout: TIMEOUT_2D_MS,
        onTick: function (p, status) {
          // 旧批次被替换后，不再改动新批次的进度条
          if (batch && self._designBatch !== batch) return;
          if (p > (self._gen2dRealP || 0)) self._gen2dRealP = p;
          self.setDesignRound(round, total, p,
            status === 'queued' ? t('gen.status_queued') : t('gen.status_drawing'));
        }
      });
    }).then(function (r) {
      // 只清理本轮自己的任务号（期间可能已开始新的批次）
      if (self.state.designPending === taskId) delete self.state.designPending;
      if (!batch || self._designBatch === batch) {
        self.saveState();
        self.stopGen2dPulse();
      }
      return { taskId: r.task_id, key: r.r2_key, url: r.r2_url, sessionId: self.state.session, photoKey: photoKey };
    }).catch(function (err) {
      if (!batch || self._designBatch === batch) self.stopGen2dPulse();
      throw err;
    });
  };

  Customizer.prototype.addDesignResult = function (result) {
    if (!result || !result.taskId) return;
    var list = this.state.designResults || [];
    var exists = list.some(function (x) { return x && String(x.taskId) === String(result.taskId); });
    if (!exists) list.push(result);
    if (list.length > 12) list = list.slice(list.length - 12);
    this.state.designResults = list;
    // 第一张自动作为当前设计稿；之后由用户点选
    if (!this.state.img2d) {
      this.state.img2d = { taskId: result.taskId, key: result.key, url: result.url };
      this.selected2d = {
        task_id: result.taskId, key: result.key, view_url: result.url,
        session_id: result.sessionId || this.state.session
      };
    }
    this.saveState();
    this.renderPageUpload();
    this.renderDesignModal();
    this.renderCustomStatus();
  };

  Customizer.prototype.finishDesignBatch = function () {
    var b = this._designBatch;
    if (!b) return;
    b.running = false;
    this.state.designBatch = { total: b.total, completed: b.completed, running: false };
    this.saveState();
    this.clearGenRun();          // 停脉冲并清 _genRun：卡片内页面级进度条随之消失
    this.renderDesignModal();
    this.renderPageRecent();
    this.loadHistory();          // 刷新 Recent History 条数、卡片下最近历史与签名链接
    this.showNotice(t('design.done', { n: b.completed }), 4000);
    // 生成完成后不再自动关闭弹窗，方便顾客直接查看/选用结果
  };

  Customizer.prototype.failDesignBatch = function (err) {
    var self = this;
    var b = this._designBatch;
    if (b) b.running = false;
    // 服务端明确失败/余额不足：清掉任务号；超时/断网保留，重试时先取回再决定是否重发
    if (err && !(err.timedOut || err.network)) delete this.state.designPending;
    this.state.designBatch = b ? { total: b.total, completed: b.completed, running: false } : null;
    this.saveState();
    this.clearGenRun();          // 失败同样收起卡片内页面级进度
    this.renderDesignModal();
    this.renderPageRecent();
    if (!this.els.gen2dError) return;
    var msg = (err && err.message) || t('err.gen_failed');
    // 弹窗可能已被关掉：再用右上角浮层提示一次，避免失败无声无息
    this.showNotice(msg, 7000);
    this.showRetryError(this.els.gen2dError, msg, function () { self.retryDesignBatch(); },
      err && err.status === 402 ? null : t('msg.refunded'));
  };

  /* 重试：先确认上一次已提交的任务是否已完成（避免重复扣费），再从失败轮继续 */
  Customizer.prototype.retryDesignBatch = function () {
    var self = this;
    var b = this._designBatch;
    if (!b || b.running) return;
    var total = b.total || this.designQuantity();
    var done = b.completed || 0;
    var prompt = b.prompt || this.collectDesignPrompt();

    var resume = function () {
      b.running = true;
      b.total = total;
      b.prompt = prompt;
      b.completed = done;
      self.state.designBatch = { total: total, completed: done, running: true };
      self.saveState();
      if (self.els.gen2dError) self.els.gen2dError.hidden = true;
      self.renderDesignModal();
      self.renderPageRecent();
      self.ensureDesignBoxSession()
        .then(function () { return self.runDesignQueue(prompt, total, done); })
        .then(function () {
          if (self._designBatch === b) self.finishDesignBatch();
        })
        .catch(function (err) {
          if (self._designBatch === b) self.failDesignBatch(err);
        });
    };

    var pending = this.state.designPending;
    if (!pending) { resume(); return; }
    this.setDesignRound(done + 1, total, 4, t('gen.status_reconnecting'));
    this.pollTask(pending, 'apimart', {
      interval: POLL_2D_MS, timeout: TIMEOUT_2D_MS,
      onTick: function (p) { self.setDesignRound(done + 1, total, p, t('gen.status_drawing')); }
    }).then(function (r) {
      done++;
      b.completed = done;
      delete self.state.designPending;
      self.addDesignResult({ taskId: r.task_id, key: r.r2_key, url: r.r2_url, sessionId: self.state.session });
      resume();
    }).catch(function (err) {
      if (!(err && (err.timedOut || err.network))) delete self.state.designPending;
      self.failDesignBatch(err);
    });
  };


  Customizer.prototype.designBoxReady = function () {
    if (this.styleIdx < 0) return true;
    return !!(this.state.style && (this.findVariant(this.sel) || this.firstAvailableVariantForStyle(this.state.style)));
  };

  /* AI 框所在的标准加购表单 */
  Customizer.prototype.designBoxForm = function () {
    return this.root.querySelector('form[action*="/cart/add"]') || this.root.querySelector('form');
  };

  /* 把会话/照片/效果图写回表单隐藏属性（design-box 的加购带稿链路） */
  Customizer.prototype.syncFormProperties = function () {
    if (!this.designBox) return;
    var form = this.designBoxForm();
    if (!form) return;
    var workerBase = (this.api && this.api.base) || '';
    var photoKeys = this.photos().map(function (p) { return p ? p.key : ''; }).filter(Boolean).join(',');
    var img2d = this.state.img2d;
    var set = function (selector, value) {
      var input = form.querySelector(selector);
      if (input) input.value = value || '';
    };
    set('[data-prop-session]', this.state.session);
    set('[data-prop-photo-key]', photoKeys);
    set('[data-prop-2d-key]', img2d ? img2d.key : '');
    set('[data-prop-img-url]', (img2d && img2d.key && workerBase) ? workerBase + '/f/' + img2d.key : '');
    set('[data-prop-style]', this.styleIdx >= 0 ? this.state.style : '');
  };

  /* 标准表单拦截：未生成效果图先不加购；放行前同步属性（capture，先于主题提交逻辑） */
  Customizer.prototype.initDesignBoxForm = function () {
    var self = this;
    var form = this.designBoxForm();
    if (!form) return;
    form.addEventListener('submit', function (e) {
      self.syncDesignBoxSelection();
      self.syncFormProperties();
      if (!self.has2d()) {
        e.preventDefault();
        e.stopPropagation();
        self.showDesignBoxNotice();
      }
    }, true);
  };

  /* 未生成效果图点 Add to cart：提示先生成，并滚动到 AI 框 */
  Customizer.prototype.showDesignBoxNotice = function () {
    var msg = t('err.gen_first');
    // gen2dError 在弹窗内：弹窗关着时改为上传框错误位 + toast 提示，避免提示不可见
    if (this.els.gen2dError) this.showError(this.els.gen2dError, msg);
    if (this.els.pageUploadError) this.showError(this.els.pageUploadError, msg);
    this.showNotice(msg, 7000);
    if (this.els.customCard) this.els.customCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (this.validPhotos().length) this.openDesignModal();
  };

  /* ---------- rehydrate after page reload ---------- */
  Customizer.prototype.rehydrate = function () {
    var self = this;
    var s = this.state;

    // 照片缩略图恢复；签名链接 30 分钟过期，缺 url 的逐张重新签名
    var photos = this.photos();
    this.syncPrimaryPhoto();
    this.renderPhotos();
    photos.forEach(function (p, i) {
      if (p && p.key && !p.url) {
        // 旧会话遗留的照片（R2 key 在旧会话目录下）无法用新会话重新签名，失败静默跳过
        self.api.sign(p.key, self.state.session).then(function (d) {
          p.url = d.view_url;
          self.syncPrimaryPhoto();
          self.saveState();
          self.renderPhotos();
        }).catch(function () {});
      }
    });

    // 签名链接 30 分钟过期，恢复时统一刷新
    if (s.img2d && s.img2d.taskId) {
      this.api.task(s.img2d.taskId, 'apimart').then(function (r) {
        if (r.status === 'completed') {
          s.img2d.key = r.r2_key; s.img2d.url = r.r2_url;
          self.els.gen2dResult.src = r.r2_url;
          // 缩略图按已恢复的上传照片渲染；极端情况下无照片时退回生成图，避免空白
          self.renderGen2dThumb();
          if (self.els.gen2dSource && !self.els.gen2dSource.getAttribute('src')) {
            self.els.gen2dSource.src = r.r2_url;
          }
          self.setGenView('2d', 'done');
          self.els.goto3.disabled = false;
          self.saveState();
        }
      }).catch(function () {});
    }
    if (s.model3d && s.model3d.taskId) {
      this.api.task(s.model3d.taskId, 'tripo').then(function (r) {
        if (r.status === 'completed') {
          s.model3d.key = r.r2_key; s.model3d.url = r.r2_url;
          // 第 3 步被主题关闭时页面上没有 model-viewer，跳过 DOM 更新
          if (self.els.gen3dViewer) self.els.gen3dViewer.src = r.r2_url;
          self.setGenView('3d', 'done');
          self.els.goto4.disabled = false;
          self.saveState();
        }
      }).catch(function () {});
    }
  };

  /* ---------- view helpers ---------- */
  Customizer.prototype.setGenView = function (kind, view) {
    var p = kind === '2d'
      ? { idle: this.els.gen2dIdle, running: this.els.gen2dRunning, done: this.els.gen2dDone }
      : { idle: this.els.gen3dIdle, running: this.els.gen3dRunning, done: this.els.gen3dDone };
    ['idle', 'running', 'done'].forEach(function (k) { if (p[k]) p[k].hidden = k !== view; });
    if (kind === '2d') {
      if (view === 'running') {
        this.startGen2dCarousel();
        // Check status 由 100s 计时器（startGen2dWatchdog）控制显隐，这里只同步当前状态，
        // 避免切步骤回来时把已经该显示的按钮又藏起来
        this.syncGen2dRefreshBtn();
      } else {
        this.stopGen2dCarousel();
      }
    }
  };

  /* Check status 按钮显隐：只有在「本次生成已开始且超过 100 秒」时才显示。
     用硬性时间判断（而不是只信 _gen2dTimedOut 标记）：上一轮超时的标记可能残留在内存里，
     重新生图时会先闪出按钮；这里双重校验，保证任何情况下都不会早于 100 秒出现。 */
  Customizer.prototype.syncGen2dRefreshBtn = function () {
    var btn = this.els.gen2dRefresh;
    if (!btn) return;
    var start = Number(this._gen2dStartedAt || 0);
    var over = !!(this._gen2dTimedOut && start && (Date.now() - start >= GEN2D_STATUS_BTN_DELAY));
    btn.hidden = !over;
  };

  /* 线性图标（删除垃圾桶 / 确认勾 / 取消叉），统一用 currentColor，颜色由 CSS 控制 */
  Customizer.prototype.trashIcon = function () {
    return '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>';
  };
  Customizer.prototype.checkIcon = function () {
    return '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5"/></svg>';
  };
  Customizer.prototype.closeIcon = function () {
    return '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  };

  /* 用户照片的「展示用缩略图」地址：
     1) 上传接口/会话恢复已带 thumb_url（公开 /f/.thumb.jpg，480 宽小图）→ 直接用；
     2) 只有 R2 key（老数据/本地存档）→ 由 key 推导公开缩略图地址；
     3) 非用户上传图 → 用 p.url。
     注意：第 3 步不再直接回退签名链接（30 分钟过期后是空白图），
     用户上传图统一走 /f/ 永久公开地址（见 photoFileUrl），签名链接只在二者都失效时兜底。
     生图参考图提交的是 key（原图），与此展示地址完全无关。 */
  Customizer.prototype.photoThumbUrl = function (p) {
    if (!p) return '';
    if (p.thumbUrl) return p.thumbUrl;
    var key = p.key || '';
    if (key && USER_UPLOAD_KEY_RE.test(key) && this.api && this.api.base) {
      return this.api.base + '/f/' + key.replace(/\.(png|jpe?g|webp|gif)$/i, '.thumb.jpg');
    }
    return p.url || '';
  };

  /* 用户照片的永久可读原图地址：Worker /f/{key}（key 含 UUID 不可猜，长期有效）。
     签名链接会过期，这里作为缩略图缺失/失败时的首选回退，避免「上传成功但看不到图」。 */
  Customizer.prototype.photoFileUrl = function (p) {
    if (!p) return '';
    var key = p.key || '';
    if (key && USER_UPLOAD_KEY_RE.test(key) && this.api && this.api.base) {
      return this.api.base + '/f/' + key;
    }
    return p.url || '';
  };

  /* 给展示照片的 <img> 绑定「逐级回退」：
     缩略图失败 → /f/ 永久原图 → 向 Worker 重新签名（签名链接过期/旧会话照片），
     任何一级成功即停止，全部失败才保持空白。 */
  Customizer.prototype.bindPhotoFallback = function (img, p) {
    var self = this;
    if (!img || !p) return;
    img.addEventListener('error', function () {
      var step = Number(img.getAttribute('data-fallback') || '0');
      if (step === 0) {
        var permanent = self.photoFileUrl(p);
        if (permanent && img.src !== permanent) {
          img.setAttribute('data-fallback', '1');
          img.src = permanent;
          return;
        }
      }
      if (step <= 1) {
        var key = p.key || '';
        if (!key || !self.state.session) return;
        img.setAttribute('data-fallback', '2');
        self.api.sign(key, self.state.session).then(function (d) {
          if (!d || !d.view_url) return;
          p.url = d.view_url;
          self.saveState();
          img.src = d.view_url;
        }).catch(function () { /* 都失败：保持空白，不再重试 */ });
      }
    });
  };

  /* 由 R2 图片地址推导缩略图（.thumb.jpg，480 宽小图，渲染快）：
     兼容签名视图地址（?key=）与公开 /f/ 地址；2D 生成图与用户上传原图都有缩略图，
     风格预览图（Shopify CDN）不处理。非 R2 地址返回空串。 */
  Customizer.prototype.r2ThumbOf = function (u) {
    if (!u || typeof u !== 'string') return '';
    var base = (this.api && this.api.base) || '';
    if (!base) return '';
    var key = '';
    var m = u.match(/[?&]key=([^&]+)/);
    if (m) {
      try { key = decodeURIComponent(m[1]); } catch (e) { key = m[1]; }
    } else if (u.indexOf(base + '/f/') === 0) {
      key = u.slice(base.length + 3);
    }
    if (!/^[A-Z0-9]{2}\/(ai-2d-img|user-upload)\/.+\.(png|jpe?g|webp|gif)$/i.test(key)) return '';
    return base + '/f/' + key.replace(/\.(png|jpe?g|webp|gif)$/i, '.thumb.jpg');
  };

  /* 2D 生成动画的候选图片地址（按优先级）：
     缩略图 → 由 key 推导的缩略图 → /f/ 永久原图 → 签名原图。
     必须带 /f/ 永久原图：签名链接会过期、缩略图也可能没生成，
     否则生成中动画的图片会整体隐藏（用户看到「进度图片没了」）。 */
  Customizer.prototype.photoUrlPool = function (p) {
    var urls = [];
    var push = function (u) { if (u && typeof u === 'string' && urls.indexOf(u) === -1) urls.push(u); };
    if (!p) return urls;
    if (p.thumbUrl) push(p.thumbUrl);
    var key = p.key || '';
    var base = (this.api && this.api.base) || '';
    if (key && USER_UPLOAD_KEY_RE.test(key) && base) {
      push(base + '/f/' + key.replace(/\.(png|jpe?g|webp|gif)$/i, '.thumb.jpg'));
      push(base + '/f/' + key);
    }
    var t = this.r2ThumbOf(p.url);
    if (t && t !== p.thumbUrl) push(t);
    push(p.url);
    return urls;
  };

  /* 2D 生成动画的图片池：只允许「用户上传的照片 / 产品主图」两类，
     绝不带页面其它图片（风格预览、随机 img 等）。
     有用户照片时池里只有该照片（卡片显示用户自己的图）；
     没有任何照片时才用产品主图兜底，保证卡片不空 */
  Customizer.prototype.carouselCardPool = function (photo) {
    var urls = photo ? this.photoUrlPool(photo) : [];
    if (urls.length) return urls;
    var el = document.querySelector('.product-single__photos img.product-single__photo')
      || document.querySelector('.product-single__photos img[src], .product-single__photos img[data-src]');
    var main = el ? (el.currentSrc || el.getAttribute('data-src') || el.src || '') : '';
    if (main) urls.push(main);
    return urls;
  };

  /* 按图片池当前下标取图：预加载成功才显示，失败自动跳下一张，全部失败才隐藏卡片（不留破图） */
  Customizer.prototype.setCarouselImg = function (card, img, st) {
    if (!card || !img || !st || !st.pool || !st.pool.length) { if (card) card.hidden = true; return; }
    var n = st.pool.length, tries = 0;
    var step = function () {
      if (tries >= n) { card.hidden = true; return; }
      var url = st.pool[st.idx % n];
      st.idx += 1; tries += 1;
      var probe = new Image();
      probe.onload = function () {
        img.onerror = function () { card.hidden = true; };   // 预加载成功后仍加载失败的极端情况兜底
        img.src = url;
        card.hidden = false;
      };
      probe.onerror = step;
      probe.src = url;
    };
    step();
  };

  Customizer.prototype.startGen2dCarousel = function () {
    var self = this;
    var box = this.els.gen2dCarousel;
    if (!box) return;
    var orig = $(box, '[data-gen2d-carousel-original]');
    var gen = $(box, '[data-gen2d-carousel-generated]');
    var left = $(box, '.ai3d-gen__card--left');
    var right = $(box, '.ai3d-gen__card--right');

    // 构建图片池失败也不能让轮播逻辑中断（异常会一路抛进 runGen2D 的 try/catch 被吞掉）
    var poolOf = function (photo) {
      try { return self.carouselCardPool(photo); } catch (e) { return []; }
    };
    var photos = (self.validPhotos() || []).filter(Boolean);
    // 卡片数由 Figure 决定（与上传限制同源 maxPhotos）：
    // Solo/Pet → 1 张（左卡=用户上传图）；Duo/Person+Pet → 2 张（左=第1张、右=第2张）
    var two = self.maxPhotos() >= 2;
    this._gen2dSlides = { left: { pool: poolOf(photos[0]), idx: 0 } };
    if (two) this._gen2dSlides.right = { pool: poolOf(photos[1]), idx: 0 };
    this.stopGen2dCarousel();
    if (box) box.classList.toggle('is-single', !two);
    // 卡片立即露出（带主题色底与入场动画），与下方进度条同时出现；
    // 图片预加载完成后由 setCarouselImg 填入，全部候选失败才隐藏单卡（不留破图）
    if (left) left.hidden = false;
    if (right) right.hidden = !two;
    try {
      this.setCarouselImg(left, orig, this._gen2dSlides.left);
      if (two) this.setCarouselImg(right, gen, this._gen2dSlides.right);
    } catch (e) { /* 单张图失败不影响另一张与轮播 */ }

    // 入场动画类播完后由 CSS 无限摆动接力；之后每 2.6s 切换池内下一张图
    if (left) left.classList.add('animate-slide-in-left');
    if (two && right) right.classList.add('animate-slide-in-right');
    this._gen2dCarouselTimer = setInterval(function () {
      if (!self._gen2dSlides || !box.isConnected) return;
      self.setCarouselImg(left, orig, self._gen2dSlides.left);
      if (two && self._gen2dSlides.right) self.setCarouselImg(right, gen, self._gen2dSlides.right);
    }, 2600);
  };

  Customizer.prototype.stopGen2dCarousel = function () {
    if (this._gen2dCarouselTimer) {
      clearInterval(this._gen2dCarouselTimer);
      this._gen2dCarouselTimer = null;
    }
  };

  Customizer.prototype.showError = function (el, msg) {
    if (!el) return;
    el.innerHTML = escapeHtml(msg);
    el.hidden = false;
  };

  Customizer.prototype.showRetryError = function (el, msg, retryFn, note, btnText) {
    if (!el) return;
    var html = escapeHtml(msg);
    if (note) html += '<br><span style="color:#6b7280">' + escapeHtml(note) + '</span>';
    html += '<br><button type="button" class="ai3d-retry">' + escapeHtml(btnText || t('btn.try_again')) + '</button>';
    el.innerHTML = html;
    el.hidden = false;
    var btn = $(el, '.ai3d-retry');
    if (btn) btn.addEventListener('click', function () { el.hidden = true; retryFn(); });
  };

  /* Figure 卡片的显示名：优先取卡片上的多语言显示名（applyFigureLabels 已按语种写入），
     取不到回退变体值本身 */
  Customizer.prototype.figureLabel = function (value) {
    if (!value) return '';
    var btns = this.els.figureBtns || [];
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute('data-figure-value') !== value) continue;
      var card = btns[i].parentElement;
      while (card && !card.classList.contains('ai3d-figure-card')) card = card.parentElement;
      var nameEl = card && card.querySelector('.ai3d-figure-card__name');
      if (nameEl && nameEl.textContent.trim()) return nameEl.textContent.trim();
      break;
    }
    return value;
  };

  /* 轻量非阻塞提示（右下角浮层，自动消失）：用于告知「历史记录把页面选中项改了」这类
     非错误的状态变化，避免用 alert 打断用户 */
  Customizer.prototype.showNotice = function (msg, duration) {
    if (!msg || !document.body) return;
    var el = document.createElement('div');
    el.className = 'ai3d-notice';
    el.setAttribute('role', 'status');
    el.textContent = msg;
    document.body.appendChild(el);
    // 先挂载再切类，保证淡入过渡生效
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 300);
    }, duration || 3200);
  };

  /* 从历史记录恢复会话会把 Figure 锁回作品当初的变体（保证加购属性/照片槽位一致）。
     若与页面当前选中的 Figure 不同，明确告知，避免用户觉得「进一下弹窗 Figure 就变了」。
     beforeFigure 需在恢复前调用处捕获。 */
  Customizer.prototype.noticeFigureSwitch = function (beforeFigure) {
    var after = this.state && this.state.figure;
    if (!after || !beforeFigure || beforeFigure === after) return;
    this.showNotice(t('msg.figure_switched', {
      from: this.figureLabel(beforeFigure),
      to: this.figureLabel(after)
    }));
  };

  /* ---------------- bootstrap ---------------- */

  function initSection(sectionId) {
    // 根节点 id 必须与标准产品模板一致（section-<id>）：主题图库（theme.Product）
    // 移动端用「#section-<id> .product-single__photos / __thumbnails」做 asNavFor 联动，
    // 自定义前缀会导致缩略图点击不切主图、主图滑动不同步缩略图
    var root = document.getElementById('section-' + sectionId);
    var jsonEl = document.getElementById('AI3DProductJson--' + sectionId)
      || document.getElementById('ProductJson-' + sectionId);
    if (!root || !jsonEl || root.dataset.ai3dInit) return;
    root.dataset.ai3dInit = '1';

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var preset = (window.AI3D_PRESETS && window.AI3D_PRESETS[sectionId]) || {};

    new Customizer(sectionId, root, preset, product);
  }

  /* 扫描页面上所有定制器 section（幂等）。主题编辑器会整体重渲染 section，
     旧实例随旧 DOM 脱离文档由 watchRemoval 自毁，新 DOM 靠这里补初始化 */
  function scanAllSections() {
    // 根 id 已对齐标准模板（section-<id>），这里按 class 扫描并取 data-section-id，
    // 避免 id 前缀误匹配其它 section（如 recommendations）
    $all(document, '.ai3d-section[data-section-id]').forEach(function (root) {
      initSection(root.getAttribute('data-section-id'));
    });
  }

  /* 引导层只挂一次（编辑器重渲染可能重复执行外链脚本，window 标志去重） */
  if (!window.__ai3dBootstrapped) {
    window.__ai3dBootstrapped = true;

    document.addEventListener('ai3d:section-ready', scanAllSections);
    document.addEventListener('shopify:section:load', scanAllSections);
    /* unload 时旧 section 即将移除，无需扫描；旧实例由 watchRemoval 的 MutationObserver 自毁 */

    var scanQueued = false;
    function queueScan() {
      if (scanQueued) return;
      scanQueued = true;
      var run = function () { scanQueued = false; scanAllSections(); };
      if (window.requestAnimationFrame) requestAnimationFrame(run);
      else setTimeout(run, 30);
    }
    function startObserver() {
      if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
      } else {
        setInterval(scanAllSections, 1500);
      }
      scanAllSections();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserver);
    } else {
      startObserver();
    }
    // 兜底：编辑器脚本注入时序异常时，前 10 秒周期性补扫
    var bootTries = 0;
    var bootTimer = setInterval(function () {
      scanAllSections();
      if (++bootTries >= 20) clearInterval(bootTimer);
    }, 500);
  }

})();
